/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Answer: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  File: { input: File; output: File; }
  JSON: { input: any; output: any; }
  PhoneNumber: { input: string | null; output: string | null; }
  Upload: { input: File; output: File; }
};

/** External case for an AU policy's underwriting process */
export type AcceleratedUnderwritingCase = {
  __typename?: 'AcceleratedUnderwritingCase';
  case_id: Maybe<Scalars['String']['output']>;
  client_decision: Maybe<Scalars['String']['output']>;
  completed: Maybe<Scalars['String']['output']>;
  decision: Maybe<Scalars['String']['output']>;
  direct_transfer_link: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  interview: Maybe<AcceleratedUnderwritingCaseInterview>;
  interview_url: Maybe<Scalars['String']['output']>;
  /** @deprecated GraphQL contract tests are frustrating */
  life_application_id: Maybe<Scalars['ID']['output']>;
  pi_decision_status: Maybe<Scalars['String']['output']>;
  policy_id: Maybe<Scalars['String']['output']>;
  rate_class_applied_for: Maybe<Scalars['String']['output']>;
  rate_class_approved_for: Maybe<Scalars['String']['output']>;
  submitted: Maybe<Scalars['Boolean']['output']>;
  underwriting_outcomes: Maybe<Array<Maybe<UnderwritingOutcome>>>;
  underwriting_status: Maybe<Scalars['String']['output']>;
};


/** External case for an AU policy's underwriting process */
export type AcceleratedUnderwritingCaseInterviewArgs = {
  life_application_id: Scalars['ID']['input'];
};

/** External case interview for an AU policy's underwriting process */
export type AcceleratedUnderwritingCaseInterview = {
  __typename?: 'AcceleratedUnderwritingCaseInterview';
  submitted: Maybe<Scalars['Boolean']['output']>;
};

/** Values of AU related forms */
export type AcceleratedUnderwritingForm = {
  __typename?: 'AcceleratedUnderwritingForm';
  brighthouse_application_details_replacement_read: Maybe<Scalars['String']['output']>;
  brighthouse_client_decision_offer_proceed: Maybe<Scalars['Boolean']['output']>;
  brighthouse_client_decision_signature_agree: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

export type AcceleratedUnderwritingFormsMutation = {
  __typename?: 'AcceleratedUnderwritingFormsMutation';
  brighthouse_forms_update: Maybe<AcceleratedUnderwritingForm>;
};


export type AcceleratedUnderwritingFormsMutationBrighthouse_Forms_UpdateArgs = {
  input: AcceleratedUnderwritingFormsUpdateMutationInput;
};

/** Autogenerated input type of AcceleratedUnderwritingFormsUpdateMutation */
export type AcceleratedUnderwritingFormsUpdateMutationInput = {
  brighthouse_application_details_replacement_read?: InputMaybe<Scalars['String']['input']>;
  brighthouse_client_decision_offer_proceed?: InputMaybe<Scalars['Boolean']['input']>;
  brighthouse_client_decision_signature_agree?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
};

export type AcceleratedUnderwritingMutation = {
  __typename?: 'AcceleratedUnderwritingMutation';
  case_create: Maybe<AcceleratedUnderwritingCase>;
  case_interview_submit: Maybe<AcceleratedUnderwritingCase>;
  case_reject: Maybe<AcceleratedUnderwritingCase>;
  case_submit: Maybe<AcceleratedUnderwritingCase>;
};


export type AcceleratedUnderwritingMutationCase_CreateArgs = {
  input: CaseCreateInput;
};


export type AcceleratedUnderwritingMutationCase_Interview_SubmitArgs = {
  input: CaseInterviewSubmitInput;
};


export type AcceleratedUnderwritingMutationCase_RejectArgs = {
  input: CaseRejectInput;
};


export type AcceleratedUnderwritingMutationCase_SubmitArgs = {
  input: CaseSubmitInput;
};

export type AccessControlMutation = {
  __typename?: 'AccessControlMutation';
  record_customer_access: Maybe<Scalars['Boolean']['output']>;
};


export type AccessControlMutationRecord_Customer_AccessArgs = {
  input: RecordCustomerAccessInput;
};

/** Metadata about a customer's account */
export type AccountMetadata = {
  __typename?: 'AccountMetadata';
  accountHolder: Scalars['Boolean']['output'];
  /** @deprecated Use accountHolder instead */
  account_holder: Scalars['Boolean']['output'];
  doNotCall: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use doNotCall instead */
  do_not_call: Maybe<Scalars['Boolean']['output']>;
  emailStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use emailStatus instead */
  email_status: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subscribedToNewsletter: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use subscribedToNewsletter instead */
  subscribed_to_newsletter: Maybe<Scalars['Boolean']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  uniqueAccount: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use uniqueAccount instead */
  unique_account: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AccountsMergeMutation */
export type AccountsMergeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  keep_primary_customer_account?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_account_id?: InputMaybe<Scalars['String']['input']>;
  source_path?: InputMaybe<Scalars['String']['input']>;
};

export type AddAdhdProfile = {
  __typename?: 'AddAdhdProfile';
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  historyOfAddAdhd: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  medicationCount: Maybe<Scalars['Int']['output']>;
  medicationDetails: Maybe<Scalars['String']['output']>;
  takingMedication: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AddAdhdProfileUpdateMutation */
export type AddAdhdProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  history_of_add_adhd?: InputMaybe<Scalars['Boolean']['input']>;
  medication_count?: InputMaybe<Scalars['Int']['input']>;
  medication_details?: InputMaybe<Scalars['String']['input']>;
  taking_medication?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of AddTag */
export type AddTagInput = {
  /** The id of the internal case to add the tag to. */
  caseReferenceId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the tag to add to the internal case. */
  tag: Scalars['String']['input'];
};

/** Autogenerated return type of AddTag */
export type AddTagPayload = {
  __typename?: 'AddTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The tag that has been added. */
  tagName: Scalars['String']['output'];
};

/** Carrier-specific questions */
export type AdditionalQuestions = {
  __typename?: 'AdditionalQuestions';
  admitted_to_hospital_last_90: Maybe<Question>;
  engage_in_regular_exercise: Maybe<Question>;
  heart_trouble_stroke_cancer_past_2_years: Maybe<Question>;
};

/** Autogenerated input type of AdditionalQuestionsUpdateMutation */
export type AdditionalQuestionsUpdateMutationInput = {
  admitted_to_hospital_last_90?: InputMaybe<Scalars['Boolean']['input']>;
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engage_in_regular_exercise?: InputMaybe<Scalars['Boolean']['input']>;
  heart_trouble_stroke_cancer_past_2_years?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2: Scalars['String']['output'];
  yearsAtCurrentAddress: Maybe<Scalars['Int']['output']>;
  zipCode: Scalars['String']['output'];
};

export type AddressType = {
  __typename?: 'AddressType';
  address_type: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  state: Maybe<State>;
  street_1: Maybe<Scalars['String']['output']>;
  street_2: Maybe<Scalars['String']['output']>;
  zip_code: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddressUpdateMutation */
export type AddressUpdateMutationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  state_code?: InputMaybe<Scalars['String']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  street_2?: InputMaybe<Scalars['String']['input']>;
  years_at_current_address?: InputMaybe<Scalars['Int']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AgentStateLicenseUpdateMutation */
export type AgentStateLicenseUpdateMutationInput = {
  agent_state_license_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AgentType = {
  __typename?: 'AgentType';
  /** Agent's first name */
  firstName: Maybe<Scalars['String']['output']>;
  /** The (User)ID of the agent */
  id: Scalars['ID']['output'];
  /** Agent's last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Array of CarrierLicenses associated with the Agent */
  licenses: Maybe<Array<CarrierLicenseType>>;
};

/** Autogenerated input type of Analytics */
export type AnalyticsInput = {
  action: Scalars['String']['input'];
  action_arguments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AnalyticsTrack */
export type AnalyticsTrackInput = {
  action: Scalars['String']['input'];
  action_arguments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AnxietyProfile = {
  __typename?: 'AnxietyProfile';
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  historyOfAnxiety: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfAnxiety instead */
  history_of_anxiety: Maybe<Scalars['Boolean']['output']>;
  hospitalized: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  internalDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use internalDetails instead */
  internal_details: Maybe<Scalars['String']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  medicationsCount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use medicationsCount instead */
  medications_count: Maybe<Scalars['Int']['output']>;
  mostRecentEpisode: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use mostRecentEpisode instead */
  most_recent_episode: Maybe<Scalars['DateTime']['output']>;
  otherDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherDetails instead */
  other_details: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  takingMedication: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use takingMedication instead */
  taking_medication: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AnxietyProfileUpdateMutation */
export type AnxietyProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  history_of_anxiety?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  internal_details?: InputMaybe<Scalars['String']['input']>;
  medications_count?: InputMaybe<Scalars['Int']['input']>;
  most_recent_episode?: InputMaybe<Scalars['DateTime']['input']>;
  other_details?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  taking_medication?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ApplicationCreateMutation */
export type ApplicationCreateMutationInput = {
  application_type?: InputMaybe<Scalars['String']['input']>;
  changed_over_internal_case_id?: InputMaybe<Scalars['ID']['input']>;
  changeover?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  pnc_shopper_reason?: InputMaybe<Scalars['String']['input']>;
  product_type: Scalars['String']['input'];
  referring_agent_email?: InputMaybe<Scalars['String']['input']>;
  referring_organization?: InputMaybe<Scalars['String']['input']>;
  shopping_reason?: InputMaybe<Scalars['String']['input']>;
  vertical_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AppliedForCoverage = {
  __typename?: 'AppliedForCoverage';
  annualPremium: Maybe<Scalars['Float']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  carrierSlug: Maybe<Scalars['String']['output']>;
  coverageAmount: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lifeApplicationId: Maybe<Scalars['ID']['output']>;
  monthlyPremium: Maybe<Scalars['Float']['output']>;
  policyName: Maybe<Scalars['String']['output']>;
  tableRating: Maybe<Scalars['Int']['output']>;
  termInYears: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ApproveApsExcessFee */
export type ApproveApsExcessFeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  third_party_order_number: Scalars['String']['input'];
};

/** Autogenerated input type of ApsExcessFeeApproveMutation */
export type ApsExcessFeeApproveMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  third_party_order_number: Scalars['String']['input'];
};

export type ApsInfoErrorType = {
  __typename?: 'ApsInfoErrorType';
  error: Maybe<Scalars['String']['output']>;
  order_number: Maybe<Scalars['String']['output']>;
};

export type ApsInfoResponseType = {
  __typename?: 'ApsInfoResponseType';
  aps_order_details: Maybe<Array<Maybe<ApsInfoType>>>;
  errors: Maybe<Array<Maybe<ApsInfoErrorType>>>;
  hipaa_form_created: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

export type ApsInfoType = {
  __typename?: 'ApsInfoType';
  completed_aps_url: Maybe<Scalars['String']['output']>;
  doctor_name: Maybe<Scalars['String']['output']>;
  event_type: Maybe<Scalars['String']['output']>;
  last_status_change_date: Maybe<Scalars['String']['output']>;
  order_number: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  status_updates: Maybe<Array<Maybe<StatusUpdateType>>>;
};

export type ApsMutation = {
  __typename?: 'ApsMutation';
  aps_excess_fee_approve: Maybe<ApsStateType>;
  aps_order_create: Maybe<ApsOrderResponse>;
};


export type ApsMutationAps_Excess_Fee_ApproveArgs = {
  input: ApsExcessFeeApproveMutationInput;
};


export type ApsMutationAps_Order_CreateArgs = {
  input: ApsOrderCreateMutationInput;
};

export type ApsOrder = {
  __typename?: 'ApsOrder';
  internal_order_uuid: Maybe<Scalars['String']['output']>;
  medical_provider: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  third_party_provider_order_number: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ApsOrderCreateMutation */
export type ApsOrderCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  medical_providers?: InputMaybe<Array<InputMaybe<MedicalProviderInput>>>;
  policy_reference_id: Scalars['ID']['input'];
};

export type ApsOrderErrorResponse = {
  __typename?: 'ApsOrderErrorResponse';
  medical_provider: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
};

export type ApsOrderResponse = {
  __typename?: 'ApsOrderResponse';
  errors: Maybe<Array<Maybe<ApsOrderErrorResponse>>>;
  orders: Maybe<Array<Maybe<ApsOrder>>>;
};

export enum ApsRequirement {
  /** APS is ordered by the carrier */
  ApsOrderedByCarrier = 'APS_ORDERED_BY_CARRIER',
  /** Carrier APS rules are not available */
  CarrierNotSupported = 'CARRIER_NOT_SUPPORTED',
  /** APS is potentially required, but not enough information available */
  MaybeRequired = 'MAYBE_REQUIRED',
  /** APS is not required */
  NotRequired = 'NOT_REQUIRED',
  /** APS is required */
  Required = 'REQUIRED'
}

export type ApsStateType = {
  __typename?: 'ApsStateType';
  id: Maybe<Scalars['ID']['output']>;
  pending_excess_fee_approval: Maybe<Scalars['Boolean']['output']>;
  third_party_order_number: Maybe<Scalars['String']['output']>;
};

export type AsthmaProfile = {
  __typename?: 'AsthmaProfile';
  currentlyTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use currentlyTreated instead */
  currently_treated: Maybe<Scalars['Boolean']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  episodesPerYear: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use episodesPerYear instead */
  episodes_per_year: Maybe<Scalars['Int']['output']>;
  everTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everTreated instead */
  ever_treated: Maybe<Scalars['Boolean']['output']>;
  historyOfAsthma: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfAsthma instead */
  history_of_asthma: Maybe<Scalars['Boolean']['output']>;
  hospitalized: Maybe<Scalars['Boolean']['output']>;
  hospitalizedCountLastYear: Maybe<Scalars['Int']['output']>;
  hospitalizedCountTotal: Maybe<Scalars['Int']['output']>;
  hospitalizedMostRecentDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use hospitalizedCountLastYear instead */
  hospitalized_count_last_year: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hospitalizedCountTotal instead */
  hospitalized_count_total: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hospitalizedMostRecentDate instead */
  hospitalized_most_recent_date: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inhaledBronchodilators: Maybe<Scalars['Boolean']['output']>;
  inhaledCorticosteroids: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use inhaledBronchodilators instead */
  inhaled_bronchodilators: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use inhaledCorticosteroids instead */
  inhaled_corticosteroids: Maybe<Scalars['Boolean']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  oralMedicationNoSteroids: Maybe<Scalars['Boolean']['output']>;
  oralMedicationWithSteroids: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use oralMedicationNoSteroids instead */
  oral_medication_no_steroids: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use oralMedicationWithSteroids instead */
  oral_medication_with_steroids: Maybe<Scalars['Boolean']['output']>;
  rescueInhaler: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use rescueInhaler instead */
  rescue_inhaler: Maybe<Scalars['Boolean']['output']>;
  severity: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AsthmaProfileUpdateMutation */
export type AsthmaProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currently_treated?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  episodes_per_year?: InputMaybe<Scalars['Int']['input']>;
  ever_treated?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_asthma?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized_count_last_year?: InputMaybe<Scalars['Int']['input']>;
  hospitalized_count_total?: InputMaybe<Scalars['Int']['input']>;
  hospitalized_most_recent_date?: InputMaybe<Scalars['DateTime']['input']>;
  inhaled_bronchodilators?: InputMaybe<Scalars['Boolean']['input']>;
  inhaled_corticosteroids?: InputMaybe<Scalars['Boolean']['input']>;
  oral_medication_no_steroids?: InputMaybe<Scalars['Boolean']['input']>;
  oral_medication_with_steroids?: InputMaybe<Scalars['Boolean']['input']>;
  rescue_inhaler?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  head?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tempfile?: InputMaybe<Scalars['File']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentUpdate = {
  __typename?: 'AttachmentUpdate';
  shareable: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AttachmentUpdateMutation */
export type AttachmentUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  message_id: Scalars['ID']['input'];
  message_type?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  shareable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutogenDetails = {
  __typename?: 'AutogenDetails';
  autogenEligible: Maybe<Scalars['Boolean']['output']>;
  evaluationStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  knockoutReasons: Maybe<Array<Scalars['String']['output']>>;
  lastFormUpdateAt: Maybe<Scalars['DateTime']['output']>;
  outcome: Maybe<Scalars['String']['output']>;
  unconfirmedForms: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AvailabilityType = {
  __typename?: 'AvailabilityType';
  date: Maybe<Scalars['String']['output']>;
  examiner_id: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BankAccountUrlFetchMutation */
export type BankAccountUrlFetchMutationInput = {
  action: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
};

/** Autogenerated input type of BeneficiariesUpdateMutation */
export type BeneficiariesUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contingent_beneficiaries?: InputMaybe<Array<InputMaybe<BeneficiaryInput>>>;
  primary_beneficiaries?: InputMaybe<Array<InputMaybe<BeneficiaryInput>>>;
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  contingent: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfBirth instead */
  date_of_birth: Maybe<Scalars['DateTime']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fullName instead */
  full_name: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  irrevocable: Maybe<Scalars['Boolean']['output']>;
  justification: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['String']['output']>;
  persisted: Maybe<Scalars['Boolean']['output']>;
  relationship: Maybe<Scalars['String']['output']>;
};

export type BeneficiaryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  contingent?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  irrevocable?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['String']['input']>;
  persisted?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type BloodPressureProfile = {
  __typename?: 'BloodPressureProfile';
  controlledWithMedication: Maybe<Scalars['Boolean']['output']>;
  controlledWithMedicationSince: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use controlledWithMedication instead */
  controlled_with_medication: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use controlledWithMedicationSince instead */
  controlled_with_medication_since: Maybe<Scalars['DateTime']['output']>;
  diastolicPressure: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use diastolicPressure instead */
  diastolic_pressure: Maybe<Scalars['Int']['output']>;
  historyOfHighBloodPressure: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfHighBloodPressure instead */
  history_of_high_blood_pressure: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  lastTreatedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lastTreatedAt instead */
  last_treated_at: Maybe<Scalars['DateTime']['output']>;
  systolicPressure: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use systolicPressure instead */
  systolic_pressure: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of BloodPressureProfileUpdateMutation */
export type BloodPressureProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlled_with_medication?: InputMaybe<Scalars['Boolean']['input']>;
  controlled_with_medication_since?: InputMaybe<Scalars['DateTime']['input']>;
  customer_id: Scalars['ID']['input'];
  diastolic_pressure?: InputMaybe<Scalars['Int']['input']>;
  history_of_high_blood_pressure?: InputMaybe<Scalars['Boolean']['input']>;
  last_treated_at?: InputMaybe<Scalars['DateTime']['input']>;
  systolic_pressure?: InputMaybe<Scalars['Int']['input']>;
};

/** The customer's height, weight, etc */
export type BuildProfile = {
  __typename?: 'BuildProfile';
  heightFeet: Maybe<Scalars['Int']['output']>;
  heightInInches: Maybe<Scalars['Int']['output']>;
  heightInches: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use heightFeet instead */
  height_feet: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use heightInInches instead */
  height_in_inches: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use heightInches instead */
  height_inches: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Use isValid instead */
  is_valid: Scalars['Boolean']['output'];
  recentWeightChange: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use recentWeightChange instead */
  recent_weight_change: Maybe<Scalars['Boolean']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  weightChangeAmount: Maybe<Scalars['Int']['output']>;
  weightChangeDirection: Maybe<Scalars['String']['output']>;
  weightChangeNotes: Maybe<Scalars['String']['output']>;
  weightChangeReason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use weightChangeAmount instead */
  weight_change_amount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use weightChangeDirection instead */
  weight_change_direction: Maybe<Scalars['String']['output']>;
  /** @deprecated Use weightChangeNotes instead */
  weight_change_notes: Maybe<Scalars['String']['output']>;
  /** @deprecated Use weightChangeReason instead */
  weight_change_reason: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BuildProfileUpdateMutation */
export type BuildProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  height_feet?: InputMaybe<Scalars['Int']['input']>;
  height_in_inches?: InputMaybe<Scalars['Int']['input']>;
  height_inches?: InputMaybe<Scalars['Int']['input']>;
  recent_weight_change?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  weight_change_amount?: InputMaybe<Scalars['Int']['input']>;
  weight_change_direction?: InputMaybe<Scalars['String']['input']>;
  weight_change_notes?: InputMaybe<Scalars['String']['input']>;
  weight_change_reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of BulkAssignGroupCreateMutation */
export type BulkAssignGroupCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of BulkAssignGroupDeleteMutation */
export type BulkAssignGroupDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of CalculatePropensityScore */
export type CalculatePropensityScoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CalculatePropensityScore */
export type CalculatePropensityScorePayload = {
  __typename?: 'CalculatePropensityScorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  customer: Customer;
};

export type CancerProfile = {
  __typename?: 'CancerProfile';
  cancerType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cancerType instead */
  cancer_type: Maybe<Scalars['String']['output']>;
  details: Maybe<Scalars['String']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  historyOfCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfCancer instead */
  history_of_cancer: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use internalDetails instead */
  internal_details: Maybe<Scalars['String']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  lastTreatmentDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lastTreatmentDate instead */
  last_treatment_date: Maybe<Scalars['DateTime']['output']>;
  stage: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CancerProfileUpdateMutation */
export type CancerProfileUpdateMutationInput = {
  cancer_type?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  history_of_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  internal_details?: InputMaybe<Scalars['String']['input']>;
  last_treatment_date?: InputMaybe<Scalars['DateTime']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierIntegrationEvidencesEvidenceType = {
  __typename?: 'CarrierIntegrationEvidencesEvidenceType';
  carrier: Scalars['String']['output'];
  caseId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  externalEvidenceId: Scalars['String']['output'];
  question: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  submissionStatus: Scalars['String']['output'];
};

export type CarrierLicenseType = {
  __typename?: 'CarrierLicenseType';
  /** The Agent which the licensing code belongs to */
  agent: AgentType;
  /** The carrierSlug associated with the carrier licensing code */
  carrierSlug: Scalars['String']['output'];
  /** The licensing code */
  code: Scalars['String']['output'];
  /** The ID of the CarrierLicense entry */
  id: Scalars['ID']['output'];
};

export type CarrierPolicyReport = {
  __typename?: 'CarrierPolicyReport';
  annualized_premium: Maybe<Scalars['Float']['output']>;
  coverage_amount: Maybe<Scalars['Int']['output']>;
  cwa_amount: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  input_date: Maybe<Scalars['String']['output']>;
  issue_age: Maybe<Scalars['Int']['output']>;
  issue_state_code: Maybe<Scalars['String']['output']>;
  last_activity_date: Maybe<Scalars['String']['output']>;
  modal_premium: Maybe<Scalars['Float']['output']>;
  new_business_contact_name: Maybe<Scalars['String']['output']>;
  payment_mode: Maybe<Scalars['String']['output']>;
  plan_name: Maybe<Scalars['String']['output']>;
  policy_date: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  underwriter: Maybe<Scalars['String']['output']>;
};

export enum CarrierRequirementStatus {
  /** Acknowledged */
  Acknowledged = 'ACKNOWLEDGED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Manually marked as received */
  ManuallyMarkedAsReceived = 'MANUALLY_MARKED_AS_RECEIVED',
  /** Needed */
  Needed = 'NEEDED',
  /** Needed for placement */
  NeededForPlacement = 'NEEDED_FOR_PLACEMENT',
  /** Order */
  Order = 'ORDER',
  /** Ordered */
  Ordered = 'ORDERED',
  /** Outstanding */
  Outstanding = 'OUTSTANDING',
  /** Received */
  Received = 'RECEIVED',
  /** Reviewed */
  Reviewed = 'REVIEWED',
  /** Scan */
  Scan = 'SCAN',
  /** Waived */
  Waived = 'WAIVED'
}

/** Autogenerated input type of CarrierRequirementUpdateMutation */
export type CarrierRequirementUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  override_status?: InputMaybe<Scalars['String']['input']>;
  third_party_requirement_id: Scalars['String']['input'];
};

export type CarrierRequirementsType = {
  __typename?: 'CarrierRequirementsType';
  comments: Maybe<Array<Maybe<StatusUpdateType>>>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  received_at: Maybe<Scalars['String']['output']>;
  requested_at: Maybe<Scalars['String']['output']>;
  status: Maybe<CarrierRequirementStatus>;
  third_party_requirement_id: Maybe<Scalars['String']['output']>;
};

export type CarrierReview = {
  __typename?: 'CarrierReview';
  amBestRating: Scalars['String']['output'];
  bottomLine: Scalars['JSON']['output'];
  numberOfCustomers: Maybe<Scalars['String']['output']>;
  pgRating: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  yearEstablished: Maybe<Scalars['String']['output']>;
};

export type CaseAttributeChange = {
  __typename?: 'CaseAttributeChange';
  changed_from: Maybe<Scalars['String']['output']>;
  changed_to: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CaseCreate */
export type CaseCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
};

/** an occurrence with out the notion of a before and after state */
export type CaseEventFeedItem = {
  __typename?: 'CaseEventFeedItem';
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  event_description: Maybe<Scalars['String']['output']>;
  event_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of CaseInterviewSubmit */
export type CaseInterviewSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
};

/** Autogenerated input type of CaseReject */
export type CaseRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
  submission_type?: InputMaybe<Scalars['String']['input']>;
  underwriting_status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CaseSubmit */
export type CaseSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
};

export type CaseUpdateFeedItem = {
  __typename?: 'CaseUpdateFeedItem';
  attribute_changes: Maybe<Array<Maybe<CaseAttributeChange>>>;
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  star: Maybe<Star>;
  updated_by: Maybe<ElevatedUser>;
};

/** Internal case application */
export type CasesApplicationType = DisabilityApplication | HomeAndAutoApplication | LifeApplication;

export type CasesFilter = {
  __typename?: 'CasesFilter';
  list: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  totalCount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use totalCount instead */
  total_count: Maybe<Scalars['Int']['output']>;
};

export type Changeset = {
  __typename?: 'Changeset';
  after: Maybe<Scalars['String']['output']>;
  before: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fieldName instead */
  field_name: Maybe<Scalars['String']['output']>;
};

export type ChatFeedItem = {
  __typename?: 'ChatFeedItem';
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  source: Maybe<Scalars['String']['output']>;
  star: Maybe<Star>;
};

export type CholesterolProfile = {
  __typename?: 'CholesterolProfile';
  cholesterolControlledWithMedication: Maybe<Scalars['Boolean']['output']>;
  cholesterolControlledWithMedicationSince: Maybe<Scalars['DateTime']['output']>;
  cholesterolLastTreatedAt: Maybe<Scalars['DateTime']['output']>;
  cholesterolLevel: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cholesterolControlledWithMedication instead */
  cholesterol_controlled_with_medication: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use cholesterolControlledWithMedicationSince instead */
  cholesterol_controlled_with_medication_since: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use cholesterolLastTreatedAt instead */
  cholesterol_last_treated_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use cholesterolLevel instead */
  cholesterol_level: Maybe<Scalars['Int']['output']>;
  hdlRatio: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use hdlRatio instead */
  hdl_ratio: Maybe<Scalars['Float']['output']>;
  historyOfHighCholesterol: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfHighCholesterol instead */
  history_of_high_cholesterol: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CholesterolProfileUpdateMutation */
export type CholesterolProfileUpdateMutationInput = {
  cholesterol_controlled_with_medication?: InputMaybe<Scalars['Boolean']['input']>;
  cholesterol_controlled_with_medication_since?: InputMaybe<Scalars['DateTime']['input']>;
  cholesterol_last_treated_at?: InputMaybe<Scalars['DateTime']['input']>;
  cholesterol_level?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  hdl_ratio?: InputMaybe<Scalars['Float']['input']>;
  history_of_high_cholesterol?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The proposed insured */
export type Client = ContactInfoConfirmation & PersonalInfoConfirmation & {
  __typename?: 'Client';
  account_holder: Maybe<Scalars['Boolean']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  analytics_email: Maybe<Scalars['String']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed_by: Maybe<Scalars['String']['output']>;
  criminal_charge_profile: Maybe<CriminalChargeProfile>;
  date_of_birth: Maybe<Scalars['DateTime']['output']>;
  driver_license_expiration_date: Maybe<Scalars['DateTime']['output']>;
  driver_license_number: Maybe<Scalars['String']['output']>;
  driver_license_state_of_issue_code: Maybe<Scalars['String']['output']>;
  driver_license_state_of_issue_id: Maybe<Scalars['Int']['output']>;
  driver_license_state_of_issue_name: Maybe<Scalars['String']['output']>;
  driver_profile: Maybe<DriverProfile>;
  email: Maybe<Scalars['String']['output']>;
  email_status: Maybe<Scalars['String']['output']>;
  exit_survey: Maybe<ExitSurvey>;
  family_profile: Maybe<FamilyProfile>;
  financial_profile: Maybe<FinancialProfile>;
  first_name: Maybe<Scalars['String']['output']>;
  full_name: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  health_profile: Maybe<HealthProfile>;
  household: Maybe<HouseholdProfile>;
  id: Maybe<Scalars['ID']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  licensed_to_drive: Maybe<Scalars['Boolean']['output']>;
  life_insurance: Maybe<LifeInsurance>;
  life_policy_preferences: Maybe<LifePolicyPreferences>;
  maiden_name: Maybe<Scalars['String']['output']>;
  medical_providers: Maybe<Array<Maybe<MedicalProvider>>>;
  middle_name: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  payment_profile: Maybe<PaymentProfile>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed_by: Maybe<Scalars['String']['output']>;
  preferred_name: Maybe<Scalars['String']['output']>;
  products: Maybe<Products>;
  residence: Maybe<Residence>;
  social_security_number: Maybe<Scalars['String']['output']>;
  subscribed_to_newsletter: Maybe<Scalars['Boolean']['output']>;
  travel_profile: Maybe<TravelProfile>;
  underwriting_profile_summary: Maybe<Scalars['String']['output']>;
  underwriting_risk_profile: Maybe<Scalars['String']['output']>;
  unique_account: Maybe<Scalars['Boolean']['output']>;
  uuid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ClientDecisionCreateMutation */
export type ClientDecisionCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  client_decision: Scalars['String']['input'];
  reference_id: Scalars['ID']['input'];
};

/** Autogenerated input type of ClientOfferDecision */
export type ClientOfferDecisionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientOfferDecision?: InputMaybe<Scalars['Boolean']['input']>;
  clientOfferDecisionSignatureAgree?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClientOfferDecision */
export type ClientOfferDecisionPayload = {
  __typename?: 'ClientOfferDecisionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  everlyInterview: EverlyInterview;
  /** @deprecated Return everlyInterview instead */
  success: Scalars['Boolean']['output'];
};

/** Grpc commission split for pgpro */
export type CommissionSplitType = {
  __typename?: 'CommissionSplitType';
  commissionSplit: Maybe<Scalars['Float']['output']>;
  populatePaperwork: Maybe<Scalars['Boolean']['output']>;
};

export type CommunicationPreferenceProfile = {
  __typename?: 'CommunicationPreferenceProfile';
  id: Maybe<Scalars['ID']['output']>;
  smsEnabled: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use smsEnabled instead */
  sms_enabled: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CommunicationPreferenceProfileUpdateMutation */
export type CommunicationPreferenceProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommunicationPreferences = {
  __typename?: 'CommunicationPreferences';
  id: Scalars['ID']['output'];
  preference: Scalars['Boolean']['output'];
  subtype: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Communications feed items */
export type CommunicationsFeedItem = CaseEventFeedItem | CaseUpdateFeedItem | ChatFeedItem | EmailFeedItem | InternalNoteFeedItem | MilestoneUpdateFeedItem | PacketFeedItem | PhoneCallFeedItem | SecureMessageFeedItem | SmsFeedItem | TaskUpdateFeedItem;

export type ComplianceProfile = {
  __typename?: 'ComplianceProfile';
  description: Maybe<Scalars['String']['output']>;
  everDiscussedSaleOfAnyPolicyToInvestor: Maybe<Scalars['Boolean']['output']>;
  everPaidAsIncentiveForAnyPolicy: Maybe<Scalars['Boolean']['output']>;
  everSoldAnyPolicyToThirdParty: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everDiscussedSaleOfAnyPolicyToInvestor instead */
  ever_discussed_sale_of_any_policy_to_investor: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everPaidAsIncentiveForAnyPolicy instead */
  ever_paid_as_incentive_for_any_policy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everSoldAnyPolicyToThirdParty instead */
  ever_sold_any_policy_to_third_party: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  ownershipWillBeTransferred: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ownershipWillBeTransferred instead */
  ownership_will_be_transferred: Maybe<Scalars['Boolean']['output']>;
  paidAsIncentiveForPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use paidAsIncentiveForPolicy instead */
  paid_as_incentive_for_policy: Maybe<Scalars['Boolean']['output']>;
  replacingPolicySoldToInvestor: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use replacingPolicySoldToInvestor instead */
  replacing_policy_sold_to_investor: Maybe<Scalars['Boolean']['output']>;
  saleOfPolicyDiscussedWithInvestor: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use saleOfPolicyDiscussedWithInvestor instead */
  sale_of_policy_discussed_with_investor: Maybe<Scalars['Boolean']['output']>;
  thirdPartyWillGainInterest: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use thirdPartyWillGainInterest instead */
  third_party_will_gain_interest: Maybe<Scalars['Boolean']['output']>;
  unrelatedPartyWillReceiveBenefit: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use unrelatedPartyWillReceiveBenefit instead */
  unrelated_party_will_receive_benefit: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ComplianceProfileUpdateMutation */
export type ComplianceProfileUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ever_discussed_sale_of_any_policy_to_investor?: InputMaybe<Scalars['Boolean']['input']>;
  ever_paid_as_incentive_for_any_policy?: InputMaybe<Scalars['Boolean']['input']>;
  ever_sold_any_policy_to_third_party?: InputMaybe<Scalars['Boolean']['input']>;
  ownership_will_be_transferred?: InputMaybe<Scalars['Boolean']['input']>;
  paid_as_incentive_for_policy?: InputMaybe<Scalars['Boolean']['input']>;
  replacing_policy_sold_to_investor?: InputMaybe<Scalars['Boolean']['input']>;
  sale_of_policy_discussed_with_investor?: InputMaybe<Scalars['Boolean']['input']>;
  third_party_will_gain_interest?: InputMaybe<Scalars['Boolean']['input']>;
  unrelated_party_will_receive_benefit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactInfoConfirmation = {
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  contact_info_confirmed_by: Maybe<Scalars['String']['output']>;
};

/** Metadata about a customer's conversation */
export type ConversationMetadata = {
  __typename?: 'ConversationMetadata';
  id: Maybe<Scalars['ID']['output']>;
  in_autodialer: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ConversationMetadataUpdateMutation */
export type ConversationMetadataUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversation_id: Scalars['ID']['input'];
  in_autodialer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ConversationsMergeMutation */
export type ConversationsMergeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destination_internal_case_id: Scalars['String']['input'];
  source_internal_case_id: Scalars['String']['input'];
};

export type CopyQuotesType = {
  __typename?: 'CopyQuotesType';
  selected_quotes: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CopySelectedQuotes */
export type CopySelectedQuotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  policy_names: Array<InputMaybe<PolicyNamesInput>>;
  quote_params: Array<InputMaybe<QuoteParamsInput>>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of CreateAccountMutation */
export type CreateAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dialer_delay_seconds?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  skip_track_saved_quotes?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateCustomerFromGeneralCase */
export type CreateCustomerFromGeneralCaseInput = {
  case_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateElevatedUser */
export type CreateElevatedUserInput = {
  admin: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  team: Scalars['String']['input'];
  user_role: Scalars['String']['input'];
};

/** Autogenerated input type of CreateMacro */
export type CreateMacroInput = {
  actions: Array<InputMaybe<FormActionInputType>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  queuedMacroId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMacro */
export type CreateMacroPayload = {
  __typename?: 'CreateMacroPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  macro: Maybe<Macro>;
};

export type CreateNewSpousalApp = {
  __typename?: 'CreateNewSpousalApp';
  customer: Maybe<Customer>;
  life_application: Maybe<LifeApplication>;
};

/** Autogenerated input type of CreateNewSpousalApp */
export type CreateNewSpousalAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  source_path?: InputMaybe<Scalars['String']['input']>;
  user_id_to_merge?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateTag */
export type CreateTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the tag that will be deleted */
  tagName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTag */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Array of any errors returned from the creation attempt */
  errors: Maybe<Array<UmbrellaErrorType>>;
  /** The final return message from the creation attempt */
  message: Maybe<Scalars['String']['output']>;
  /** Returned tag id, if creation is successful */
  tagId: Maybe<Scalars['ID']['output']>;
  /** Returned name of tag, if creation is successful */
  tagName: Maybe<Scalars['String']['output']>;
  /** Array of tags returned from successful creation */
  tags: Maybe<Array<UmbrellaMetadataTagType>>;
};

/** The criminal charges of the proposed insured */
export type CriminalChargeProfile = {
  __typename?: 'CriminalChargeProfile';
  charge: Maybe<Scalars['String']['output']>;
  charged: Maybe<Scalars['Boolean']['output']>;
  chargedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use chargedAt instead */
  charged_at: Maybe<Scalars['DateTime']['output']>;
  county: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  recentlyDischarged: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use recentlyDischarged instead */
  recently_discharged: Maybe<Scalars['Boolean']['output']>;
  stateCode: Maybe<Scalars['String']['output']>;
  stateId: Maybe<Scalars['Int']['output']>;
  stateName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stateCode instead */
  state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stateId instead */
  state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use stateName instead */
  state_name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CriminalChargeProfileUpdateMutation */
export type CriminalChargeProfileUpdateMutationInput = {
  charge?: InputMaybe<Scalars['String']['input']>;
  charged?: InputMaybe<Scalars['Boolean']['input']>;
  charged_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  recently_discharged?: InputMaybe<Scalars['Boolean']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CustomForm = {
  __typename?: 'CustomForm';
  form_label: Maybe<Scalars['String']['output']>;
  form_name: Maybe<Scalars['String']['output']>;
  questions: Maybe<Array<Maybe<Question>>>;
};

/** Autogenerated input type of CustomFormResponseUpdateMutation */
export type CustomFormResponseUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  form_name?: InputMaybe<Scalars['String']['input']>;
  response_json?: InputMaybe<Scalars['String']['input']>;
};

/** Conditional custom form values on a life application */
export type CustomFormsType = {
  __typename?: 'CustomFormsType';
  additional_questions: Maybe<AdditionalQuestions>;
  conditional_question_forms: Maybe<Array<Maybe<CustomForm>>>;
  id: Maybe<Scalars['ID']['output']>;
};

/** The user data for a Policygenius customer */
export type Customer = {
  __typename?: 'Customer';
  accountMetadata: AccountMetadata;
  /** @deprecated Use accountMetadata instead */
  account_metadata: AccountMetadata;
  addAdhdProfile: Maybe<AddAdhdProfile>;
  /** @deprecated Use addAdhdProfile instead */
  add_adhd_profile: Maybe<AddAdhdProfile>;
  anxietyProfile: Maybe<AnxietyProfile>;
  /** @deprecated Use anxietyProfile instead */
  anxiety_profile: Maybe<AnxietyProfile>;
  applications: CustomerApplications;
  asthmaProfile: AsthmaProfile;
  /** @deprecated Use asthmaProfile instead */
  asthma_profile: AsthmaProfile;
  bloodPressureProfile: Maybe<BloodPressureProfile>;
  /** @deprecated Use bloodPressureProfile instead */
  blood_pressure_profile: Maybe<BloodPressureProfile>;
  brokerCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use brokerCode instead */
  broker_code: Maybe<Scalars['String']['output']>;
  buildProfile: BuildProfile;
  /** @deprecated Use buildProfile instead */
  build_profile: BuildProfile;
  cancerProfile: CancerProfile;
  /** @deprecated Use cancerProfile instead */
  cancer_profile: CancerProfile;
  cholesterolProfile: Maybe<CholesterolProfile>;
  /** @deprecated Use cholesterolProfile instead */
  cholesterol_profile: Maybe<CholesterolProfile>;
  communicationPreferenceProfile: Maybe<CommunicationPreferenceProfile>;
  communicationPreferences: Maybe<Array<Maybe<CommunicationPreferences>>>;
  /** @deprecated Use communicationPreferenceProfile instead */
  communication_preference_profile: Maybe<CommunicationPreferenceProfile>;
  criminalChargeProfile: Maybe<CriminalChargeProfile>;
  /** @deprecated Use criminalChargeProfile instead */
  criminal_charge_profile: Maybe<CriminalChargeProfile>;
  crossSellLeadScore: Maybe<Scalars['String']['output']>;
  customerCommunicationPreferences: Maybe<CustomerCommunicationPreference>;
  customerIntent: Maybe<CustomerIntent>;
  depressionProfile: DepressionProfile;
  /** @deprecated Use depressionProfile instead */
  depression_profile: DepressionProfile;
  diabetesProfile: DiabetesProfile;
  /** @deprecated Use diabetesProfile instead */
  diabetes_profile: DiabetesProfile;
  driverProfile: DriverProfile;
  /** @deprecated Use driverProfile instead */
  driver_profile: DriverProfile;
  eligibleForDeletion: Scalars['Boolean']['output'];
  employmentProfile: Maybe<EmploymentProfile>;
  /** @deprecated Use employmentProfile instead */
  employment_profile: Maybe<EmploymentProfile>;
  exitSurvey: ExitSurvey;
  /** @deprecated Use exitSurvey instead */
  exit_survey: ExitSurvey;
  familyHealthHistoryProfile: Maybe<FamilyHealthHistoryProfile>;
  /** @deprecated Use familyHealthHistoryProfile instead */
  family_health_history_profile: Maybe<FamilyHealthHistoryProfile>;
  financialProfile: FinancialProfile;
  /** @deprecated Use financialProfile instead */
  financial_profile: FinancialProfile;
  hasLifeSpousalRelationship: Scalars['Boolean']['output'];
  hazardousActivitiesProfile: Maybe<HazardousActivitiesProfile>;
  hazardousEmploymentProfile: Maybe<HazardousEmploymentProfile>;
  /** @deprecated Use hazardousActivitiesProfile instead */
  hazardous_activities_profile: Maybe<HazardousActivitiesProfile>;
  healthProfile: HealthProfile;
  /** @deprecated Use healthProfile instead */
  health_profile: HealthProfile;
  heartAttackProfile: HeartAttackProfile;
  /** @deprecated Use heartAttackProfile instead */
  heart_attack_profile: HeartAttackProfile;
  householdProfile: Maybe<HouseholdProfile>;
  /** @deprecated Use householdProfile instead */
  household_profile: Maybe<HouseholdProfile>;
  id: Scalars['ID']['output'];
  identityProfile: IdentityProfile;
  /** @deprecated Use identityProfile instead */
  identity_profile: IdentityProfile;
  immigrationProfile: ImmigrationProfile;
  /** @deprecated Use immigrationProfile instead */
  immigration_profile: ImmigrationProfile;
  insuranceProfile: Maybe<InsuranceProfile>;
  /** @deprecated Use insuranceProfile instead */
  insurance_profile: Maybe<InsuranceProfile>;
  isDigitalAssist: Maybe<Scalars['Boolean']['output']>;
  isLocked: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isLocked instead */
  is_locked: Maybe<Scalars['Boolean']['output']>;
  latestReferralProfile: Maybe<ReferralProfile>;
  lifeInsuranceCoverageNeeds: LifeInsuranceCoverageNeedsCalculation;
  lifePgProReferral: Maybe<Scalars['Boolean']['output']>;
  lifeSegment: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use lifeInsuranceCoverageNeeds instead */
  life_insurance_coverage_needs: LifeInsuranceCoverageNeedsCalculation;
  medicalProviders: Maybe<Array<Maybe<MedicalProvider>>>;
  /** @deprecated Use medicalProviders instead */
  medical_providers: Maybe<Array<Maybe<MedicalProvider>>>;
  militaryProfile: Maybe<MilitaryProfile>;
  /** @deprecated Use militaryProfile instead */
  military_profile: Maybe<MilitaryProfile>;
  paymentProfile: Maybe<PaymentProfile>;
  /** @deprecated Use paymentProfile instead */
  payment_profile: Maybe<PaymentProfile>;
  pcpProfile: Maybe<PcpProfile>;
  /** @deprecated Use pcpProfile instead */
  pcp_profile: Maybe<PcpProfile>;
  pregnancyHistory: Maybe<PregnancyHistory>;
  pregnancyProfile: Maybe<PregnancyProfile>;
  /** @deprecated Use pregnancyHistory instead */
  pregnancy_history: Maybe<PregnancyHistory>;
  /** @deprecated Use pregnancyProfile instead */
  pregnancy_profile: Maybe<PregnancyProfile>;
  productProfile: ProductProfile;
  /** @deprecated Use productProfile instead */
  product_profile: ProductProfile;
  relatedCustomers: Array<Customer>;
  /** @deprecated Use relatedCustomers instead */
  related_customers: Array<Customer>;
  residenceProfile: ResidenceProfile;
  /** @deprecated Use residenceProfile instead */
  residence_profile: ResidenceProfile;
  secondaryResidenceProfile: Maybe<SecondaryResidenceProfile>;
  /** @deprecated Use secondaryResidenceProfile instead */
  secondary_residence_profile: Maybe<SecondaryResidenceProfile>;
  shouldOffboardLife: Scalars['Boolean']['output'];
  sleepApneaProfile: SleepApneaProfile;
  /** @deprecated Use sleepApneaProfile instead */
  sleep_apnea_profile: SleepApneaProfile;
  strokeProfile: StrokeProfile;
  /** @deprecated Use strokeProfile instead */
  stroke_profile: StrokeProfile;
  substanceAbuseProfile: Maybe<SubstanceAbuseProfile>;
  /** @deprecated Use substanceAbuseProfile instead */
  substance_abuse_profile: Maybe<SubstanceAbuseProfile>;
  tobaccoProfile: TobaccoProfile;
  /** @deprecated Use tobaccoProfile instead */
  tobacco_profile: TobaccoProfile;
  travelProfile: Maybe<TravelProfile>;
  /** @deprecated Use travelProfile instead */
  travel_profile: Maybe<TravelProfile>;
  /** JSON-stringified user attributes */
  userAttributes: Scalars['String']['output'];
  /**
   * JSON-stringified user attributes
   * @deprecated Use userAttributes instead
   */
  user_attributes: Scalars['String']['output'];
};


/** The user data for a Policygenius customer */
export type CustomerCustomerIntentArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerApplications = {
  __typename?: 'CustomerApplications';
  disabilityApplications: Maybe<Array<Maybe<DisabilityApplication>>>;
  /** @deprecated Use disabilityApplications instead */
  disability_applications: Maybe<Array<Maybe<DisabilityApplication>>>;
  homeAndAutoApplications: Maybe<Array<Maybe<HomeAndAutoApplication>>>;
  /** @deprecated Use homeAndAutoApplications instead */
  home_and_auto_applications: Maybe<Array<Maybe<HomeAndAutoApplication>>>;
  lifeApplications: Maybe<Array<Maybe<LifeApplication>>>;
  /** @deprecated Use lifeApplications instead */
  life_applications: Maybe<Array<Maybe<LifeApplication>>>;
};

export type CustomerCommunicationPreference = {
  __typename?: 'CustomerCommunicationPreference';
  id: Maybe<Scalars['ID']['output']>;
  marketingCommsPaused: Maybe<Scalars['Boolean']['output']>;
  marketingCommsPausedUntil: Maybe<Scalars['DateTime']['output']>;
  marketingPauseLength: Maybe<Scalars['Int']['output']>;
  phoneCallsPaused: Maybe<Scalars['Boolean']['output']>;
  phoneCallsPausedUntil: Maybe<Scalars['DateTime']['output']>;
  phonePauseLength: Maybe<Scalars['Int']['output']>;
  umbrellaSmsPauseLength: Maybe<Scalars['Int']['output']>;
  umbrellaSmsPaused: Maybe<Scalars['Boolean']['output']>;
  umbrellaSmsPausedUntil: Maybe<Scalars['DateTime']['output']>;
};

/** Autogenerated input type of CustomerCommunicationPreferencesUpdateMutation */
export type CustomerCommunicationPreferencesUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  marketing_comms_paused?: InputMaybe<Scalars['Boolean']['input']>;
  marketing_comms_paused_until?: InputMaybe<Scalars['DateTime']['input']>;
  phone_calls_paused?: InputMaybe<Scalars['Boolean']['input']>;
  phone_calls_paused_until?: InputMaybe<Scalars['DateTime']['input']>;
  umbrella_sms_paused?: InputMaybe<Scalars['Boolean']['input']>;
  umbrella_sms_paused_until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated input type of CustomerCreateMutation */
export type CustomerCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copy_spouse_address?: InputMaybe<Scalars['Boolean']['input']>;
  create_from_general_case?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  existing_customer_uuid?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  general_case_id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pnc_shopper_reason?: InputMaybe<Scalars['String']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  referring_agent_email?: InputMaybe<Scalars['String']['input']>;
  referring_organization?: InputMaybe<Scalars['String']['input']>;
  spousal?: InputMaybe<Scalars['Boolean']['input']>;
  spousal_modal?: InputMaybe<Scalars['Boolean']['input']>;
  spousal_modal_source?: InputMaybe<Scalars['String']['input']>;
  vertical_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Autogenerated input type of CustomerFromGeneralCaseCreateMutation */
export type CustomerFromGeneralCaseCreateMutationInput = {
  case_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerIntent = {
  __typename?: 'CustomerIntent';
  feedback: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  question: Maybe<Scalars['String']['output']>;
  response: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CustomerIntentUpdateMutation */
export type CustomerIntentUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Translation of an elasticsearch record into a useful summary of customer */
export type CustomerSummaryType = {
  __typename?: 'CustomerSummaryType';
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** @deprecated Use dateOfBirth instead */
  date_of_birth: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fullName instead */
  full_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyNumbers instead */
  policy_numbers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zendeskTicketIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Use zendeskTicketIds instead */
  zendesk_ticket_ids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** Autogenerated input type of CustomerUnsubscribeMutation */
export type CustomerUnsubscribeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
};

export type CustomersMutation = {
  __typename?: 'CustomersMutation';
  accounts_merge: Maybe<Customer>;
  add_adhd_profile_update: Maybe<AddAdhdProfile>;
  anxiety_profile_update: Maybe<AnxietyProfile>;
  asthma_profile_update: Maybe<AsthmaProfile>;
  blood_pressure_profile_update: Maybe<BloodPressureProfile>;
  build_profile_update: Maybe<BuildProfile>;
  calculatePropensityScore: Maybe<CalculatePropensityScorePayload>;
  cancer_profile_update: Maybe<CancerProfile>;
  cholesterol_profile_update: Maybe<CholesterolProfile>;
  communication_preference_profile_update: Maybe<CommunicationPreferenceProfile>;
  create_account: Maybe<Customer>;
  create_new_spousal_app: Maybe<CreateNewSpousalApp>;
  criminal_charge_profile_update: Maybe<CriminalChargeProfile>;
  customer_communication_preferences_update: Maybe<CustomerCommunicationPreference>;
  customer_intent_update: Maybe<CustomerIntent>;
  depression_profile_update: Maybe<DepressionProfile>;
  diabetes_profile_update: Maybe<DiabetesProfile>;
  driver_profile_update: Maybe<DriverProfile>;
  employment_profile_update: Maybe<EmploymentProfile>;
  exit_survey_update: Maybe<ExitSurvey>;
  family_health_profile_update: Maybe<FamilyHealthHistoryProfile>;
  financial_profile_update: Maybe<FinancialProfile>;
  hazardous_activities_profile_update: Maybe<HazardousActivitiesProfile>;
  health_profile_update: Maybe<HealthProfile>;
  heart_attack_profile_update: Maybe<HeartAttackProfile>;
  household_profile_update: Maybe<HouseholdProfile>;
  identity_profile_update: Maybe<IdentityProfile>;
  immigration_profile_update: Maybe<ImmigrationProfile>;
  insurance_profile_update: Maybe<InsuranceProfile>;
  medical_provider_create: Maybe<MedicalProvider>;
  military_profile_update: Maybe<MilitaryProfile>;
  payment_profile_update: Maybe<PaymentProfile>;
  pcp_profile_update: Maybe<PcpProfile>;
  pregnancy_history_update: Maybe<PregnancyHistory>;
  pregnancy_profile_update: Maybe<PregnancyProfile>;
  residence_profile_update: Maybe<ResidenceProfile>;
  secondary_residence_profile_update: Maybe<SecondaryResidenceProfile>;
  sleep_apnea_profile_update: Maybe<SleepApneaProfile>;
  spousal_link: Maybe<SpousalLink>;
  spousal_unlink: Maybe<SpousalLink>;
  stroke_profile_update: Maybe<StrokeProfile>;
  substance_abuse_profile_update: Maybe<SubstanceAbuseProfile>;
  tobacco_profile_update: Maybe<TobaccoProfile>;
  travel_profile_update: Maybe<TravelProfile>;
  updateHazardousEmploymentProfile: Maybe<UpdateHazardousEmploymentProfilePayload>;
  update_user_attributes: Maybe<Customer>;
  user_broker_update: Maybe<Customer>;
};


export type CustomersMutationAccounts_MergeArgs = {
  input: AccountsMergeMutationInput;
};


export type CustomersMutationAdd_Adhd_Profile_UpdateArgs = {
  input: AddAdhdProfileUpdateMutationInput;
};


export type CustomersMutationAnxiety_Profile_UpdateArgs = {
  input: AnxietyProfileUpdateMutationInput;
};


export type CustomersMutationAsthma_Profile_UpdateArgs = {
  input: AsthmaProfileUpdateMutationInput;
};


export type CustomersMutationBlood_Pressure_Profile_UpdateArgs = {
  input: BloodPressureProfileUpdateMutationInput;
};


export type CustomersMutationBuild_Profile_UpdateArgs = {
  input: BuildProfileUpdateMutationInput;
};


export type CustomersMutationCalculatePropensityScoreArgs = {
  input: CalculatePropensityScoreInput;
};


export type CustomersMutationCancer_Profile_UpdateArgs = {
  input: CancerProfileUpdateMutationInput;
};


export type CustomersMutationCholesterol_Profile_UpdateArgs = {
  input: CholesterolProfileUpdateMutationInput;
};


export type CustomersMutationCommunication_Preference_Profile_UpdateArgs = {
  input: CommunicationPreferenceProfileUpdateMutationInput;
};


export type CustomersMutationCreate_AccountArgs = {
  input: CreateAccountMutationInput;
};


export type CustomersMutationCreate_New_Spousal_AppArgs = {
  input: CreateNewSpousalAppInput;
};


export type CustomersMutationCriminal_Charge_Profile_UpdateArgs = {
  input: CriminalChargeProfileUpdateMutationInput;
};


export type CustomersMutationCustomer_Communication_Preferences_UpdateArgs = {
  input: CustomerCommunicationPreferencesUpdateMutationInput;
};


export type CustomersMutationCustomer_Intent_UpdateArgs = {
  input: CustomerIntentUpdateMutationInput;
};


export type CustomersMutationDepression_Profile_UpdateArgs = {
  input: DepressionProfileUpdateMutationInput;
};


export type CustomersMutationDiabetes_Profile_UpdateArgs = {
  input: DiabetesProfileUpdateMutationInput;
};


export type CustomersMutationDriver_Profile_UpdateArgs = {
  input: DriverProfileUpdateMutationInput;
};


export type CustomersMutationEmployment_Profile_UpdateArgs = {
  input: EmploymentProfileUpdateMutationInput;
};


export type CustomersMutationExit_Survey_UpdateArgs = {
  input: ExitSurveyUpdateMutationInput;
};


export type CustomersMutationFamily_Health_Profile_UpdateArgs = {
  input: FamilyHealthProfileUpdateMutationInput;
};


export type CustomersMutationFinancial_Profile_UpdateArgs = {
  input: FinancialProfileUpdateMutationInput;
};


export type CustomersMutationHazardous_Activities_Profile_UpdateArgs = {
  input: HazardousActivitiesProfileUpdateMutationInput;
};


export type CustomersMutationHealth_Profile_UpdateArgs = {
  input: HealthProfileUpdateMutationInput;
};


export type CustomersMutationHeart_Attack_Profile_UpdateArgs = {
  input: HeartAttackProfileUpdateMutationInput;
};


export type CustomersMutationHousehold_Profile_UpdateArgs = {
  input: HouseholdProfileUpdateMutationInput;
};


export type CustomersMutationIdentity_Profile_UpdateArgs = {
  input: IdentityProfileUpdateMutationInput;
};


export type CustomersMutationImmigration_Profile_UpdateArgs = {
  input: ImmigrationProfileUpdateMutationInput;
};


export type CustomersMutationInsurance_Profile_UpdateArgs = {
  input: InsuranceProfileUpdateMutationInput;
};


export type CustomersMutationMedical_Provider_CreateArgs = {
  input: MedicalProviderCreateMutationInput;
};


export type CustomersMutationMilitary_Profile_UpdateArgs = {
  input: MilitaryProfileUpdateMutationInput;
};


export type CustomersMutationPayment_Profile_UpdateArgs = {
  input: PaymentProfileUpdateMutationInput;
};


export type CustomersMutationPcp_Profile_UpdateArgs = {
  input: PcpProfileUpdateMutationInput;
};


export type CustomersMutationPregnancy_History_UpdateArgs = {
  input: PregnancyHistoryUpdateMutationInput;
};


export type CustomersMutationPregnancy_Profile_UpdateArgs = {
  input: PregnancyProfileUpdateMutationInput;
};


export type CustomersMutationResidence_Profile_UpdateArgs = {
  input: ResidenceProfileUpdateMutationInput;
};


export type CustomersMutationSecondary_Residence_Profile_UpdateArgs = {
  input: SecondaryResidenceProfileUpdateMutationInput;
};


export type CustomersMutationSleep_Apnea_Profile_UpdateArgs = {
  input: SleepApneaProfileUpdateMutationInput;
};


export type CustomersMutationSpousal_LinkArgs = {
  input: SpousalLinkMutationInput;
};


export type CustomersMutationSpousal_UnlinkArgs = {
  input: SpousalUnlinkMutationInput;
};


export type CustomersMutationStroke_Profile_UpdateArgs = {
  input: StrokeProfileUpdateMutationInput;
};


export type CustomersMutationSubstance_Abuse_Profile_UpdateArgs = {
  input: SubstanceAbuseProfileUpdateMutationInput;
};


export type CustomersMutationTobacco_Profile_UpdateArgs = {
  input: TobaccoProfileUpdateMutationInput;
};


export type CustomersMutationTravel_Profile_UpdateArgs = {
  input: TravelProfileUpdateMutationInput;
};


export type CustomersMutationUpdateHazardousEmploymentProfileArgs = {
  input: UpdateHazardousEmploymentProfileInput;
};


export type CustomersMutationUpdate_User_AttributesArgs = {
  input: UpdateUserAttributesMutationInput;
};


export type CustomersMutationUser_Broker_UpdateArgs = {
  input: UserBrokerUpdateMutationInput;
};

export type Debt = {
  __typename?: 'Debt';
  amount: Maybe<Scalars['Int']['output']>;
  cosigned: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  persisted: Scalars['Boolean']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type DebtInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  cosigned?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  persisted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DeleteMacro */
export type DeleteMacroInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the macro that will be deleted */
  macroId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMacro */
export type DeleteMacroPayload = {
  __typename?: 'DeleteMacroPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteUserData */
export type DeleteUserDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user that will be deleted */
  customerId: Scalars['ID']['input'];
  /** Boolean for triggering a dry_run */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeleteUserData */
export type DeleteUserDataPayload = {
  __typename?: 'DeleteUserDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Email of user that was deleted */
  email: Maybe<Scalars['String']['output']>;
  /** Array of any errors returned from delete_user_data run */
  errors: Maybe<Array<UmbrellaErrorType>>;
  /** The final return message from delete_user_data run */
  message: Maybe<Scalars['String']['output']>;
  /** UUID of user that was deleted */
  uuid: Maybe<Scalars['String']['output']>;
};

export type Dependent = {
  __typename?: 'Dependent';
  age: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  persisted: Maybe<Scalars['Boolean']['output']>;
  plannedEducation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use plannedEducation instead */
  planned_education: Maybe<Scalars['String']['output']>;
};

export type DependentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  persisted?: InputMaybe<Scalars['Boolean']['input']>;
  planned_education?: InputMaybe<Scalars['String']['input']>;
};

export type DepressionProfile = {
  __typename?: 'DepressionProfile';
  currentlyTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use currentlyTreated instead */
  currently_treated: Maybe<Scalars['Boolean']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  everTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everTreated instead */
  ever_treated: Maybe<Scalars['Boolean']['output']>;
  historyOfDepression: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfDepression instead */
  history_of_depression: Maybe<Scalars['Boolean']['output']>;
  hospitalized: Scalars['Boolean']['output'];
  hospitalizedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use hospitalizedAt instead */
  hospitalized_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  numberOfMedications: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use numberOfMedications instead */
  number_of_medications: Maybe<Scalars['Int']['output']>;
  psychotherapy: Maybe<Scalars['Boolean']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  treatmentEndDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use treatmentEndDate instead */
  treatment_end_date: Maybe<Scalars['DateTime']['output']>;
};

/** Autogenerated input type of DepressionProfileUpdateMutation */
export type DepressionProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currently_treated?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  ever_treated?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_depression?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalized_at?: InputMaybe<Scalars['DateTime']['input']>;
  number_of_medications?: InputMaybe<Scalars['Int']['input']>;
  psychotherapy?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  treatment_end_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiabetesProfile = {
  __typename?: 'DiabetesProfile';
  currentlyTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use currentlyTreated instead */
  currently_treated: Maybe<Scalars['Boolean']['output']>;
  dateOfDiagnosis: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfDiagnosis instead */
  date_of_diagnosis: Maybe<Scalars['DateTime']['output']>;
  diabetesType: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use diabetesType instead */
  diabetes_type: Maybe<Scalars['Int']['output']>;
  gestational: Maybe<Scalars['Boolean']['output']>;
  hasHadComplications: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasHadComplications instead */
  has_had_complications: Maybe<Scalars['Boolean']['output']>;
  historyOfDiabetes: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfDiabetes instead */
  history_of_diabetes: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insulinUnits: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use insulinUnits instead */
  insulin_units: Maybe<Scalars['Int']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  lastA1cReading: Maybe<Scalars['Float']['output']>;
  lastTreatmentDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lastA1cReading instead */
  last_a1c_reading: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use lastTreatmentDate instead */
  last_treatment_date: Maybe<Scalars['DateTime']['output']>;
  twelveMonthAverageA1cReading: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use twelveMonthAverageA1cReading instead */
  twelve_month_average_a1c_reading: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of DiabetesProfileUpdateMutation */
export type DiabetesProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currently_treated?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_diagnosis?: InputMaybe<Scalars['DateTime']['input']>;
  diabetes_type?: InputMaybe<Scalars['Int']['input']>;
  gestational?: InputMaybe<Scalars['Boolean']['input']>;
  has_had_complications?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  insulin_units?: InputMaybe<Scalars['Int']['input']>;
  last_a1c_reading?: InputMaybe<Scalars['Float']['input']>;
  last_treatment_date?: InputMaybe<Scalars['DateTime']['input']>;
  twelve_month_average_a1c_reading?: InputMaybe<Scalars['Float']['input']>;
};

export enum DialerDelayTypeEnum {
  BannerOnline = 'BANNER_ONLINE',
  CommonApp = 'COMMON_APP',
  ContinueOnline = 'CONTINUE_ONLINE',
  D2DPostOfc = 'D2D_POST_OFC',
  FunnelRemix = 'FUNNEL_REMIX',
  ImprovedNextSteps = 'IMPROVED_NEXT_STEPS',
  NoDelay = 'NO_DELAY',
  SplitFunnel = 'SPLIT_FUNNEL'
}

export type DisabilityApplication = {
  __typename?: 'DisabilityApplication';
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  internal_case: Maybe<InternalCase>;
  policy: Maybe<DisabilityApplicationPolicy>;
  rating: Maybe<DisabilityApplicationRating>;
  reference_id: Maybe<Scalars['ID']['output']>;
  riders: Maybe<DisabilityApplicationRiders>;
};

export type DisabilityApplicationPolicy = {
  __typename?: 'DisabilityApplicationPolicy';
  annual_premium: Maybe<Scalars['Int']['output']>;
  benefit_amount: Maybe<Scalars['Int']['output']>;
  benefit_period: Maybe<Scalars['String']['output']>;
  carrier_name: Maybe<Scalars['String']['output']>;
  carrier_slug: Maybe<Scalars['String']['output']>;
  existing_disability_ins_type: Maybe<Scalars['String']['output']>;
  has_existing_disability_ins: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  is_policy_owner: Maybe<Scalars['Boolean']['output']>;
  monthly_premium: Maybe<Scalars['Int']['output']>;
  occupation_class: Maybe<Scalars['String']['output']>;
  pays_premium: Maybe<Scalars['Boolean']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  policy_preferences: Maybe<LifePolicyPreferences>;
  premium_amount: Maybe<Scalars['Int']['output']>;
  premium_frequency: Maybe<Scalars['String']['output']>;
  premium_structure: Maybe<Scalars['String']['output']>;
  quarterly_premium: Maybe<Scalars['Int']['output']>;
  semi_annual_premium: Maybe<Scalars['Int']['output']>;
  waiting_period_in_days: Maybe<Scalars['Int']['output']>;
};

export type DisabilityApplicationRating = {
  __typename?: 'DisabilityApplicationRating';
  exclusions: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  medical_rating_percentage: Maybe<Scalars['Int']['output']>;
  mental_nervous_coverage: Maybe<Scalars['String']['output']>;
};

export type DisabilityApplicationRiders = {
  __typename?: 'DisabilityApplicationRiders';
  catastrophic_disability_benefit: Maybe<Scalars['Boolean']['output']>;
  cost_of_living_adjustment: Maybe<Scalars['Boolean']['output']>;
  critical_illness_benefit: Maybe<Scalars['Boolean']['output']>;
  expect_income_increase: Maybe<Scalars['Boolean']['output']>;
  expect_income_increase_pool_size: Maybe<Scalars['Int']['output']>;
  expect_income_increase_type: Maybe<Scalars['String']['output']>;
  extended_benefits: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  noncancellable: Maybe<Scalars['Boolean']['output']>;
  noncancellable_type: Maybe<Scalars['String']['output']>;
  own_occupation_policy: Maybe<Scalars['Boolean']['output']>;
  own_occupation_policy_type: Maybe<Scalars['String']['output']>;
  residual_disability_policy: Maybe<Scalars['Boolean']['output']>;
  residual_disability_policy_type: Maybe<Scalars['String']['output']>;
  retirement_protection: Maybe<Scalars['Boolean']['output']>;
  retroactive_injury_benefit: Maybe<Scalars['Boolean']['output']>;
  return_of_premium_benefit: Maybe<Scalars['Boolean']['output']>;
  social_insurance_substitute: Maybe<Scalars['Boolean']['output']>;
  student_loan_protection: Maybe<Scalars['Boolean']['output']>;
  supplemental_disability_income: Maybe<Scalars['Boolean']['output']>;
  unemployment_waiver_of_premium: Maybe<Scalars['Boolean']['output']>;
};

export type DisabilityApplications = {
  __typename?: 'DisabilityApplications';
  policy_update: Maybe<DisabilityApplication>;
  rating_update: Maybe<DisabilityApplication>;
  riders_update: Maybe<DisabilityApplication>;
};


export type DisabilityApplicationsPolicy_UpdateArgs = {
  input: DisabilityPolicyUpdateMutationInput;
};


export type DisabilityApplicationsRating_UpdateArgs = {
  input: DisabilityRatingUpdateMutationInput;
};


export type DisabilityApplicationsRiders_UpdateArgs = {
  input: DisabilityRidersUpdateMutationInput;
};

/** Autogenerated input type of DisabilityPolicyUpdateMutation */
export type DisabilityPolicyUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  benefit_amount?: InputMaybe<Scalars['Int']['input']>;
  benefit_period?: InputMaybe<Scalars['String']['input']>;
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  existing_disability_ins_type?: InputMaybe<Scalars['String']['input']>;
  has_existing_disability_ins?: InputMaybe<Scalars['Boolean']['input']>;
  is_policy_owner?: InputMaybe<Scalars['Boolean']['input']>;
  occupation_class?: InputMaybe<Scalars['String']['input']>;
  pays_premium?: InputMaybe<Scalars['Boolean']['input']>;
  premium_amount?: InputMaybe<Scalars['Int']['input']>;
  premium_frequency?: InputMaybe<Scalars['String']['input']>;
  premium_structure?: InputMaybe<Scalars['String']['input']>;
  waiting_period_in_days?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DisabilityRatingUpdateMutation */
export type DisabilityRatingUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclusions?: InputMaybe<Scalars['String']['input']>;
  medical_rating_percentage?: InputMaybe<Scalars['Int']['input']>;
  mental_nervous_coverage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DisabilityRidersUpdateMutation */
export type DisabilityRidersUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  catastrophic_disability_benefit?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost_of_living_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  critical_illness_benefit?: InputMaybe<Scalars['Boolean']['input']>;
  expect_income_increase?: InputMaybe<Scalars['Boolean']['input']>;
  expect_income_increase_pool_size?: InputMaybe<Scalars['Int']['input']>;
  expect_income_increase_type?: InputMaybe<Scalars['String']['input']>;
  extended_benefits?: InputMaybe<Scalars['Boolean']['input']>;
  noncancellable?: InputMaybe<Scalars['Boolean']['input']>;
  noncancellable_type?: InputMaybe<Scalars['String']['input']>;
  own_occupation_policy?: InputMaybe<Scalars['Boolean']['input']>;
  own_occupation_policy_type?: InputMaybe<Scalars['String']['input']>;
  residual_disability_policy?: InputMaybe<Scalars['Boolean']['input']>;
  residual_disability_policy_type?: InputMaybe<Scalars['String']['input']>;
  retirement_protection?: InputMaybe<Scalars['Boolean']['input']>;
  retroactive_injury_benefit?: InputMaybe<Scalars['Boolean']['input']>;
  return_of_premium_benefit?: InputMaybe<Scalars['Boolean']['input']>;
  social_insurance_substitute?: InputMaybe<Scalars['Boolean']['input']>;
  student_loan_protection?: InputMaybe<Scalars['Boolean']['input']>;
  supplemental_disability_income?: InputMaybe<Scalars['Boolean']['input']>;
  unemployment_waiver_of_premium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisplayedPolicyResultsInputType = {
  annual_premium?: InputMaybe<Scalars['Float']['input']>;
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  issue_type?: InputMaybe<Scalars['String']['input']>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  plan_identifier_name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  recommended_policy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Document = {
  __typename?: 'Document';
  id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use last_updater */
  last_updated_by: Maybe<Client>;
  last_updater: Maybe<Customer>;
  name: Maybe<Scalars['String']['output']>;
  unsigned_file_url: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentPacket = {
  __typename?: 'DocumentPacket';
  documents: Maybe<Array<Maybe<Document>>>;
  id: Maybe<Scalars['ID']['output']>;
  mapping_warnings: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Maybe<Scalars['String']['output']>;
  nigo_warnings: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  packet_state: Maybe<PacketStateType>;
  unsigned_combined_file_url: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DocumentPacketCarrierSubmitMutation */
export type DocumentPacketCarrierSubmitMutationInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  document_packet_id: Scalars['ID']['input'];
  file_attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};

/** Autogenerated input type of DocumentPacketCreateMutation */
export type DocumentPacketCreateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creating_from_scratch?: InputMaybe<Scalars['Boolean']['input']>;
  packet_type: Scalars['String']['input'];
};

export type DocumentPacketCreateResponse = {
  __typename?: 'DocumentPacketCreateResponse';
  /** @deprecated Use life application metadata */
  life_application: Maybe<LifeApplication>;
  life_application_metadata: Maybe<UmbrellaLifeApplicationMetadata>;
  missing_forms: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Autogenerated input type of DocumentPacketDocumentDeleteMutation */
export type DocumentPacketDocumentDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  document_id: Scalars['ID']['input'];
};

/** Autogenerated input type of DocumentPacketFormsAddMutation */
export type DocumentPacketFormsAddMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  document_packet_id: Scalars['ID']['input'];
  form_template_uuids: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Autogenerated input type of DocumentPacketSignatureRequestMutation */
export type DocumentPacketSignatureRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  document_packet_id: Scalars['ID']['input'];
  skip_email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentPacketsMutation = {
  __typename?: 'DocumentPacketsMutation';
  document_packet_carrier_submit: Maybe<DocumentPacket>;
  document_packet_create: Maybe<DocumentPacketCreateResponse>;
  document_packet_document_delete: Maybe<DocumentPacket>;
  document_packet_forms_add: Maybe<DocumentPacket>;
  document_packet_signature_request: Maybe<DocumentPacket>;
};


export type DocumentPacketsMutationDocument_Packet_Carrier_SubmitArgs = {
  input: DocumentPacketCarrierSubmitMutationInput;
};


export type DocumentPacketsMutationDocument_Packet_CreateArgs = {
  input: DocumentPacketCreateMutationInput;
};


export type DocumentPacketsMutationDocument_Packet_Document_DeleteArgs = {
  input: DocumentPacketDocumentDeleteMutationInput;
};


export type DocumentPacketsMutationDocument_Packet_Forms_AddArgs = {
  input: DocumentPacketFormsAddMutationInput;
};


export type DocumentPacketsMutationDocument_Packet_Signature_RequestArgs = {
  input: DocumentPacketSignatureRequestMutationInput;
};

export enum DocumentTypeEnum {
  /** Auto Policy Declarations */
  PolicyDecPagesAuto = 'policy_dec_pages_auto',
  /** Home Policy Declarations */
  PolicyDecPagesHome = 'policy_dec_pages_home',
  /** Auto Quotes */
  QuotesAuto = 'quotes_auto',
  /** Home Quotes */
  QuotesHome = 'quotes_home'
}

export type DriverProfile = {
  __typename?: 'DriverProfile';
  convictedOfDwiAt: Maybe<Scalars['DateTime']['output']>;
  convictedOfRecklessDrivingAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use convictedOfDwiAt instead */
  convicted_of_dwi_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use convictedOfRecklessDrivingAt instead */
  convicted_of_reckless_driving_at: Maybe<Scalars['DateTime']['output']>;
  defensiveDrivingLast3Years: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use defensiveDrivingLast3Years instead */
  defensive_driving_last_3_years: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  duiDwiCountLast8Years: Maybe<Scalars['Int']['output']>;
  dwiConviction: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use dwiConviction instead */
  dwi_conviction: Maybe<Scalars['Boolean']['output']>;
  historyOfAdverseDriving: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfAdverseDriving instead */
  history_of_adverse_driving: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Use isValid instead */
  is_valid: Scalars['Boolean']['output'];
  licenseSuspendedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use licenseSuspendedAt instead */
  license_suspended_at: Maybe<Scalars['DateTime']['output']>;
  movingViolations: Maybe<Scalars['Boolean']['output']>;
  movingViolationsLast0To6Months: Maybe<Scalars['Int']['output']>;
  movingViolationsLast6To12Months: Maybe<Scalars['Int']['output']>;
  movingViolationsLast12To24Months: Maybe<Scalars['Int']['output']>;
  movingViolationsLast24To36Months: Maybe<Scalars['Int']['output']>;
  movingViolationsLast36To60Months: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use movingViolations instead */
  moving_violations: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use movingViolationsLast0To6Months instead */
  moving_violations_last_0_to_6_months: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use movingViolationsLast6To12Months instead */
  moving_violations_last_6_to_12_months: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use movingViolationsLast12To24Months instead */
  moving_violations_last_12_to_24_months: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use movingViolationsLast24To36Months instead */
  moving_violations_last_24_to_36_months: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use movingViolationsLast36To60Months instead */
  moving_violations_last_36_to_60_months: Maybe<Scalars['Int']['output']>;
  recklessConviction: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use recklessConviction instead */
  reckless_conviction: Maybe<Scalars['Boolean']['output']>;
  suspendedConviction: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use suspendedConviction instead */
  suspended_conviction: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DriverProfileUpdateMutation */
export type DriverProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  convicted_of_dwi_at?: InputMaybe<Scalars['DateTime']['input']>;
  convicted_of_reckless_driving_at?: InputMaybe<Scalars['DateTime']['input']>;
  customer_id: Scalars['ID']['input'];
  defensive_driving_last_3_years?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dui_dwi_count_last_8_years?: InputMaybe<Scalars['Int']['input']>;
  dwi_conviction?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_adverse_driving?: InputMaybe<Scalars['Boolean']['input']>;
  license_suspended_at?: InputMaybe<Scalars['DateTime']['input']>;
  moving_violations?: InputMaybe<Scalars['Boolean']['input']>;
  moving_violations_last_0_to_6_months?: InputMaybe<Scalars['Int']['input']>;
  moving_violations_last_6_to_12_months?: InputMaybe<Scalars['Int']['input']>;
  moving_violations_last_12_to_24_months?: InputMaybe<Scalars['Int']['input']>;
  moving_violations_last_24_to_36_months?: InputMaybe<Scalars['Int']['input']>;
  moving_violations_last_36_to_60_months?: InputMaybe<Scalars['Int']['input']>;
  reckless_conviction?: InputMaybe<Scalars['Boolean']['input']>;
  suspended_conviction?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A PG user with a role */
export type ElevatedUser = {
  __typename?: 'ElevatedUser';
  /** Whether or not the user is active in the system. */
  active: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the user is an administrator. */
  admin: Maybe<Scalars['Boolean']['output']>;
  /** The email of the user. */
  email: Maybe<Scalars['String']['output']>;
  /** The first name of the user. */
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use firstName instead */
  first_name: Maybe<Scalars['String']['output']>;
  /** The full name of the user. */
  fullName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fullName instead */
  full_name: Maybe<Scalars['String']['output']>;
  /** Id of the user */
  id: Maybe<Scalars['ID']['output']>;
  /** The initials of the users name. */
  initials: Maybe<Scalars['String']['output']>;
  /** The last name of the user. */
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastName instead */
  last_name: Maybe<Scalars['String']['output']>;
  /** Whether or not the user has the ability to modify permissions. */
  permissionAdmin: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use permissionAdmin instead */
  permission_admin: Maybe<Scalars['Boolean']['output']>;
  /** The list of permissions the user has. */
  productAccessPermissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use productAccessPermissions instead */
  product_access_permissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The role of the user. */
  role: Maybe<Scalars['String']['output']>;
  /** The team the user is on. */
  team: Maybe<Scalars['String']['output']>;
  /** @deprecated Use id */
  uuid: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ElevatedUserCreateMutation */
export type ElevatedUserCreateMutationInput = {
  admin: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  user_role: Scalars['String']['input'];
};

export type ElevatedUserSearchInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  teams_id_not_null?: InputMaybe<Scalars['Boolean']['input']>;
  teams_name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmailFeedItem = {
  __typename?: 'EmailFeedItem';
  attachments: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  cc: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commenter: Maybe<ElevatedUser>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  direction: Maybe<Scalars['String']['output']>;
  email_history: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  sender_email: Maybe<Scalars['String']['output']>;
  sender_full_name: Maybe<Scalars['String']['output']>;
  shareable_attachments: Maybe<Array<Maybe<ShareableAttachment>>>;
  source: Maybe<Scalars['String']['output']>;
  star: Maybe<Star>;
  status: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EmailQuotes */
export type EmailQuotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  intro_text: Scalars['String']['input'];
  policy_names?: InputMaybe<Array<InputMaybe<PolicyNamesInput>>>;
  quote_params: Array<InputMaybe<QuoteParamsInput>>;
};

export type EmploymentProfile = {
  __typename?: 'EmploymentProfile';
  ableToPerformAllDuties: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ableToPerformAllDuties instead */
  able_to_perform_all_duties: Maybe<Scalars['Boolean']['output']>;
  activelyWorking: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use activelyWorking instead */
  actively_working: Maybe<Scalars['Boolean']['output']>;
  additionalNotes: Maybe<Scalars['String']['output']>;
  /** @deprecated Use additionalNotes instead */
  additional_notes: Maybe<Scalars['String']['output']>;
  duties: Maybe<Scalars['String']['output']>;
  employerAddressStreet1: Maybe<Scalars['String']['output']>;
  employerAddressStreet2: Maybe<Scalars['String']['output']>;
  employerCity: Maybe<Scalars['String']['output']>;
  employerName: Maybe<Scalars['String']['output']>;
  employerPhone: Maybe<Scalars['String']['output']>;
  employerStateCode: Maybe<Scalars['String']['output']>;
  employerStateId: Maybe<Scalars['Int']['output']>;
  employerStateName: Maybe<Scalars['String']['output']>;
  employerZipCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerAddressStreet1 instead */
  employer_address_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerAddressStreet2 instead */
  employer_address_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerCity instead */
  employer_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerName instead */
  employer_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerPhone instead */
  employer_phone: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerStateCode instead */
  employer_state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerStateId instead */
  employer_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use employerStateName instead */
  employer_state_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employerZipCode instead */
  employer_zip_code: Maybe<Scalars['String']['output']>;
  employmentType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employmentType instead */
  employment_type: Maybe<Scalars['String']['output']>;
  hoursWorkedPerWeek: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use hoursWorkedPerWeek instead */
  hours_worked_per_week: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  jobTitleId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use jobTitle instead */
  job_title: Maybe<Scalars['String']['output']>;
  /** @deprecated Use jobTitleId instead */
  job_title_id: Maybe<Scalars['Int']['output']>;
  yearsEmployed: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use yearsEmployed instead */
  years_employed: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of EmploymentProfileUpdateMutation */
export type EmploymentProfileUpdateMutationInput = {
  able_to_perform_all_duties?: InputMaybe<Scalars['Boolean']['input']>;
  actively_working?: InputMaybe<Scalars['Boolean']['input']>;
  additional_notes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  duties?: InputMaybe<Scalars['String']['input']>;
  employer_address_street_1?: InputMaybe<Scalars['String']['input']>;
  employer_address_street_2?: InputMaybe<Scalars['String']['input']>;
  employer_city?: InputMaybe<Scalars['String']['input']>;
  employer_name?: InputMaybe<Scalars['String']['input']>;
  employer_phone?: InputMaybe<Scalars['String']['input']>;
  employer_state_id?: InputMaybe<Scalars['Int']['input']>;
  employer_zip_code?: InputMaybe<Scalars['String']['input']>;
  employment_type?: InputMaybe<Scalars['String']['input']>;
  hours_worked_per_week?: InputMaybe<Scalars['Int']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  job_title_id?: InputMaybe<Scalars['Int']['input']>;
  years_employed?: InputMaybe<Scalars['Int']['input']>;
};

export type Everly = {
  __typename?: 'Everly';
  clientOfferDecision: Maybe<ClientOfferDecisionPayload>;
  fetchIllustrationData: Maybe<FetchIllustrationDataPayload>;
  illustrationModification: Maybe<IllustrationModificationPayload>;
  offerRejection: Maybe<OfferRejectionPayload>;
  sendAmendmentMessage: Maybe<SendAmendmentMessagePayload>;
  submitEvidenceResponse: Maybe<SubmitEvidenceResponsePayload>;
  submitPartOne: Maybe<SubmitPartOnePayload>;
  submitPartTwo: Maybe<SubmitEverlyPartTwoPayload>;
};


export type EverlyClientOfferDecisionArgs = {
  input: ClientOfferDecisionInput;
};


export type EverlyFetchIllustrationDataArgs = {
  input: FetchIllustrationDataInput;
};


export type EverlyIllustrationModificationArgs = {
  input: IllustrationModificationInput;
};


export type EverlyOfferRejectionArgs = {
  input: OfferRejectionInput;
};


export type EverlySendAmendmentMessageArgs = {
  input: SendAmendmentMessageInput;
};


export type EverlySubmitEvidenceResponseArgs = {
  input: SubmitEvidenceResponseInput;
};


export type EverlySubmitPartOneArgs = {
  input: SubmitPartOneInput;
};


export type EverlySubmitPartTwoArgs = {
  input: SubmitEverlyPartTwoInput;
};

export enum EverlyDecisionOutcome {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  PendingDecision = 'PENDING_DECISION',
  PendingEvidence = 'PENDING_EVIDENCE',
  PendingReview = 'PENDING_REVIEW',
  PendingUnderwriting = 'PENDING_UNDERWRITING',
  RiskNotAcceptable = 'RISK_NOT_ACCEPTABLE'
}

export enum EverlyDecisionStatus {
  Adverse = 'ADVERSE',
  CleanCase = 'CLEAN_CASE',
  Declined = 'DECLINED',
  Modified = 'MODIFIED',
  Na = 'NA',
  NA = 'N_A'
}

export enum EverlyIllustrationFetchStatus {
  Default = 'DEFAULT',
  Error = 'ERROR',
  Fetched = 'FETCHED',
  Fetching = 'FETCHING'
}

export enum EverlyInstantIdCheckStatus {
  Failure = 'FAILURE',
  None = 'NONE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type EverlyInterview = {
  __typename?: 'EverlyInterview';
  amended: Maybe<Scalars['Boolean']['output']>;
  amendmentMessages: Maybe<Array<UmbrellaAmendmentMessageType>>;
  amendmentUrl: Maybe<Scalars['String']['output']>;
  approvedChildRiders: Maybe<Array<UmbrellaEverlyApprovedChildRiderType>>;
  approvedFaceAmount: Maybe<Scalars['Int']['output']>;
  approvedMaxFaceAmount: Maybe<Scalars['Int']['output']>;
  caseId: Maybe<Scalars['String']['output']>;
  clientOfferDecision: Maybe<Scalars['Boolean']['output']>;
  clientOfferDecisionSignatureAgree: Maybe<Scalars['Boolean']['output']>;
  coverageAmount: Maybe<Scalars['Int']['output']>;
  deathBenefitOption: Maybe<Scalars['String']['output']>;
  decisionOutcome: Maybe<EverlyDecisionOutcome>;
  decisionReasons: Array<Scalars['String']['output']>;
  decisionRiskClass: Maybe<Scalars['String']['output']>;
  decisionStatus: Maybe<EverlyDecisionStatus>;
  documentData: Maybe<Array<UmbrellaEverlyDocumentType>>;
  expiryDate: Maybe<Scalars['String']['output']>;
  fixedCostPeriod: Maybe<Scalars['String']['output']>;
  fundAllocationPercentageCap: Maybe<Scalars['Int']['output']>;
  fundAllocationPercentageFixed: Maybe<Scalars['Int']['output']>;
  fundAllocationPercentageParticipation: Maybe<Scalars['Int']['output']>;
  fundAllocationString: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  illustrationFetchStatus: EverlyIllustrationFetchStatus;
  illustrationPremiumAmount: Maybe<Scalars['String']['output']>;
  illustrationPremiumFrequency: Maybe<Scalars['String']['output']>;
  illustrationQuoteId: Maybe<Scalars['String']['output']>;
  instantIdCheckStatus: EverlyInstantIdCheckStatus;
  isExpired: Scalars['Boolean']['output'];
  lastExpiryStatus: Maybe<Scalars['String']['output']>;
  lexisNexisErrorType: Maybe<Scalars['String']['output']>;
  lexisNexisFailureMessage: Maybe<Scalars['String']['output']>;
  offerRejectionStatus: Maybe<Scalars['String']['output']>;
  partOneSubmissionOutcome: Maybe<EverlySubmissionOutcome>;
  partOneSubmissionStatus: Maybe<EverlySubmissionStatus>;
  partTwoSubmissionOutcome: EverlySubmissionOutcome;
  partTwoSubmissionStatus: EverlySubmissionStatus;
  paymentAmount: Maybe<Scalars['String']['output']>;
  paymentFrequency: Maybe<Scalars['String']['output']>;
  policyDecisionAmendments: Array<Scalars['String']['output']>;
  policyValidationExceptions: Array<UmbrellaEverlyPolicyValidationExceptionType>;
  reillustrationUrl: Maybe<Scalars['String']['output']>;
  underwritingClass: Maybe<Scalars['String']['output']>;
};

export enum EverlySubmissionOutcome {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum EverlySubmissionStatus {
  Failed = 'FAILED',
  PendingUserSubmission = 'PENDING_USER_SUBMISSION',
  SubmittedByUser = 'SUBMITTED_BY_USER',
  SubmittedToCarrier = 'SUBMITTED_TO_CARRIER'
}

/** Autogenerated input type of ExistingPoliciesUpdateMutation */
export type ExistingPoliciesUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  existing_policies?: InputMaybe<Array<InputMaybe<ExistingPolicyInputType>>>;
  other_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  reference_id: Scalars['ID']['input'];
};

export type ExistingPolicyInputType = {
  carrier_name?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  coverage_reason?: InputMaybe<Scalars['String']['input']>;
  in_force_year?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  policy_number?: InputMaybe<Scalars['String']['input']>;
  policy_type?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  replacing?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ExitSurvey = {
  __typename?: 'ExitSurvey';
  id: Scalars['ID']['output'];
  initialProduct: Maybe<Scalars['String']['output']>;
  /** @deprecated Use initialProduct instead */
  initial_product: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  sourceCategory: Maybe<Scalars['String']['output']>;
  sourceCategoryDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sourceCategory instead */
  source_category: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sourceCategoryDescription instead */
  source_category_description: Maybe<Scalars['String']['output']>;
};

export type ExitSurveySource = {
  __typename?: 'ExitSurveySource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
  supplementals: Array<ExitSurveySourceSupplementType>;
  supplementalsPrompt: Maybe<Scalars['String']['output']>;
  /** @deprecated Use supplementalsPrompt instead */
  supplementals_prompt: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ExitSurveySourceSupplementType = {
  __typename?: 'ExitSurveySourceSupplementType';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ExitSurveySourcesQuery = {
  __typename?: 'ExitSurveySourcesQuery';
  list: Array<ExitSurveySource>;
};

/** Autogenerated input type of ExitSurveyUpdateMutation */
export type ExitSurveyUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  initial_product?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_category?: InputMaybe<Scalars['String']['input']>;
  source_category_description?: InputMaybe<Scalars['String']['input']>;
};

export type FamilyChild = {
  __typename?: 'FamilyChild';
  age: Maybe<Scalars['Int']['output']>;
  family_profile_id: Maybe<Scalars['ID']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  persisted: Maybe<Scalars['Boolean']['output']>;
  planned_education: Maybe<Scalars['String']['output']>;
};

export type FamilyHealthHistoryProfile = {
  __typename?: 'FamilyHealthHistoryProfile';
  familyMemberHealthHistories: Maybe<Array<Maybe<FamilyMemberHealthHistoryProfile>>>;
  /** @deprecated Use familyMemberHealthHistories instead */
  family_member_health_histories: Maybe<Array<Maybe<FamilyMemberHealthHistoryProfile>>>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of FamilyHealthProfileUpdateMutation */
export type FamilyHealthProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  family_member_health_histories?: InputMaybe<Array<InputMaybe<FamilyMemberHealthHistoryInput>>>;
};

export type FamilyMemberHealthHistoryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  age_contracted?: InputMaybe<Scalars['Int']['input']>;
  age_died?: InputMaybe<Scalars['Int']['input']>;
  basal_cell_carcinoma?: InputMaybe<Scalars['Boolean']['input']>;
  breast_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  cardiovascular_disease?: InputMaybe<Scalars['Boolean']['input']>;
  cardiovascular_impairments?: InputMaybe<Scalars['Boolean']['input']>;
  cause_of_death?: InputMaybe<Scalars['String']['input']>;
  cerebrovascular_disease?: InputMaybe<Scalars['Boolean']['input']>;
  colon_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  coronary_artery_disease?: InputMaybe<Scalars['Boolean']['input']>;
  current_age?: InputMaybe<Scalars['Int']['input']>;
  current_health_status?: InputMaybe<Scalars['String']['input']>;
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  died_from_disease?: InputMaybe<Scalars['Boolean']['input']>;
  familial_adenomatous_polyposis?: InputMaybe<Scalars['Boolean']['input']>;
  huntingtons_disease?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intestinal_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  kidney_disease?: InputMaybe<Scalars['Boolean']['input']>;
  malignant_melanoma?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  other_details?: InputMaybe<Scalars['String']['input']>;
  other_internal_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  ovarian_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  persisted?: InputMaybe<Scalars['Boolean']['input']>;
  polycystic_kidney_disease?: InputMaybe<Scalars['Boolean']['input']>;
  prostate_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  relation_is_living?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  sickle_cell_anemia?: InputMaybe<Scalars['Boolean']['input']>;
  stroke?: InputMaybe<Scalars['Boolean']['input']>;
  unknown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FamilyMemberHealthHistoryProfile = {
  __typename?: 'FamilyMemberHealthHistoryProfile';
  ageContracted: Maybe<Scalars['Int']['output']>;
  ageDied: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use ageContracted instead */
  age_contracted: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use ageDied instead */
  age_died: Maybe<Scalars['Int']['output']>;
  basalCellCarcinoma: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use basalCellCarcinoma instead */
  basal_cell_carcinoma: Maybe<Scalars['Boolean']['output']>;
  breastCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use breastCancer instead */
  breast_cancer: Maybe<Scalars['Boolean']['output']>;
  cardiovascularDisease: Maybe<Scalars['Boolean']['output']>;
  cardiovascularImpairments: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use cardiovascularDisease instead */
  cardiovascular_disease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use cardiovascularImpairments instead */
  cardiovascular_impairments: Maybe<Scalars['Boolean']['output']>;
  causeOfDeath: Maybe<Scalars['String']['output']>;
  /** @deprecated Use causeOfDeath instead */
  cause_of_death: Maybe<Scalars['String']['output']>;
  cerebrovascularDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use cerebrovascularDisease instead */
  cerebrovascular_disease: Maybe<Scalars['Boolean']['output']>;
  colonCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use colonCancer instead */
  colon_cancer: Maybe<Scalars['Boolean']['output']>;
  coronaryArteryDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use coronaryArteryDisease instead */
  coronary_artery_disease: Maybe<Scalars['Boolean']['output']>;
  currentAge: Maybe<Scalars['Int']['output']>;
  currentHealthStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currentAge instead */
  current_age: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use currentHealthStatus instead */
  current_health_status: Maybe<Scalars['String']['output']>;
  diabetes: Maybe<Scalars['Boolean']['output']>;
  diedFromDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use diedFromDisease instead */
  died_from_disease: Maybe<Scalars['Boolean']['output']>;
  familialAdenomatousPolyposis: Maybe<Scalars['Boolean']['output']>;
  huntingtonsDisease: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  intestinalCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use intestinalCancer instead */
  intestinal_cancer: Maybe<Scalars['Boolean']['output']>;
  kidneyDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use kidneyDisease instead */
  kidney_disease: Maybe<Scalars['Boolean']['output']>;
  malignantMelanoma: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use malignantMelanoma instead */
  malignant_melanoma: Maybe<Scalars['Boolean']['output']>;
  other: Maybe<Scalars['Boolean']['output']>;
  otherDetails: Maybe<Scalars['String']['output']>;
  otherInternalCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherDetails instead */
  other_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherInternalCancer instead */
  other_internal_cancer: Maybe<Scalars['Boolean']['output']>;
  ovarianCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ovarianCancer instead */
  ovarian_cancer: Maybe<Scalars['Boolean']['output']>;
  persisted: Maybe<Scalars['Boolean']['output']>;
  polycysticKidneyDisease: Maybe<Scalars['Boolean']['output']>;
  prostateCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use prostateCancer instead */
  prostate_cancer: Maybe<Scalars['Boolean']['output']>;
  relationIsLiving: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use relationIsLiving instead */
  relation_is_living: Maybe<Scalars['Boolean']['output']>;
  relationship: Maybe<Scalars['String']['output']>;
  sickleCellAnemia: Maybe<Scalars['Boolean']['output']>;
  stroke: Maybe<Scalars['Boolean']['output']>;
  unknown: Maybe<Scalars['Boolean']['output']>;
};

export type FamilyProfile = {
  __typename?: 'FamilyProfile';
  childcare_expenses: Maybe<Scalars['Boolean']['output']>;
  children: Maybe<Array<Maybe<FamilyChild>>>;
  customer_id: Maybe<Scalars['ID']['output']>;
  has_children: Maybe<Scalars['Boolean']['output']>;
  has_other_dependents: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  marital_status: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of FeedItemsStarMutation */
export type FeedItemsStarMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  star_id: Scalars['String']['input'];
};

/** Autogenerated input type of FetchIllustrationData */
export type FetchIllustrationDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  illustrationId: Scalars['String']['input'];
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of FetchIllustrationData */
export type FetchIllustrationDataPayload = {
  __typename?: 'FetchIllustrationDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FileType = {
  __typename?: 'FileType';
  file_url: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Metadata to help filter cases with */
export type FilterMetadataInputType = {
  pnc_auto_vertical_id?: InputMaybe<Scalars['ID']['input']>;
  pnc_home_vertical_id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 *
 *     All the various arguments and filters that can be applied
 *     to an internal case elastic search query
 *
 */
export type FiltersInputType = {
  application_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approval_outcomes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aps_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignee_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  carrier_slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  case_owner_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  exclude_approval_outcomes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclude_aps_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclude_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from_follow_up?: InputMaybe<Scalars['Int']['input']>;
  lifecycle_stage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metadata?: InputMaybe<FilterMetadataInputType>;
  milestones?: InputMaybe<Array<InputMaybe<InternalCaseMilestoneFilterInput>>>;
  order_by?: InputMaybe<Scalars['String']['input']>;
  pncShoppingReason?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pnc_is_new_purchase?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  pnc_product_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  policy_decision_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referralAgencyType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referringOrganizationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<InternalCaseStatus>>>;
  statuses?: InputMaybe<Array<InputMaybe<InternalCaseStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  team_member_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  team_member_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to_follow_up?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  umbrella_only?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  view_id?: InputMaybe<Scalars['ID']['input']>;
};

/** The financial profile of the proposed insured */
export type FinancialProfile = {
  __typename?: 'FinancialProfile';
  adverseFinancialHistory: Maybe<Scalars['Boolean']['output']>;
  adverseFinancialHistorySummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use adverseFinancialHistory instead */
  adverse_financial_history: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use adverseFinancialHistorySummary instead */
  adverse_financial_history_summary: Maybe<Scalars['String']['output']>;
  assets: Maybe<Scalars['Int']['output']>;
  bankruptcyChapterFiled: Maybe<Scalars['Int']['output']>;
  bankruptcyChapterFiledAt: Maybe<Scalars['DateTime']['output']>;
  bankruptcyDischargedAt: Maybe<Scalars['DateTime']['output']>;
  bankruptcyReason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use bankruptcyChapterFiled instead */
  bankruptcy_chapter_filed: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use bankruptcyChapterFiledAt instead */
  bankruptcy_chapter_filed_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use bankruptcyDischargedAt instead */
  bankruptcy_discharged_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use bankruptcyReason instead */
  bankruptcy_reason: Maybe<Scalars['String']['output']>;
  burialExpenses: Scalars['Int']['output'];
  /** @deprecated Use burialExpenses instead */
  burial_expenses: Scalars['Int']['output'];
  childrenNeeds: Scalars['Int']['output'];
  /** @deprecated Use childrenNeeds instead */
  children_needs: Scalars['Int']['output'];
  currentLifeInsuranceCoverage: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use currentLifeInsuranceCoverage instead */
  current_life_insurance_coverage: Maybe<Scalars['Int']['output']>;
  debt: Maybe<Scalars['Int']['output']>;
  debtNeeds: Scalars['Int']['output'];
  debtTerm: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use debtNeeds instead */
  debt_needs: Scalars['Int']['output'];
  /** @deprecated Use debtTerm instead */
  debt_term: Maybe<Scalars['Int']['output']>;
  debts: Array<Debt>;
  declinedPostponedHistory: Maybe<Scalars['Boolean']['output']>;
  employmentType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use employmentType instead */
  employment_type: Maybe<Scalars['String']['output']>;
  financialCushionNeeds: Scalars['Int']['output'];
  financialSupportReceived: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use financialCushionNeeds instead */
  financial_cushion_needs: Scalars['Int']['output'];
  /** @deprecated Use financialSupportReceived instead */
  financial_support_received: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  incomeReplacement: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use incomeReplacement instead */
  income_replacement: Maybe<Scalars['Int']['output']>;
  individualIncome: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use individualIncome instead */
  individual_income: Maybe<Scalars['Int']['output']>;
  liabilities: Maybe<Scalars['Int']['output']>;
  occupation: Maybe<Scalars['String']['output']>;
  otherHouseholdIncome: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use otherHouseholdIncome instead */
  other_household_income: Maybe<Scalars['Int']['output']>;
  previousRestricted: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use previousRestricted instead */
  previous_restricted: Maybe<Scalars['Boolean']['output']>;
  requestedOrReceivedWageReplacement: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requestedOrReceivedWageReplacement instead */
  requested_or_received_wage_replacement: Maybe<Scalars['Boolean']['output']>;
  restrictionCoverageType: Maybe<Scalars['String']['output']>;
  restrictionDate: Maybe<Scalars['DateTime']['output']>;
  restrictionReason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use restrictionCoverageType instead */
  restriction_coverage_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use restrictionDate instead */
  restriction_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use restrictionReason instead */
  restriction_reason: Maybe<Scalars['String']['output']>;
  retirementSavings: Scalars['Int']['output'];
  /** @deprecated Use retirementSavings instead */
  retirement_savings: Scalars['Int']['output'];
  savings: Maybe<Scalars['Int']['output']>;
  spouseCoverage: Maybe<Scalars['Int']['output']>;
  spouseCoverageUnknown: Maybe<Scalars['Boolean']['output']>;
  spouseIncome: Maybe<Scalars['Int']['output']>;
  spouseIncomeUnknown: Maybe<Scalars['Boolean']['output']>;
  spouseIncomeUsed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use spouseCoverage instead */
  spouse_coverage: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use spouseCoverageUnknown instead */
  spouse_coverage_unknown: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use spouseIncome instead */
  spouse_income: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use spouseIncomeUnknown instead */
  spouse_income_unknown: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use spouseIncomeUsed instead */
  spouse_income_used: Maybe<Scalars['Boolean']['output']>;
  subjectToBackupWithholding: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use subjectToBackupWithholding instead */
  subject_to_backup_withholding: Maybe<Scalars['Boolean']['output']>;
  totalHouseholdIncome: Maybe<Scalars['Int']['output']>;
  unearnedIncome: Maybe<Scalars['Int']['output']>;
  unearnedIncomeSource: Maybe<Scalars['String']['output']>;
  /** @deprecated Use unearnedIncome instead */
  unearned_income: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use unearnedIncomeSource instead */
  unearned_income_source: Maybe<Scalars['String']['output']>;
  yearsToSupportDependents: Scalars['Int']['output'];
  /** @deprecated Use yearsToSupportDependents instead */
  years_to_support_dependents: Scalars['Int']['output'];
};

/** Autogenerated input type of FinancialProfileUpdateMutation */
export type FinancialProfileUpdateMutationInput = {
  adverse_financial_history?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Scalars['Int']['input']>;
  bankruptcy_chapter_filed?: InputMaybe<Scalars['Int']['input']>;
  bankruptcy_chapter_filed_at?: InputMaybe<Scalars['DateTime']['input']>;
  bankruptcy_discharged_at?: InputMaybe<Scalars['DateTime']['input']>;
  bankruptcy_reason?: InputMaybe<Scalars['String']['input']>;
  burial_expenses?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  current_life_insurance_coverage?: InputMaybe<Scalars['Int']['input']>;
  customer_id: Scalars['ID']['input'];
  debt_term?: InputMaybe<Scalars['Int']['input']>;
  debts?: InputMaybe<Array<InputMaybe<DebtInput>>>;
  declined_postponed_history?: InputMaybe<Scalars['Boolean']['input']>;
  financial_support_received?: InputMaybe<Scalars['Boolean']['input']>;
  income_replacement?: InputMaybe<Scalars['Int']['input']>;
  individual_income?: InputMaybe<Scalars['Int']['input']>;
  liabilities?: InputMaybe<Scalars['Int']['input']>;
  other_household_income?: InputMaybe<Scalars['Int']['input']>;
  requested_or_received_wage_replacement?: InputMaybe<Scalars['Boolean']['input']>;
  retirement_savings?: InputMaybe<Scalars['Int']['input']>;
  savings?: InputMaybe<Scalars['Int']['input']>;
  spouse_coverage?: InputMaybe<Scalars['Int']['input']>;
  spouse_coverage_unknown?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_income?: InputMaybe<Scalars['Int']['input']>;
  spouse_income_unknown?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_income_used?: InputMaybe<Scalars['Boolean']['input']>;
  subject_to_backup_withholding?: InputMaybe<Scalars['Boolean']['input']>;
  total_household_income?: InputMaybe<Scalars['Int']['input']>;
  unearned_income?: InputMaybe<Scalars['Int']['input']>;
  unearned_income_source?: InputMaybe<Scalars['String']['input']>;
  years_to_support_dependents?: InputMaybe<Scalars['Int']['input']>;
};

/** Field to be updated by a macro and its value */
export type FormAction = {
  __typename?: 'FormAction';
  appliedValue: Maybe<Scalars['String']['output']>;
  /** @deprecated Use appliedValue instead */
  applied_value: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  rawValue: Maybe<Scalars['String']['output']>;
  /** @deprecated Use rawValue instead */
  raw_value: Maybe<Scalars['String']['output']>;
  /** @deprecated Use either raw_value or applied_value */
  value: Maybe<Scalars['String']['output']>;
};

export type FormActionInputType = {
  field: Scalars['String']['input'];
  rawValue?: InputMaybe<Scalars['String']['input']>;
};

export type FormConfirmations = {
  __typename?: 'FormConfirmations';
  confirmed_at: Maybe<Scalars['DateTime']['output']>;
  confirmed_by: Maybe<ElevatedUser>;
  disability_application_id: Maybe<Scalars['ID']['output']>;
  form_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  life_application_id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of FormConfirmationsUpdateByCustomerMutation */
export type FormConfirmationsUpdateByCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  form_name: Scalars['String']['input'];
};

/** Autogenerated input type of FormConfirmationsUpdateMutation */
export type FormConfirmationsUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  disability_application_id?: InputMaybe<Scalars['ID']['input']>;
  form_name: Scalars['String']['input'];
  life_application_id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormTemplateSearchResult = {
  __typename?: 'FormTemplateSearchResult';
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type HazardousActivitiesProfile = {
  __typename?: 'HazardousActivitiesProfile';
  aeronautics: Maybe<Scalars['Boolean']['output']>;
  baseJumping: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use baseJumping instead */
  base_jumping: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  engagedInHazardousActivities: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use engagedInHazardousActivities instead */
  engaged_in_hazardous_activities: Maybe<Scalars['Boolean']['output']>;
  extremeMotorsports: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use extremeMotorsports instead */
  extreme_motorsports: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  piloting: Maybe<Scalars['Boolean']['output']>;
  racingOrMotorSports: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use racingOrMotorSports instead */
  racing_or_motor_sports: Maybe<Scalars['Boolean']['output']>;
  rockClimbing: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use rockClimbing instead */
  rock_climbing: Maybe<Scalars['Boolean']['output']>;
  rodeos: Maybe<Scalars['Boolean']['output']>;
  scubaDiving: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use scubaDiving instead */
  scuba_diving: Maybe<Scalars['Boolean']['output']>;
  snowsports: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of HazardousActivitiesProfileUpdateMutation */
export type HazardousActivitiesProfileUpdateMutationInput = {
  aeronautics?: InputMaybe<Scalars['Boolean']['input']>;
  base_jumping?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  extreme_motorsports?: InputMaybe<Scalars['Boolean']['input']>;
  hang_gliding?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  piloting?: InputMaybe<Scalars['Boolean']['input']>;
  racing_or_motor_sports?: InputMaybe<Scalars['Boolean']['input']>;
  rock_climbing?: InputMaybe<Scalars['Boolean']['input']>;
  rodeos?: InputMaybe<Scalars['Boolean']['input']>;
  scuba_diving?: InputMaybe<Scalars['Boolean']['input']>;
  sky_diving?: InputMaybe<Scalars['Boolean']['input']>;
  snowsports?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HazardousEmploymentProfile = {
  __typename?: 'HazardousEmploymentProfile';
  bartender: Maybe<Scalars['Boolean']['output']>;
  correctionsOfficer: Maybe<Scalars['Boolean']['output']>;
  fireFighter: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  military: Maybe<Scalars['Boolean']['output']>;
  nightclub: Maybe<Scalars['Boolean']['output']>;
  pilotOrFlightCrew: Maybe<Scalars['Boolean']['output']>;
  professionalSportsPerson: Maybe<Scalars['Boolean']['output']>;
  stuntPerson: Maybe<Scalars['Boolean']['output']>;
  swat: Maybe<Scalars['Boolean']['output']>;
};

export type HealthProfile = {
  __typename?: 'HealthProfile';
  aids: Maybe<Scalars['Boolean']['output']>;
  alzheimerDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use alzheimerDisease instead */
  alzheimer_disease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use asthma instead */
  asthma: Maybe<Scalars['Boolean']['output']>;
  backProblems: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use backProblems instead */
  back_problems: Maybe<Scalars['Boolean']['output']>;
  basalCellSkinCancer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use basalCellSkinCancer instead */
  basal_cell_skin_cancer: Maybe<Scalars['Boolean']['output']>;
  cancer: Maybe<Scalars['Boolean']['output']>;
  carpalTunnel: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use carpalTunnel instead */
  carpal_tunnel: Maybe<Scalars['Boolean']['output']>;
  codp: Maybe<Scalars['Boolean']['output']>;
  dailyLivingAssistance: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use dailyLivingAssistance instead */
  daily_living_assistance: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use depression instead */
  depression: Maybe<Scalars['Boolean']['output']>;
  detailedMedicalInformation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use detailedMedicalInformation instead */
  detailed_medical_information: Maybe<Scalars['String']['output']>;
  /** @deprecated Use diabetes instead */
  diabetes: Maybe<Scalars['Boolean']['output']>;
  emphysema: Maybe<Scalars['Boolean']['output']>;
  epilepsy: Maybe<Scalars['Boolean']['output']>;
  familyHistoryOfDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use familyHistoryOfDisease instead */
  family_history_of_disease: Maybe<Scalars['Boolean']['output']>;
  glaucoma: Maybe<Scalars['Boolean']['output']>;
  headachesOrMigranes: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use headachesOrMigranes instead */
  headaches_or_migranes: Maybe<Scalars['Boolean']['output']>;
  healthIssues: Array<Scalars['String']['output']>;
  healthRating: Maybe<Scalars['String']['output']>;
  /** @deprecated Use healthIssues instead */
  health_issues: Array<Scalars['String']['output']>;
  /** @deprecated Use healthRating instead */
  health_rating: Maybe<Scalars['String']['output']>;
  heartDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use heartDisease instead */
  heart_disease: Maybe<Scalars['Boolean']['output']>;
  historyOfAdverseDriving: Scalars['Boolean']['output'];
  historyOfAsthma: Maybe<Scalars['Boolean']['output']>;
  historyOfDepression: Maybe<Scalars['Boolean']['output']>;
  historyOfDiabetes: Maybe<Scalars['Boolean']['output']>;
  historyOfHeartAttack: Scalars['Boolean']['output'];
  historyOfHighBloodPressure: Maybe<Scalars['Boolean']['output']>;
  historyOfHighCholesterol: Maybe<Scalars['Boolean']['output']>;
  historyOfSleepApnea: Maybe<Scalars['Boolean']['output']>;
  historyOfStroke: Scalars['Boolean']['output'];
  historyOfTobaccoUse: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfAsthma instead */
  history_of_asthma: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfDepression instead */
  history_of_depression: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfDiabetes instead */
  history_of_diabetes: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfHighBloodPressure instead */
  history_of_high_blood_pressure: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfHighCholesterol instead */
  history_of_high_cholesterol: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfSleepApnea instead */
  history_of_sleep_apnea: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfTobaccoUse instead */
  history_of_tobacco_use: Maybe<Scalars['Boolean']['output']>;
  hiv: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  kidneyOrLiverDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use kidneyOrLiverDisease instead */
  kidney_or_liver_disease: Maybe<Scalars['Boolean']['output']>;
  kneeInjuryOrSurgery: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use kneeInjuryOrSurgery instead */
  knee_injury_or_surgery: Maybe<Scalars['Boolean']['output']>;
  mentalHealth: Maybe<Scalars['Boolean']['output']>;
  mentalIllness: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use mentalIllness instead */
  mental_illness: Maybe<Scalars['Boolean']['output']>;
  mortalityAnalysisDescription: Maybe<Scalars['String']['output']>;
  mortalityAnalysisPerformed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use mortalityAnalysisDescription instead */
  mortality_analysis_description: Maybe<Scalars['String']['output']>;
  /** @deprecated Use mortalityAnalysisPerformed instead */
  mortality_analysis_performed: Maybe<Scalars['Boolean']['output']>;
  mostRecentPhysicalExamAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use mostRecentPhysicalExamAt instead */
  most_recent_physical_exam_at: Maybe<Scalars['DateTime']['output']>;
  multipleSclerosis: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use multipleSclerosis instead */
  multiple_sclerosis: Maybe<Scalars['Boolean']['output']>;
  nursingHome: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use nursingHome instead */
  nursing_home: Maybe<Scalars['Boolean']['output']>;
  otherHealthIssues: Maybe<Scalars['String']['output']>;
  otherSeriousMedicalConditions: Maybe<Scalars['Boolean']['output']>;
  otherSeriousMedicalConditionsDate: Maybe<Scalars['DateTime']['output']>;
  otherSeriousMedicalConditionsDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherHealthIssues instead */
  other_health_issues: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherSeriousMedicalConditions instead */
  other_serious_medical_conditions: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherSeriousMedicalConditionsDate instead */
  other_serious_medical_conditions_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use otherSeriousMedicalConditionsDetails instead */
  other_serious_medical_conditions_details: Maybe<Scalars['String']['output']>;
  rheumatoidArthritis: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use rheumatoidArthritis instead */
  rheumatoid_arthritis: Maybe<Scalars['Boolean']['output']>;
  seriousHealthConditions: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use seriousHealthConditions instead */
  serious_health_conditions: Maybe<Scalars['Boolean']['output']>;
  sleepApnea: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use sleepApnea instead */
  sleep_apnea: Maybe<Scalars['Boolean']['output']>;
  stroke: Maybe<Scalars['Boolean']['output']>;
  ulcerativeColitisOrIleitis: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ulcerativeColitisOrIleitis instead */
  ulcerative_colitis_or_ileitis: Maybe<Scalars['Boolean']['output']>;
  upcomingSurgeries: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use upcomingSurgeries instead */
  upcoming_surgeries: Maybe<Scalars['Boolean']['output']>;
  vascularDisease: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use vascularDisease instead */
  vascular_disease: Maybe<Scalars['Boolean']['output']>;
  walkerWheelchairOxygen: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use walkerWheelchairOxygen instead */
  walker_wheelchair_oxygen: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of HealthProfileUpdateMutation */
export type HealthProfileUpdateMutationInput = {
  aids?: InputMaybe<Scalars['Boolean']['input']>;
  alzheimer_disease?: InputMaybe<Scalars['Boolean']['input']>;
  asthma?: InputMaybe<Scalars['Boolean']['input']>;
  back_problems?: InputMaybe<Scalars['Boolean']['input']>;
  basal_cell_skin_cancer?: InputMaybe<Scalars['Boolean']['input']>;
  cancer?: InputMaybe<Scalars['Boolean']['input']>;
  carpal_tunnel?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codp?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  daily_living_assistance?: InputMaybe<Scalars['Boolean']['input']>;
  depression?: InputMaybe<Scalars['Boolean']['input']>;
  detailed_medical_information?: InputMaybe<Scalars['String']['input']>;
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  emphysema?: InputMaybe<Scalars['Boolean']['input']>;
  epilepsy?: InputMaybe<Scalars['Boolean']['input']>;
  family_history_of_disease?: InputMaybe<Scalars['Boolean']['input']>;
  glaucoma?: InputMaybe<Scalars['Boolean']['input']>;
  headaches_or_migranes?: InputMaybe<Scalars['Boolean']['input']>;
  health_rating?: InputMaybe<Scalars['String']['input']>;
  heart_disease?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_asthma?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_depression?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_high_blood_pressure?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_high_cholesterol?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_sleep_apnea?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_tobacco_use?: InputMaybe<Scalars['Boolean']['input']>;
  hiv?: InputMaybe<Scalars['Boolean']['input']>;
  kidney_or_liver_disease?: InputMaybe<Scalars['Boolean']['input']>;
  knee_injury_or_surgery?: InputMaybe<Scalars['Boolean']['input']>;
  mental_health?: InputMaybe<Scalars['Boolean']['input']>;
  mental_illness?: InputMaybe<Scalars['Boolean']['input']>;
  mortality_analysis_description?: InputMaybe<Scalars['String']['input']>;
  mortality_analysis_performed?: InputMaybe<Scalars['Boolean']['input']>;
  most_recent_physical_exam_at?: InputMaybe<Scalars['DateTime']['input']>;
  multiple_sclerosis?: InputMaybe<Scalars['Boolean']['input']>;
  nursing_home?: InputMaybe<Scalars['Boolean']['input']>;
  other_health_issues?: InputMaybe<Scalars['String']['input']>;
  other_serious_medical_conditions?: InputMaybe<Scalars['Boolean']['input']>;
  other_serious_medical_conditions_date?: InputMaybe<Scalars['DateTime']['input']>;
  other_serious_medical_conditions_details?: InputMaybe<Scalars['String']['input']>;
  rheumatoid_arthritis?: InputMaybe<Scalars['Boolean']['input']>;
  sleep_apnea?: InputMaybe<Scalars['Boolean']['input']>;
  stroke?: InputMaybe<Scalars['Boolean']['input']>;
  ulcerative_colitis_or_ileitis?: InputMaybe<Scalars['Boolean']['input']>;
  upcoming_surgeries?: InputMaybe<Scalars['Boolean']['input']>;
  vascular_disease?: InputMaybe<Scalars['Boolean']['input']>;
  walker_wheelchair_oxygen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeartAttackProfile = OtherConditionProfile & {
  __typename?: 'HeartAttackProfile';
  dateOfLastEpisode: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfLastEpisode instead */
  date_of_last_episode: Maybe<Scalars['DateTime']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  historyOfCondition: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfCondition instead */
  history_of_condition: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use internalDetails instead */
  internal_details: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Use isValid instead */
  is_valid: Scalars['Boolean']['output'];
  otherDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherDetails instead */
  other_details: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HeartAttackProfileUpdateMutation */
export type HeartAttackProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_last_episode?: InputMaybe<Scalars['DateTime']['input']>;
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  history_of_condition?: InputMaybe<Scalars['Boolean']['input']>;
  internal_details?: InputMaybe<Scalars['String']['input']>;
  other_details?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of HipaaCreateMutation */
export type HipaaCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  timestamp: Scalars['Int']['input'];
};

export type HipaaPreAuth = {
  __typename?: 'HipaaPreAuth';
  url: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HipaaPreAuthCreateMutation */
export type HipaaPreAuthCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  life_application_id: Scalars['ID']['input'];
};

export type HomeAndAutoApplicant = {
  __typename?: 'HomeAndAutoApplicant';
  auto: Maybe<Scalars['Boolean']['output']>;
  date_of_birth: Maybe<Scalars['DateTime']['output']>;
  defensive_driving_date: Maybe<Scalars['DateTime']['output']>;
  defensive_driving_last_3_years: Maybe<Scalars['Boolean']['output']>;
  driver_license_number: Maybe<Scalars['String']['output']>;
  driver_license_state_of_issue: Maybe<Scalars['String']['output']>;
  driver_license_state_of_issue_id: Maybe<Scalars['Int']['output']>;
  driver_license_status_id: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  full_name: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  good_student: Maybe<Scalars['Boolean']['output']>;
  home: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  lives_one_hundred_miles_away: Maybe<Scalars['Boolean']['output']>;
  marital_status: Maybe<Scalars['String']['output']>;
  occupation: Maybe<HomeAndAutoOccupation>;
  /** @deprecated Use occupation.id */
  occupation_id: Maybe<Scalars['ID']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  relationship_to_applicant: Maybe<Scalars['String']['output']>;
  social_security_number: Maybe<Scalars['String']['output']>;
};

export type HomeAndAutoApplicantInputType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  applicant_type?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  defensive_driving_date?: InputMaybe<Scalars['DateTime']['input']>;
  defensive_driving_last_3_years?: InputMaybe<Scalars['Boolean']['input']>;
  driver_license_number?: InputMaybe<Scalars['String']['input']>;
  driver_license_state_of_issue_id?: InputMaybe<Scalars['Int']['input']>;
  driver_license_status_id?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  good_student?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lives_one_hundred_miles_away?: InputMaybe<Scalars['Boolean']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  occupation_id?: InputMaybe<Scalars['ID']['input']>;
  product_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relationship_to_applicant?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicants = {
  __typename?: 'HomeAndAutoApplicants';
  additional_drivers: Maybe<Array<Maybe<HomeAndAutoApplicant>>>;
  co_applicant: Maybe<HomeAndAutoApplicant>;
  co_applicants: Maybe<HomeAndAutoApplicant>;
  primary_applicant: Maybe<HomeAndAutoApplicant>;
};

/** Autogenerated input type of HomeAndAutoApplicantsUpdateMutation */
export type HomeAndAutoApplicantsUpdateMutationInput = {
  applicants?: InputMaybe<Array<InputMaybe<HomeAndAutoApplicantInputType>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
};

export type HomeAndAutoApplication = {
  __typename?: 'HomeAndAutoApplication';
  application_data: Maybe<HomeAndAutoApplicationData>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  current_in_force_policies: Maybe<Array<Maybe<HomeAndAutoApplicationInForcePolicyType>>>;
  existing_policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoPolicyType>>>;
  /** @deprecated Use application data or quote */
  external_data: Maybe<HomeAndAutoApplicationExternalData>;
  final_quotes: Maybe<Array<Maybe<UmbrellaHomeAndAutoQuoteFinalType>>>;
  id: Scalars['ID']['output'];
  in_force_policies: Maybe<Array<Maybe<HomeAndAutoApplicationInForcePolicyType>>>;
  internal_case: Maybe<InternalCase>;
  is_latest_transaction: Maybe<Scalars['Boolean']['output']>;
  is_read_only: Maybe<Scalars['Boolean']['output']>;
  quote_estimates: Maybe<Array<Maybe<UmbrellaHomeAndAutoQuoteEstimatesType>>>;
  quote_final: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
  reference_id: Maybe<Scalars['ID']['output']>;
  reshopped_in_force_policies: Maybe<Array<Maybe<HomeAndAutoApplicationInForcePolicyType>>>;
  reshopped_internal_case: Maybe<InternalCase>;
  shopping_reason: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationAddressUpdateMutation */
export type HomeAndAutoApplicationAddressUpdateMutationInput = {
  address_type?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  state_id?: InputMaybe<Scalars['Int']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  street_2?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicationAutoCoverageInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicationCoverageDeductibleInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicationCoverageDeductibleType = {
  __typename?: 'HomeAndAutoApplicationCoverageDeductibleType';
  format: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type HomeAndAutoApplicationCoveragesType = {
  __typename?: 'HomeAndAutoApplicationCoveragesType';
  coverages: Maybe<Array<Maybe<HomeAndAutoApplicationCoverageDeductibleType>>>;
  deductibles: Maybe<Array<Maybe<HomeAndAutoApplicationCoverageDeductibleType>>>;
  reference_id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationCreateMutation */
export type HomeAndAutoApplicationCreateMutationInput = {
  additional_notes?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  life_application_reference_id?: InputMaybe<Scalars['String']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  pnc_shopper_reason?: InputMaybe<Scalars['String']['input']>;
  shopping_reason?: InputMaybe<Scalars['String']['input']>;
  square_footage?: InputMaybe<Scalars['Int']['input']>;
  state_id?: InputMaybe<Scalars['Int']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  street_2?: InputMaybe<Scalars['String']['input']>;
  vertical_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicationData = {
  __typename?: 'HomeAndAutoApplicationData';
  additional_coverage_preferences: Maybe<Array<Maybe<UmbrellaHomeAndAutoAdditionalCoveragePreferenceType>>>;
  addresses: Maybe<Array<Maybe<AddressType>>>;
  applicants: Maybe<HomeAndAutoApplicants>;
  auto_application: Maybe<Scalars['Boolean']['output']>;
  auto_policy_preferences: Maybe<HomeAndAutoAutoPolicyPreferencesType>;
  home_application: Maybe<Scalars['Boolean']['output']>;
  home_details: Maybe<HomeAndAutoApplicationHomeDetailsType>;
  home_policy_preferences: Maybe<HomeAndAutoHomePolicyPreferencesType>;
  home_property: Maybe<HomeAndAutoApplicationHomePropertyType>;
  id: Maybe<Scalars['ID']['output']>;
  more_home_details: Maybe<HomeAndAutoApplicationMoreHomeDetailsType>;
  mortgages: Maybe<Array<Maybe<HomeAndAutoApplicationMortgageType>>>;
  property_accessory_profile: Maybe<HomeAndAutoPropertyAccessoryProfile>;
  vehicles: Maybe<Array<Maybe<HomeAndAutoApplicationVehicleType>>>;
  verticals: Maybe<Array<Maybe<UmbrellaHomeAndAutoVerticalType>>>;
};

export type HomeAndAutoApplicationExternalData = {
  __typename?: 'HomeAndAutoApplicationExternalData';
  ezlynx_url: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** @deprecated This value live in Umbrella::HomeAndAuto::QuoteFinalType or Umbrella::HomeAndAuto::QuoteEstimateType instead of ExternalDataType */
  slide_url: Maybe<Scalars['String']['output']>;
};

export type HomeAndAutoApplicationHomeDetailsType = {
  __typename?: 'HomeAndAutoApplicationHomeDetailsType';
  aggressive_dogs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  basement_type: Maybe<Scalars['String']['output']>;
  dogs_on_premises: Maybe<Scalars['Boolean']['output']>;
  foundation_type: Maybe<Scalars['String']['output']>;
  has_business_or_daycare: Maybe<Scalars['Boolean']['output']>;
  has_dog_bitten: Maybe<Scalars['Boolean']['output']>;
  heating_system: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  inground_fuel_tank: Maybe<Scalars['Boolean']['output']>;
  is_swimming_pool_fenced: Maybe<Scalars['Boolean']['output']>;
  occupancy_notes: Maybe<Scalars['String']['output']>;
  reference_id: Maybe<Scalars['ID']['output']>;
  swimming_pool_diving_board: Maybe<Scalars['Boolean']['output']>;
  swimming_pool_on_premises: Maybe<Scalars['Boolean']['output']>;
  trampoline_has_net: Maybe<Scalars['Boolean']['output']>;
  trampoline_on_premises: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationHomeDetailsUpdateMutation */
export type HomeAndAutoApplicationHomeDetailsUpdateMutationInput = {
  aggressive_dogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  basement_type?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogs_on_premises?: InputMaybe<Scalars['Boolean']['input']>;
  foundation_type?: InputMaybe<Scalars['String']['input']>;
  has_business_or_daycare?: InputMaybe<Scalars['Boolean']['input']>;
  has_dog_bitten?: InputMaybe<Scalars['Boolean']['input']>;
  heating_system?: InputMaybe<Scalars['String']['input']>;
  inground_fuel_tank?: InputMaybe<Scalars['Boolean']['input']>;
  is_swimming_pool_fenced?: InputMaybe<Scalars['Boolean']['input']>;
  occupancy_notes?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  swimming_pool_diving_board?: InputMaybe<Scalars['Boolean']['input']>;
  swimming_pool_on_premises?: InputMaybe<Scalars['Boolean']['input']>;
  trampoline_has_net?: InputMaybe<Scalars['Boolean']['input']>;
  trampoline_on_premises?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeAndAutoApplicationHomePropertyType = {
  __typename?: 'HomeAndAutoApplicationHomePropertyType';
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  architectural_style_id: Maybe<Scalars['Int']['output']>;
  closing_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  construction_type_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  feet_from_hydrant: Maybe<Scalars['Int']['output']>;
  home_type: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  landlord: Maybe<Scalars['Boolean']['output']>;
  live_in_property: Maybe<Scalars['Boolean']['output']>;
  met_previous_address_requirement: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  miles_from_fire_station: Maybe<Scalars['Int']['output']>;
  mortgage: Maybe<Scalars['Boolean']['output']>;
  new_construction: Maybe<Scalars['Boolean']['output']>;
  new_purchase: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  number_of_bathrooms: Maybe<Scalars['Int']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  number_of_bedrooms: Maybe<Scalars['Int']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  number_of_stories: Maybe<Scalars['Int']['output']>;
  primary_home: Maybe<Scalars['Boolean']['output']>;
  reference_id: Maybe<Scalars['ID']['output']>;
  renovations: Maybe<Array<Maybe<HomeAndAutoApplicationRenovationType>>>;
  rent_out: Maybe<Scalars['Boolean']['output']>;
  rental_type: Maybe<Scalars['String']['output']>;
  renter: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  replacement_cost: Maybe<Scalars['ID']['output']>;
  /** @deprecated This value is no longer used in the Home And Auto microservice backend */
  residence_status_id: Maybe<Scalars['ID']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  roof_type_id: Maybe<Scalars['Int']['output']>;
  secondary_home: Maybe<Scalars['Boolean']['output']>;
  shopping_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  square_footage: Maybe<Scalars['Int']['output']>;
  vacant: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This value lives in MoreHomeDetailType instead of HomePropertyType */
  year_built: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationHomePropertyUpdateMutation */
export type HomeAndAutoApplicationHomePropertyUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  closing_date?: InputMaybe<Scalars['DateTime']['input']>;
  home_type?: InputMaybe<Scalars['String']['input']>;
  landlord?: InputMaybe<Scalars['Boolean']['input']>;
  live_in_property?: InputMaybe<Scalars['Boolean']['input']>;
  met_previous_address_requirement?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  new_purchase?: InputMaybe<Scalars['Boolean']['input']>;
  primary_home?: InputMaybe<Scalars['Boolean']['input']>;
  reference_id: Scalars['ID']['input'];
  renovations?: InputMaybe<Array<InputMaybe<RenovationInput>>>;
  rent_out?: InputMaybe<Scalars['Boolean']['input']>;
  rental_type?: InputMaybe<Scalars['String']['input']>;
  renter?: InputMaybe<Scalars['Boolean']['input']>;
  secondary_home?: InputMaybe<Scalars['Boolean']['input']>;
  shopping_reason?: InputMaybe<Scalars['String']['input']>;
  vacant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeAndAutoApplicationInForcePolicyType = {
  __typename?: 'HomeAndAutoApplicationInForcePolicyType';
  active: Maybe<Scalars['Boolean']['output']>;
  application_reference_id: Maybe<Scalars['ID']['output']>;
  became_broker_date: Maybe<Scalars['DateTime']['output']>;
  carrier_policy_number: Maybe<Scalars['String']['output']>;
  effective_date: Maybe<Scalars['DateTime']['output']>;
  expiration_date: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  last_updated_by: Maybe<Scalars['String']['output']>;
  payment_method_type: Maybe<UmbrellaHomeAndAutoPaymentMethodType>;
  payment_mode_type: Maybe<UmbrellaHomeAndAutoPaymentModeType>;
  policy: Maybe<UmbrellaHomeAndAutoPolicyType>;
  policy_id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use application_reference_id instead */
  reference_id: Maybe<Scalars['ID']['output']>;
  renewal_offer: Maybe<UmbrellaHomeAndAutoRenewalOfferType>;
  supports_sync: Maybe<Scalars['Boolean']['output']>;
  update_event_id: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type HomeAndAutoApplicationMoreHomeDetailsType = {
  __typename?: 'HomeAndAutoApplicationMoreHomeDetailsType';
  architectural_style: Maybe<Scalars['String']['output']>;
  architectural_style_id: Maybe<Scalars['ID']['output']>;
  construction_type: Maybe<Scalars['String']['output']>;
  construction_type_id: Maybe<Scalars['ID']['output']>;
  feet_from_hydrant: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  miles_from_fire_station: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms: Maybe<Scalars['Int']['output']>;
  number_of_stories: Maybe<Scalars['Float']['output']>;
  reference_id: Maybe<Scalars['ID']['output']>;
  replacement_cost: Maybe<Scalars['Float']['output']>;
  roof_design: Maybe<Scalars['String']['output']>;
  roof_design_id: Maybe<Scalars['ID']['output']>;
  roof_type: Maybe<Scalars['String']['output']>;
  roof_type_id: Maybe<Scalars['ID']['output']>;
  square_footage: Maybe<Scalars['Int']['output']>;
  year_built: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationMoreHomeDetailsUpdateMutation */
export type HomeAndAutoApplicationMoreHomeDetailsUpdateMutationInput = {
  architectural_style?: InputMaybe<Scalars['String']['input']>;
  architectural_style_id?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  construction_type?: InputMaybe<Scalars['String']['input']>;
  construction_type_id?: InputMaybe<Scalars['ID']['input']>;
  feet_from_hydrant?: InputMaybe<Scalars['Int']['input']>;
  miles_from_fire_station?: InputMaybe<Scalars['Float']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_stories?: InputMaybe<Scalars['Int']['input']>;
  reference_id: Scalars['ID']['input'];
  replacement_cost?: InputMaybe<Scalars['Float']['input']>;
  roof_design?: InputMaybe<Scalars['String']['input']>;
  roof_design_id?: InputMaybe<Scalars['ID']['input']>;
  roof_type?: InputMaybe<Scalars['String']['input']>;
  roof_type_id?: InputMaybe<Scalars['ID']['input']>;
  square_footage?: InputMaybe<Scalars['Int']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeAndAutoApplicationMortgageType = {
  __typename?: 'HomeAndAutoApplicationMortgageType';
  id: Maybe<Scalars['ID']['output']>;
  loan_number: Maybe<Scalars['String']['output']>;
  mortgage_clause_term: Maybe<Scalars['String']['output']>;
  mortgage_company: Maybe<HomeAndAutoApplicationThirdPartyCompanyType>;
  mortgage_contact: Maybe<HomeAndAutoApplicationThirdPartyContactType>;
  name: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationMortgageUpdateMutation */
export type HomeAndAutoApplicationMortgageUpdateMutationInput = {
  address_id?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['ID']['input']>;
  company_name?: InputMaybe<Scalars['ID']['input']>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  loan_number?: InputMaybe<Scalars['String']['input']>;
  mortgage_clause_term?: InputMaybe<Scalars['String']['input']>;
  mortgage_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  state_id?: InputMaybe<Scalars['Int']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoApplicationMutation = {
  __typename?: 'HomeAndAutoApplicationMutation';
  address_update: Maybe<HomeAndAutoApplicationData>;
  applicants_update: Maybe<HomeAndAutoApplicationData>;
  application_create: Maybe<HomeAndAutoApplication>;
  home_details_update: Maybe<HomeAndAutoApplicationHomeDetailsType>;
  home_property_update: Maybe<HomeAndAutoApplicationHomePropertyType>;
  more_home_details_update: Maybe<HomeAndAutoApplicationMoreHomeDetailsType>;
  mortgage_update: Maybe<HomeAndAutoApplicationMortgageType>;
  product_type_update: Maybe<HomeAndAutoApplication>;
  property_accessory_profile_update: Maybe<HomeAndAutoPropertyAccessoryProfile>;
  update_auto_coverages: Maybe<Scalars['Boolean']['output']>;
  update_coverages: Maybe<HomeAndAutoApplicationCoveragesType>;
  vehicles_update: Maybe<HomeAndAutoApplicationData>;
};


export type HomeAndAutoApplicationMutationAddress_UpdateArgs = {
  input: HomeAndAutoApplicationAddressUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationApplicants_UpdateArgs = {
  input: HomeAndAutoApplicantsUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationApplication_CreateArgs = {
  input: HomeAndAutoApplicationCreateMutationInput;
};


export type HomeAndAutoApplicationMutationHome_Details_UpdateArgs = {
  input: HomeAndAutoApplicationHomeDetailsUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationHome_Property_UpdateArgs = {
  input: HomeAndAutoApplicationHomePropertyUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationMore_Home_Details_UpdateArgs = {
  input: HomeAndAutoApplicationMoreHomeDetailsUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationMortgage_UpdateArgs = {
  input: HomeAndAutoApplicationMortgageUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationProduct_Type_UpdateArgs = {
  input: HomeAndAutoApplicationProductTypeUpdateMutationInput;
};


export type HomeAndAutoApplicationMutationProperty_Accessory_Profile_UpdateArgs = {
  input: HomeAndAutoApplicationPropertyAccessoryProfileMutationInput;
};


export type HomeAndAutoApplicationMutationUpdate_Auto_CoveragesArgs = {
  input: HomeAndAutoApplicationUpdateAutoCoveragesMutationInput;
};


export type HomeAndAutoApplicationMutationUpdate_CoveragesArgs = {
  input: HomeAndAutoApplicationUpdateCoveragesMutationInput;
};


export type HomeAndAutoApplicationMutationVehicles_UpdateArgs = {
  input: HomeAndAutoApplicationVehiclesUpdateMutationInput;
};

/** Autogenerated input type of HomeAndAutoApplicationProductTypeUpdateMutation */
export type HomeAndAutoApplicationProductTypeUpdateMutationInput = {
  additional_coverage_preferences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  auto_application?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  home_application?: InputMaybe<Scalars['Boolean']['input']>;
  reference_id: Scalars['ID']['input'];
  referring_organization?: InputMaybe<Scalars['String']['input']>;
  vertical_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Autogenerated input type of HomeAndAutoApplicationPropertyAccessoryProfileMutation */
export type HomeAndAutoApplicationPropertyAccessoryProfileMutationInput = {
  automatic_sprinklers?: InputMaybe<Scalars['Boolean']['input']>;
  automatic_sprinklers_room_locations?: InputMaybe<Scalars['String']['input']>;
  central_burglar_alarm?: InputMaybe<Scalars['Boolean']['input']>;
  central_fire_alarm?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deadbolt?: InputMaybe<Scalars['Boolean']['input']>;
  fire_extinguisher?: InputMaybe<Scalars['Boolean']['input']>;
  reference_id: Scalars['ID']['input'];
  smoke_detectors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeAndAutoApplicationRenovationType = {
  __typename?: 'HomeAndAutoApplicationRenovationType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type HomeAndAutoApplicationThirdPartyCompanyType = {
  __typename?: 'HomeAndAutoApplicationThirdPartyCompanyType';
  address: Maybe<AddressType>;
  addresses: Maybe<Array<Maybe<AddressType>>>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type HomeAndAutoApplicationThirdPartyContactType = {
  __typename?: 'HomeAndAutoApplicationThirdPartyContactType';
  email: Maybe<Scalars['String']['output']>;
  fax_number: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationUpdateAutoCoveragesMutation */
export type HomeAndAutoApplicationUpdateAutoCoveragesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<HomeAndAutoApplicationAutoCoverageInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<HomeAndAutoApplicationAutoCoverageInput>>>;
  reference_id: Scalars['ID']['input'];
};

/** Autogenerated input type of HomeAndAutoApplicationUpdateCoveragesMutation */
export type HomeAndAutoApplicationUpdateCoveragesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<HomeAndAutoApplicationCoverageDeductibleInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<HomeAndAutoApplicationCoverageDeductibleInput>>>;
  reference_id: Scalars['ID']['input'];
};

export type HomeAndAutoApplicationVehicleType = {
  __typename?: 'HomeAndAutoApplicationVehicleType';
  coverages: Maybe<Array<Maybe<UmbrellaHomeAndAutoCoverageDeductibleType>>>;
  deductibles: Maybe<Array<Maybe<UmbrellaHomeAndAutoCoverageDeductibleType>>>;
  id: Maybe<Scalars['ID']['output']>;
  make: Maybe<Scalars['String']['output']>;
  miles_driven_per_year: Maybe<Scalars['Int']['output']>;
  model: Maybe<Scalars['String']['output']>;
  new_purchase: Maybe<Scalars['Boolean']['output']>;
  primary_driver_id: Maybe<Scalars['ID']['output']>;
  primary_use: Maybe<Scalars['String']['output']>;
  purchase_type: Maybe<Scalars['String']['output']>;
  sub_model: Maybe<Scalars['String']['output']>;
  telematics: Maybe<Scalars['Boolean']['output']>;
  use_for_delivery: Maybe<Scalars['Boolean']['output']>;
  use_for_rideshare: Maybe<Scalars['Boolean']['output']>;
  vehicle_identification_number: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of HomeAndAutoApplicationVehiclesUpdateMutation */
export type HomeAndAutoApplicationVehiclesUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  vehicles?: InputMaybe<Array<InputMaybe<VehicleInput>>>;
};

export type HomeAndAutoAutoPolicyPreferencesType = {
  __typename?: 'HomeAndAutoAutoPolicyPreferencesType';
  bodily_injury: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  medical_payments: Maybe<Scalars['String']['output']>;
  property_damage: Maybe<Scalars['String']['output']>;
  underinsured_motorist_bodily_injury: Maybe<Scalars['String']['output']>;
  uninsured_motorist_bodily_injury: Maybe<Scalars['String']['output']>;
  vehicle_policy_preferences: Maybe<Array<Maybe<HomeAndAutoVehiclePolicyPreferencesType>>>;
};

/** Autogenerated input type of HomeAndAutoBundleAddMutation */
export type HomeAndAutoBundleAddMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quote_id: Scalars['ID']['input'];
  section_id: Scalars['ID']['input'];
  vertical_names: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Autogenerated input type of HomeAndAutoBundleDeleteMutation */
export type HomeAndAutoBundleDeleteMutationInput = {
  bundle_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoBundleMutation = {
  __typename?: 'HomeAndAutoBundleMutation';
  bundle_add: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
  bundle_delete: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
};


export type HomeAndAutoBundleMutationBundle_AddArgs = {
  input: HomeAndAutoBundleAddMutationInput;
};


export type HomeAndAutoBundleMutationBundle_DeleteArgs = {
  input: HomeAndAutoBundleDeleteMutationInput;
};

export type HomeAndAutoCoverageDeductibleInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoDwellingEndorsementInput = {
  building_additions_alterations_amount?: InputMaybe<Scalars['Int']['input']>;
  existing_foundation_damage?: InputMaybe<Scalars['Boolean']['input']>;
  foundation_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identity_theft?: InputMaybe<Scalars['Boolean']['input']>;
  increased_coverage_on_credit_card_amount?: InputMaybe<Scalars['Int']['input']>;
  increased_limit_jewelry_watches_fur_amount?: InputMaybe<Scalars['Int']['input']>;
  increased_mold_increase_liability?: InputMaybe<Scalars['Boolean']['input']>;
  increased_mold_property_damage_amount?: InputMaybe<Scalars['Int']['input']>;
  increased_replacement_cost_dwelling_percentage?: InputMaybe<Scalars['Float']['input']>;
  loss_assessment_amount?: InputMaybe<Scalars['Int']['input']>;
  mine_subsidence?: InputMaybe<Scalars['Boolean']['input']>;
  off_premises_theft_exclusion?: InputMaybe<Scalars['Boolean']['input']>;
  ordinance_law_percentage?: InputMaybe<Scalars['Float']['input']>;
  permitted_incidental_business_occupancy?: InputMaybe<Scalars['Boolean']['input']>;
  personal_injury?: InputMaybe<Scalars['Boolean']['input']>;
  replacement_cost_content?: InputMaybe<Scalars['Boolean']['input']>;
  residence_glass?: InputMaybe<Scalars['Boolean']['input']>;
  sinkhole_collapse?: InputMaybe<Scalars['Boolean']['input']>;
  sinkhole_collapse_amount?: InputMaybe<Scalars['Int']['input']>;
  water_backup_amount?: InputMaybe<Scalars['Int']['input']>;
  water_damage?: InputMaybe<Scalars['Boolean']['input']>;
  windstorm_hurricane_hail_exclusion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeAndAutoExistingBusinessPolicyInput = {
  annual_premium?: InputMaybe<Scalars['Float']['input']>;
  carrier_policy_number?: InputMaybe<Scalars['String']['input']>;
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  effective_date?: InputMaybe<Scalars['DateTime']['input']>;
  in_force_policy_id?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  term_in_months?: InputMaybe<Scalars['Int']['input']>;
  vertical_name: Scalars['String']['input'];
};

/** Autogenerated input type of HomeAndAutoExistingPolicyCollectInfoMutation */
export type HomeAndAutoExistingPolicyCollectInfoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  existing_home_auto_policy_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  existing_home_auto_policy_renewal_date?: InputMaybe<Scalars['DateTime']['input']>;
  life_application_id: Scalars['ID']['input'];
};

/** Autogenerated input type of HomeAndAutoExistingPolicyCreateOrUpdateMutation */
export type HomeAndAutoExistingPolicyCreateOrUpdateMutationInput = {
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dwelling_endorsements?: InputMaybe<HomeAndAutoDwellingEndorsementInput>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  not_insured_reason?: InputMaybe<Scalars['String']['input']>;
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  premium_range?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['String']['input'];
  scheduled_personal_properties?: InputMaybe<Array<InputMaybe<HomeAndAutoScheduledPersonalPropertyInput>>>;
  term_in_months?: InputMaybe<Scalars['Float']['input']>;
  vertical_name?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoExistingPolicyMutation = {
  __typename?: 'HomeAndAutoExistingPolicyMutation';
  collect_info: Maybe<UmbrellaHomeAndAutoCollectPolicyInfoType>;
  create_or_update: Maybe<UmbrellaHomeAndAutoPolicyType>;
};


export type HomeAndAutoExistingPolicyMutationCollect_InfoArgs = {
  input: HomeAndAutoExistingPolicyCollectInfoMutationInput;
};


export type HomeAndAutoExistingPolicyMutationCreate_Or_UpdateArgs = {
  input: HomeAndAutoExistingPolicyCreateOrUpdateMutationInput;
};

/** Autogenerated input type of HomeAndAutoEzlynxApplicationCreateOrUpdateMutation */
export type HomeAndAutoEzlynxApplicationCreateOrUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  reference_id: Scalars['ID']['input'];
};

export type HomeAndAutoEzlynxMutation = {
  __typename?: 'HomeAndAutoEzlynxMutation';
  application_create_or_update: Maybe<HomeAndAutoApplicationExternalData>;
};


export type HomeAndAutoEzlynxMutationApplication_Create_Or_UpdateArgs = {
  input: HomeAndAutoEzlynxApplicationCreateOrUpdateMutationInput;
};

export type HomeAndAutoHomePolicyPreferencesType = {
  __typename?: 'HomeAndAutoHomePolicyPreferencesType';
  all_perils: Maybe<Scalars['String']['output']>;
  dwelling: Maybe<Scalars['String']['output']>;
  hurricane: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  increased_replacement_cost_dwelling: Maybe<Scalars['String']['output']>;
  loss_of_use: Maybe<Scalars['String']['output']>;
  medical_payments: Maybe<Scalars['String']['output']>;
  ordinance_or_law: Maybe<Scalars['String']['output']>;
  other_structures: Maybe<Scalars['String']['output']>;
  personal_liability: Maybe<Scalars['String']['output']>;
  personal_property: Maybe<Scalars['String']['output']>;
  theft: Maybe<Scalars['String']['output']>;
  water_backup: Maybe<Scalars['String']['output']>;
  wind_hail: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HomeAndAutoInForcePolicyCreateMutation */
export type HomeAndAutoInForcePolicyCreateMutationInput = {
  became_broker_date: Scalars['DateTime']['input'];
  carrier_policy_number: Scalars['String']['input'];
  carrier_slug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effective_date: Scalars['DateTime']['input'];
  existing_business_policy_id?: InputMaybe<Scalars['ID']['input']>;
  existing_pg_policy_number?: InputMaybe<Scalars['String']['input']>;
  monthly_premium: Scalars['Float']['input'];
  occupancy_type_id?: InputMaybe<Scalars['ID']['input']>;
  payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  payment_mode_id?: InputMaybe<Scalars['ID']['input']>;
  reference_id: Scalars['ID']['input'];
  term_in_months: Scalars['Int']['input'];
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
  vertical_id: Scalars['ID']['input'];
};

/** Autogenerated input type of HomeAndAutoInForcePolicyDeleteMutation */
export type HomeAndAutoInForcePolicyDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  in_force_policy_id: Scalars['ID']['input'];
  reference_id: Scalars['ID']['input'];
};

export type HomeAndAutoInForcePolicyMutation = {
  __typename?: 'HomeAndAutoInForcePolicyMutation';
  create: Maybe<HomeAndAutoApplicationInForcePolicyType>;
  delete: Maybe<HomeAndAutoApplicationInForcePolicyType>;
  update: Maybe<HomeAndAutoApplicationInForcePolicyType>;
};


export type HomeAndAutoInForcePolicyMutationCreateArgs = {
  input: HomeAndAutoInForcePolicyCreateMutationInput;
};


export type HomeAndAutoInForcePolicyMutationDeleteArgs = {
  input: HomeAndAutoInForcePolicyDeleteMutationInput;
};


export type HomeAndAutoInForcePolicyMutationUpdateArgs = {
  input: HomeAndAutoInForcePolicyUpdateMutationInput;
};

/** Autogenerated input type of HomeAndAutoInForcePolicyUpdateMutation */
export type HomeAndAutoInForcePolicyUpdateMutationInput = {
  became_broker_date: Scalars['DateTime']['input'];
  carrier_policy_number: Scalars['String']['input'];
  carrier_slug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effective_date: Scalars['DateTime']['input'];
  in_force_policy_id: Scalars['ID']['input'];
  monthly_premium: Scalars['Float']['input'];
  occupancy_type_id?: InputMaybe<Scalars['ID']['input']>;
  payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  payment_mode_id?: InputMaybe<Scalars['ID']['input']>;
  reference_id: Scalars['ID']['input'];
  term_in_months: Scalars['Int']['input'];
  vertical_id: Scalars['ID']['input'];
};

export type HomeAndAutoMutation = {
  __typename?: 'HomeAndAutoMutation';
  application: Maybe<HomeAndAutoApplicationMutation>;
  bundle: Maybe<HomeAndAutoBundleMutation>;
  existing_policy: Maybe<HomeAndAutoExistingPolicyMutation>;
  ezlynx: Maybe<HomeAndAutoEzlynxMutation>;
  in_force_policy: Maybe<HomeAndAutoInForcePolicyMutation>;
  policy: Maybe<HomeAndAutoPolicyMutation>;
  /** @deprecated Use quote_estimates or quote_final */
  quote: Maybe<HomeAndAutoQuoteMutation>;
  quote_estimates: Maybe<HomeAndAutoQuoteEstimatesMutation>;
  quote_final: Maybe<HomeAndAutoQuoteFinalMutation>;
};

export type HomeAndAutoOccupation = {
  __typename?: 'HomeAndAutoOccupation';
  id: Maybe<Scalars['ID']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  occupation: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HomeAndAutoPolicyCreateOrUpdateMutation */
export type HomeAndAutoPolicyCreateOrUpdateMutationInput = {
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  policy_type?: InputMaybe<Scalars['String']['input']>;
  quote_id: Scalars['ID']['input'];
  section_id: Scalars['ID']['input'];
  vertical_name: Scalars['String']['input'];
};

export type HomeAndAutoPolicyInput = {
  agent_uuid?: InputMaybe<Scalars['String']['input']>;
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  occupancy_type?: InputMaybe<Scalars['String']['input']>;
  savings?: InputMaybe<Scalars['Float']['input']>;
  term_in_months?: InputMaybe<Scalars['Int']['input']>;
  unavailable_rate?: InputMaybe<Scalars['Boolean']['input']>;
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
  vertical_name: Scalars['String']['input'];
};

export type HomeAndAutoPolicyMutation = {
  __typename?: 'HomeAndAutoPolicyMutation';
  policy_create_or_update: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
  policy_remove: Maybe<Scalars['Boolean']['output']>;
  policy_update: Maybe<UmbrellaHomeAndAutoPolicyType>;
};


export type HomeAndAutoPolicyMutationPolicy_Create_Or_UpdateArgs = {
  input: HomeAndAutoPolicyCreateOrUpdateMutationInput;
};


export type HomeAndAutoPolicyMutationPolicy_RemoveArgs = {
  input: HomeAndAutoPolicyRemoveMutationInput;
};


export type HomeAndAutoPolicyMutationPolicy_UpdateArgs = {
  input: HomeAndAutoPolicyUpdateMutationInput;
};

/** Autogenerated input type of HomeAndAutoPolicyRemoveMutation */
export type HomeAndAutoPolicyRemoveMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  policy_id: Scalars['ID']['input'];
};

/** Autogenerated input type of HomeAndAutoPolicyUpdateMutation */
export type HomeAndAutoPolicyUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<HomeAndAutoCoverageDeductibleInput>>>;
  policy_id?: InputMaybe<Scalars['ID']['input']>;
};

export type HomeAndAutoPropertyAccessoryProfile = {
  __typename?: 'HomeAndAutoPropertyAccessoryProfile';
  automatic_sprinklers: Maybe<Scalars['Boolean']['output']>;
  automatic_sprinklers_room_locations: Maybe<Scalars['String']['output']>;
  central_burglar_alarm: Maybe<Scalars['Boolean']['output']>;
  central_fire_alarm: Maybe<Scalars['Boolean']['output']>;
  deadbolt: Maybe<Scalars['Boolean']['output']>;
  fire_extinguisher: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  reference_id: Maybe<Scalars['ID']['output']>;
  smoke_detectors: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of HomeAndAutoQuoteEstimatesCreate */
export type HomeAndAutoQuoteEstimatesCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id: Scalars['ID']['input'];
};

export type HomeAndAutoQuoteEstimatesMutation = {
  __typename?: 'HomeAndAutoQuoteEstimatesMutation';
  quote_estimate_create: Maybe<Scalars['Boolean']['output']>;
  send_estimates_email: Maybe<UmbrellaHomeAndAutoQuoteEstimatesSendEstimatesEmailType>;
};


export type HomeAndAutoQuoteEstimatesMutationQuote_Estimate_CreateArgs = {
  input: HomeAndAutoQuoteEstimatesCreateInput;
};


export type HomeAndAutoQuoteEstimatesMutationSend_Estimates_EmailArgs = {
  input: HomeAndAutoQuoteEstimatesSendEstimatesEmailMutationInput;
};

/** Autogenerated input type of HomeAndAutoQuoteEstimatesSendEstimatesEmailMutation */
export type HomeAndAutoQuoteEstimatesSendEstimatesEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoQuoteFinalMutation = {
  __typename?: 'HomeAndAutoQuoteFinalMutation';
  quote_final_create: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
  quote_section_add: Maybe<Array<Maybe<UmbrellaHomeAndAutoSectionType>>>;
  quote_section_delete: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
};


export type HomeAndAutoQuoteFinalMutationQuote_Final_CreateArgs = {
  input: QuoteFinalCreateMutationInput;
};


export type HomeAndAutoQuoteFinalMutationQuote_Section_AddArgs = {
  input: QuoteFinalSectionAddMutationInput;
};


export type HomeAndAutoQuoteFinalMutationQuote_Section_DeleteArgs = {
  input: HomeAndAutoQuoteFinalSectionDeleteMutationInput;
};

/** Autogenerated input type of HomeAndAutoQuoteFinalSectionDeleteMutation */
export type HomeAndAutoQuoteFinalSectionDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  section_id: Scalars['ID']['input'];
};

export type HomeAndAutoQuoteMutation = {
  __typename?: 'HomeAndAutoQuoteMutation';
  quote_estimate_create: Maybe<Scalars['Boolean']['output']>;
  quote_section_add: Maybe<Array<Maybe<UmbrellaHomeAndAutoSectionType>>>;
  quote_section_delete: Maybe<UmbrellaHomeAndAutoQuoteFinalType>;
};


export type HomeAndAutoQuoteMutationQuote_Estimate_CreateArgs = {
  input: QuoteEstimateCreateInput;
};


export type HomeAndAutoQuoteMutationQuote_Section_AddArgs = {
  input: QuoteSectionAddMutationInput;
};


export type HomeAndAutoQuoteMutationQuote_Section_DeleteArgs = {
  input: HomeAndAutoQuoteSectionDeleteMutationInput;
};

/** Autogenerated input type of HomeAndAutoQuoteSectionDeleteMutation */
export type HomeAndAutoQuoteSectionDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  section_id: Scalars['ID']['input'];
};

export type HomeAndAutoScheduledPersonalPropertyInput = {
  action: Scalars['String']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  breakage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HomeAndAutoVehiclePolicyPreferencesType = {
  __typename?: 'HomeAndAutoVehiclePolicyPreferencesType';
  collision: Maybe<Scalars['String']['output']>;
  comprehensive: Maybe<Scalars['String']['output']>;
  rental_reimbursement: Maybe<Scalars['String']['output']>;
  towing_and_labor: Maybe<Scalars['String']['output']>;
  vehicle_id: Maybe<Scalars['ID']['output']>;
};

export type HomePrefillAddressInputType = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type HouseholdProfile = {
  __typename?: 'HouseholdProfile';
  car: Maybe<Scalars['Boolean']['output']>;
  childcareExpenses: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use childcareExpenses instead */
  childcare_expenses: Maybe<Scalars['Boolean']['output']>;
  dependents: Maybe<Array<Maybe<Dependent>>>;
  hasChildren: Maybe<Scalars['Boolean']['output']>;
  hasKids: Maybe<Scalars['Boolean']['output']>;
  hasOtherDependents: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasChildren instead */
  has_children: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasKids instead */
  has_kids: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasOtherDependents instead */
  has_other_dependents: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use dependents */
  kids: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  livingSituation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use livingSituation instead */
  living_situation: Maybe<Scalars['String']['output']>;
  maritalStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use maritalStatus instead */
  marital_status: Maybe<Scalars['String']['output']>;
  planToPurchaseHome: Maybe<Scalars['Boolean']['output']>;
  planToPurchaseVehicle: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use planToPurchaseHome instead */
  plan_to_purchase_home: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use planToPurchaseVehicle instead */
  plan_to_purchase_vehicle: Maybe<Scalars['Boolean']['output']>;
  spouseInForceAllInsurers: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use spouseInForceAllInsurers instead */
  spouse_in_force_all_insurers: Maybe<Scalars['Int']['output']>;
  vehicleStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use vehicleStatus instead */
  vehicle_status: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of HouseholdProfileUpdateMutation */
export type HouseholdProfileUpdateMutationInput = {
  car?: InputMaybe<Scalars['Boolean']['input']>;
  childcare_expenses?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  dependents?: InputMaybe<Array<InputMaybe<DependentInput>>>;
  has_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_other_dependents?: InputMaybe<Scalars['Boolean']['input']>;
  living_situation?: InputMaybe<Scalars['String']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  plan_to_purchase_home?: InputMaybe<Scalars['Boolean']['input']>;
  plan_to_purchase_vehicle?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_in_force_all_insurers?: InputMaybe<Scalars['Int']['input']>;
  vehicle_status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of HydrateResidenceProfile */
export type HydrateResidenceProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  reference_id?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of IdentificationUpdateMutation */
export type IdentificationUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_number?: InputMaybe<Scalars['String']['input']>;
  id_type?: InputMaybe<Scalars['String']['input']>;
};

/** Demographic and identifiable customer data */
export type IdentityProfile = {
  __typename?: 'IdentityProfile';
  age: Scalars['Int']['output'];
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfBirth instead */
  date_of_birth: Maybe<Scalars['DateTime']['output']>;
  driverLicenseExpirationDate: Maybe<Scalars['DateTime']['output']>;
  driverLicenseIssueDate: Maybe<Scalars['DateTime']['output']>;
  driverLicenseNumber: Maybe<Scalars['String']['output']>;
  driverLicenseStateOfIssue: Maybe<State>;
  /** @deprecated Use driverLicenseExpirationDate instead */
  driver_license_expiration_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use driverLicenseIssueDate instead */
  driver_license_issue_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use driverLicenseNumber instead */
  driver_license_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use driverLicenseStateOfIssue instead */
  driver_license_state_of_issue: Maybe<State>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use firstName instead */
  first_name: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fullName instead */
  full_name: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastName instead */
  last_name: Maybe<Scalars['String']['output']>;
  licensedToDrive: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use licensedToDrive instead */
  licensed_to_drive: Maybe<Scalars['Boolean']['output']>;
  maidenName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use maidenName instead */
  maiden_name: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use middleName instead */
  middle_name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  phoneType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use phoneType instead */
  phone_type: Maybe<Scalars['String']['output']>;
  preferredName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use preferredName instead */
  preferred_name: Maybe<Scalars['String']['output']>;
  previousFirstName: Maybe<Scalars['String']['output']>;
  previousLastName: Maybe<Scalars['String']['output']>;
  previousMiddleName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use previousFirstName instead */
  previous_first_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use previousLastName instead */
  previous_last_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use previousMiddleName instead */
  previous_middle_name: Maybe<Scalars['String']['output']>;
  reasonNoLicense: Maybe<Scalars['String']['output']>;
  /** @deprecated Use reasonNoLicense instead */
  reason_no_license: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IdentityProfileUpdateMutation */
export type IdentityProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  driver_license_expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  driver_license_issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  driver_license_number?: InputMaybe<Scalars['String']['input']>;
  driver_license_state_of_issue_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  licensed_to_drive?: InputMaybe<Scalars['Boolean']['input']>;
  maiden_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_type?: InputMaybe<Scalars['String']['input']>;
  preferred_name?: InputMaybe<Scalars['String']['input']>;
  reason_no_license?: InputMaybe<Scalars['String']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  validate_email?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of IllustrationModification */
export type IllustrationModificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundAllocationPercentageCap?: InputMaybe<Scalars['Int']['input']>;
  fundAllocationPercentageFixed?: InputMaybe<Scalars['Int']['input']>;
  fundAllocationPercentageParticipation?: InputMaybe<Scalars['Int']['input']>;
  paymentAmount?: InputMaybe<Scalars['String']['input']>;
  paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of IllustrationModification */
export type IllustrationModificationPayload = {
  __typename?: 'IllustrationModificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImmigrationProfile = {
  __typename?: 'ImmigrationProfile';
  birthCountry: Maybe<Scalars['String']['output']>;
  birthState: Maybe<State>;
  /** @deprecated Use birthCountry instead */
  birth_country: Maybe<Scalars['String']['output']>;
  /** @deprecated Use birthState instead */
  birth_state: Maybe<State>;
  countryOfOrigin: Maybe<Scalars['String']['output']>;
  /** @deprecated Use countryOfOrigin instead */
  country_of_origin: Maybe<Scalars['String']['output']>;
  dateOfEntryToUs: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfEntryToUs instead */
  date_of_entry_to_us: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lengthOfUsStay: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lengthOfUsStay instead */
  length_of_us_stay: Maybe<Scalars['String']['output']>;
  residencyExpirationDate: Maybe<Scalars['DateTime']['output']>;
  residencyStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use residencyExpirationDate instead */
  residency_expiration_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use residencyStatus instead */
  residency_status: Maybe<Scalars['String']['output']>;
  visaDetails: Maybe<Scalars['String']['output']>;
  visaGreenCardNumber: Maybe<Scalars['String']['output']>;
  visaType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use visaDetails instead */
  visa_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use visaGreenCardNumber instead */
  visa_green_card_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use visaType instead */
  visa_type: Maybe<Scalars['String']['output']>;
  yearsInUnitedStates: Maybe<Scalars['String']['output']>;
  /** @deprecated Use yearsInUnitedStates instead */
  years_in_united_states: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ImmigrationProfileUpdateMutation */
export type ImmigrationProfileUpdateMutationInput = {
  birth_country?: InputMaybe<Scalars['String']['input']>;
  birth_state_id?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country_of_origin?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_entry_to_us?: InputMaybe<Scalars['DateTime']['input']>;
  length_of_us_stay?: InputMaybe<Scalars['String']['input']>;
  residency_expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  residency_status?: InputMaybe<Scalars['String']['input']>;
  visa_details?: InputMaybe<Scalars['String']['input']>;
  visa_green_card_number?: InputMaybe<Scalars['String']['input']>;
  visa_type?: InputMaybe<Scalars['String']['input']>;
  years_in_united_states?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceProfile = {
  __typename?: 'InsuranceProfile';
  currentAutoCarrier: Maybe<Scalars['String']['output']>;
  currentHomeownersCarrier: Maybe<Scalars['String']['output']>;
  currentRentersCarrier: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currentAutoCarrier instead */
  current_auto_carrier: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currentHomeownersCarrier instead */
  current_homeowners_carrier: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currentRentersCarrier instead */
  current_renters_carrier: Maybe<Scalars['String']['output']>;
  disabilityInsuranceSource: Maybe<Scalars['String']['output']>;
  disabilityInsuranceStatus: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use disabilityInsuranceSource instead */
  disability_insurance_source: Maybe<Scalars['String']['output']>;
  /** @deprecated Use disabilityInsuranceStatus instead */
  disability_insurance_status: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  rentersInsuranceStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use rentersInsuranceStatus instead */
  renters_insurance_status: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of InsuranceProfileUpdateMutation */
export type InsuranceProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  current_auto_carrier?: InputMaybe<Scalars['String']['input']>;
  current_homeowners_carrier?: InputMaybe<Scalars['String']['input']>;
  current_renters_carrier?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  disability_insurance_source?: InputMaybe<Scalars['String']['input']>;
  disability_insurance_status?: InputMaybe<Scalars['Boolean']['input']>;
  renters_insurance_status?: InputMaybe<Scalars['String']['input']>;
};

/** Moo spefic insured child specific questions */
export type InsuredChildAdditionalQuestions = {
  __typename?: 'InsuredChildAdditionalQuestions';
  child_born_prematurely: Maybe<Scalars['Boolean']['output']>;
  child_with_disorder: Maybe<Scalars['Boolean']['output']>;
  date_of_birth: Maybe<Scalars['String']['output']>;
  disorder_condition: Maybe<Scalars['String']['output']>;
  disorder_condition_started: Maybe<Scalars['String']['output']>;
  disorder_last_treated: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  has_chronic_condition_in_last_three_years: Maybe<Scalars['Boolean']['output']>;
  has_chronic_condition_in_last_three_years_details: Maybe<Scalars['String']['output']>;
  has_existing_life_insurance: Maybe<Scalars['Boolean']['output']>;
  heart_circulatory_birth_defect_mental: Maybe<Scalars['Boolean']['output']>;
  heart_circulatory_birth_defect_mental_details: Maybe<Scalars['String']['output']>;
  intent_to_replace_existing_contract: Maybe<Scalars['Boolean']['output']>;
  is_interested_in_replacing_life_insurance: Maybe<Scalars['Boolean']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  life_insurance_coverage_amount: Maybe<Scalars['Int']['output']>;
  middle_name: Maybe<Scalars['String']['output']>;
  policy_in_force: Maybe<Scalars['Boolean']['output']>;
  policy_in_force_company: Maybe<Scalars['String']['output']>;
  relationship_to_owner: Maybe<Scalars['String']['output']>;
  replace_in_force_policy: Maybe<Scalars['Boolean']['output']>;
  state_of_residence: Maybe<Scalars['String']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of InsuredChildAdditionalQuestionsUpdateMutation */
export type InsuredChildAdditionalQuestionsUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  child_born_prematurely?: InputMaybe<Scalars['Boolean']['input']>;
  child_with_disorder?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  disorder_condition?: InputMaybe<Scalars['String']['input']>;
  disorder_condition_started?: InputMaybe<Scalars['String']['input']>;
  disorder_last_treated?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_chronic_condition_in_last_three_years?: InputMaybe<Scalars['Boolean']['input']>;
  has_chronic_condition_in_last_three_years_details?: InputMaybe<Scalars['String']['input']>;
  has_existing_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  heart_circulatory_birth_defect_mental?: InputMaybe<Scalars['Boolean']['input']>;
  heart_circulatory_birth_defect_mental_details?: InputMaybe<Scalars['String']['input']>;
  intent_to_replace_existing_contract?: InputMaybe<Scalars['Boolean']['input']>;
  is_interested_in_replacing_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  life_insurance_coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  policy_in_force?: InputMaybe<Scalars['Boolean']['input']>;
  policy_in_force_company?: InputMaybe<Scalars['String']['input']>;
  relationship_to_owner?: InputMaybe<Scalars['String']['input']>;
  replace_in_force_policy?: InputMaybe<Scalars['Boolean']['input']>;
  state_of_residence?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type InternalCase = {
  __typename?: 'InternalCase';
  application: Maybe<CasesApplicationType>;
  appliedForPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use appliedForPolicy instead */
  applied_for_policy: Maybe<Scalars['Boolean']['output']>;
  assignedToProcessAppPgAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use assignedToProcessAppPgAt instead */
  assigned_to_process_app_pg_at: Maybe<Scalars['DateTime']['output']>;
  assignee: Maybe<ElevatedUser>;
  caseAgeInDays: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use caseAgeInDays instead */
  case_age_in_days: Maybe<Scalars['Int']['output']>;
  cc: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commissionSplit: Maybe<CommissionSplitType>;
  conversationId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use conversationId instead */
  conversation_id: Maybe<Scalars['String']['output']>;
  creationMethod: Maybe<Scalars['String']['output']>;
  customer: Maybe<Customer>;
  deliveryDueDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use deliveryDueDate instead */
  delivery_due_date: Maybe<Scalars['DateTime']['output']>;
  followUpDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use followUpDate instead */
  follow_up_date: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  internalCaseAgent: Maybe<InternalCaseAgentType>;
  internalCaseTasks: Maybe<Array<Maybe<UmbrellaInternalCaseTaskType>>>;
  internalCaseTeamMembers: Maybe<Array<Maybe<InternalCaseTeamMember>>>;
  /** @deprecated Use internalCaseAgent instead */
  internal_case_agent: Maybe<InternalCaseAgentType>;
  /** @deprecated Use internalCaseTasks instead */
  internal_case_tasks: Maybe<Array<Maybe<UmbrellaInternalCaseTaskType>>>;
  /** @deprecated Use internalCaseTeamMembers instead */
  internal_case_team_members: Maybe<Array<Maybe<InternalCaseTeamMember>>>;
  /** @deprecated Use application */
  lifeApplication: Maybe<LifeApplication>;
  /** @deprecated Use application */
  life_application: Maybe<LifeApplication>;
  lifecycleStage: Maybe<Scalars['String']['output']>;
  lifecycleStageAgeInDays: Maybe<Scalars['Int']['output']>;
  lifecycleStageStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lifecycleStage instead */
  lifecycle_stage: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lifecycleStageAgeInDays instead */
  lifecycle_stage_age_in_days: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use lifecycleStageStartedAt instead */
  lifecycle_stage_started_at: Maybe<Scalars['DateTime']['output']>;
  milestones: Maybe<Array<Maybe<UmbrellaCasesInternalCaseMilestoneType>>>;
  motivation: Maybe<MotivationType>;
  openForInHours: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use openForInHours instead */
  open_for_in_hours: Maybe<Scalars['Int']['output']>;
  policyNumber: Maybe<Scalars['String']['output']>;
  policyStartDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use policyNumber instead */
  policy_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyStartDate instead */
  policy_start_date: Maybe<Scalars['DateTime']['output']>;
  productId: Maybe<Scalars['ID']['output']>;
  productType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use productId instead */
  product_id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use productType instead */
  product_type: Maybe<Scalars['String']['output']>;
  queuedMacro: Maybe<Macro>;
  queuedMacroShortcode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use queuedMacro instead */
  queued_macro: Maybe<Macro>;
  /** @deprecated Use queuedMacroShortcode instead */
  queued_macro_shortcode: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use referenceId instead */
  reference_id: Maybe<Scalars['ID']['output']>;
  referringOrganization: Maybe<Scalars['String']['output']>;
  relationships: Maybe<Array<Maybe<InternalCaseRelationship>>>;
  spousalLink: Maybe<SpousalLink>;
  /** @deprecated Use spousalLink instead */
  spousal_link: Maybe<SpousalLink>;
  status: Maybe<InternalCaseStatus>;
  tags: Maybe<Array<UmbrellaMetadataTagType>>;
  /** @deprecated Use internal case team members */
  teamMembers: Maybe<Array<Maybe<ElevatedUser>>>;
  /** @deprecated Use internal case team members */
  team_members: Maybe<Array<Maybe<ElevatedUser>>>;
  transamericaInterview: Maybe<TransamericaInterview>;
  umbrellaOnly: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use umbrellaOnly instead */
  umbrella_only: Maybe<Scalars['Boolean']['output']>;
};

/** Grpc agent of internal case agent */
export type InternalCaseAgentType = {
  __typename?: 'InternalCaseAgentType';
  agencyCode: Maybe<Scalars['String']['output']>;
  agencyName: Maybe<Scalars['String']['output']>;
  agencyType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use agencyName instead */
  agency_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use agencyType instead */
  agency_type: Maybe<Scalars['String']['output']>;
  agentCode: Maybe<Scalars['String']['output']>;
  appointmentStatus: Maybe<Scalars['String']['output']>;
  contractedName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use contractedName instead */
  contracted_name: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use firstName instead */
  first_name: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastName instead */
  last_name: Maybe<Scalars['String']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
  writingAgentFirstName: Maybe<Scalars['String']['output']>;
  writingAgentLastName: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of InternalCaseBulkAssign */
export type InternalCaseBulkAssignInput = {
  /** JSON-stringified object of internal cases and assignees */
  assignedApps: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of InternalCaseBulkAssign */
export type InternalCaseBulkAssignPayload = {
  __typename?: 'InternalCaseBulkAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Reference ids for all of the successfully updated internal cases */
  referenceIds: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of InternalCaseBulkUpdateMutation */
export type InternalCaseBulkUpdateMutationInput = {
  assigned_apps?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type InternalCaseMilestoneFilterInput = {
  name: Scalars['String']['input'];
  statuses: Array<InputMaybe<Scalars['String']['input']>>;
};

export type InternalCaseMilestoneInput = {
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type InternalCaseMilestoneStatusesType = {
  __typename?: 'InternalCaseMilestoneStatusesType';
  med_exam: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  packet: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InternalCaseMilestoneSummary = {
  __typename?: 'InternalCaseMilestoneSummary';
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type InternalCaseRelationship = {
  __typename?: 'InternalCaseRelationship';
  id: Maybe<Scalars['ID']['output']>;
  internalCase: Maybe<InternalCase>;
  /** @deprecated Use internalCase instead */
  internal_case: Maybe<InternalCase>;
  relationship: Maybe<Scalars['String']['output']>;
};

export enum InternalCaseStatus {
  /** A cold case */
  Cold = 'COLD',
  /** An on-hold case */
  Hold = 'HOLD',
  /** An unhandled case */
  New = 'NEW',
  /** An open case */
  Open = 'OPEN',
  /** A pending case */
  Pending = 'PENDING',
  /** A solved case */
  Solved = 'SOLVED'
}

/** Autogenerated input type of InternalCaseTaskCreateMutation */
export type InternalCaseTaskCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
};

export type InternalCaseTaskInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  internal_case_id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of InternalCaseTaskUpdateMutation */
export type InternalCaseTaskUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  status_reason?: InputMaybe<Scalars['String']['input']>;
  status_reason_text?: InputMaybe<Scalars['String']['input']>;
};

export type InternalCaseTasksMutation = {
  __typename?: 'InternalCaseTasksMutation';
  internal_case_task_create: Maybe<UmbrellaInternalCaseTaskType>;
  internal_case_task_update: Maybe<UmbrellaInternalCaseTaskType>;
};


export type InternalCaseTasksMutationInternal_Case_Task_CreateArgs = {
  input: InternalCaseTaskCreateMutationInput;
};


export type InternalCaseTasksMutationInternal_Case_Task_UpdateArgs = {
  input: InternalCaseTaskUpdateMutationInput;
};

/** Contributors and owners on an internal case */
export type InternalCaseTeamMember = {
  __typename?: 'InternalCaseTeamMember';
  owner: Maybe<Scalars['Boolean']['output']>;
  teamMember: Maybe<ElevatedUser>;
  /** @deprecated Use teamMember instead */
  team_member: Maybe<ElevatedUser>;
};

export type InternalCaseTeamMemberInput = {
  owner: Scalars['Boolean']['input'];
  team_member_id: Scalars['String']['input'];
};

/** Autogenerated input type of InternalCaseUpdateMutation */
export type InternalCaseUpdateMutationInput = {
  agent_id?: InputMaybe<Scalars['String']['input']>;
  aps_tasks?: InputMaybe<Array<InputMaybe<InternalCaseTaskInput>>>;
  assigned_to_process_app_pg_at?: InputMaybe<Scalars['DateTime']['input']>;
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  case_age_in_days?: InputMaybe<Scalars['Int']['input']>;
  case_manager_id?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  delivery_due_date?: InputMaybe<Scalars['DateTime']['input']>;
  follow_up_date?: InputMaybe<Scalars['DateTime']['input']>;
  internal_case_id: Scalars['ID']['input'];
  lifecycle_stage?: InputMaybe<Scalars['String']['input']>;
  lifecycle_stage_age_in_days?: InputMaybe<Scalars['Int']['input']>;
  lifecycle_stage_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  milestones?: InputMaybe<Array<InputMaybe<InternalCaseMilestoneInput>>>;
  open_for_in_hours?: InputMaybe<Scalars['Int']['input']>;
  pg_pro_referral?: InputMaybe<Scalars['Boolean']['input']>;
  policy_number?: InputMaybe<Scalars['String']['input']>;
  policy_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  queued_macro_shortcode?: InputMaybe<Scalars['String']['input']>;
  referring_agent_email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InternalCaseStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  team_members?: InputMaybe<Array<InputMaybe<InternalCaseTeamMemberInput>>>;
  umbrella_only?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalNoteFeedItem = {
  __typename?: 'InternalNoteFeedItem';
  attachments: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  commenter: Maybe<ElevatedUser>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  shareable_attachments: Maybe<Array<Maybe<ShareableAttachment>>>;
  source: Maybe<Scalars['String']['output']>;
  star: Maybe<Star>;
};

export type LifeApplication = {
  __typename?: 'LifeApplication';
  additionalQuestions: Maybe<AdditionalQuestions>;
  agentStateLicenseConfirmed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use agentStateLicenseConfirmed instead */
  agent_state_license_confirmed: Maybe<Scalars['Boolean']['output']>;
  autogenDetails: Maybe<AutogenDetails>;
  availableProductTypes: Array<LifeProduct>;
  changedOverFromApplications: Maybe<Array<Maybe<LifeApplication>>>;
  changedOverToApplications: Maybe<Array<Maybe<LifeApplication>>>;
  /** @deprecated Use changedOverFromApplications instead */
  changed_over_from_applications: Maybe<Array<Maybe<LifeApplication>>>;
  /** @deprecated Use changedOverToApplications instead */
  changed_over_to_applications: Maybe<Array<Maybe<LifeApplication>>>;
  commonAppCompleted: Scalars['Boolean']['output'];
  complianceProfile: Maybe<ComplianceProfile>;
  /** @deprecated Use complianceProfile instead */
  compliance_profile: Maybe<ComplianceProfile>;
  contingentBeneficiaries: Maybe<Array<Maybe<Beneficiary>>>;
  /** @deprecated Use contingentBeneficiaries instead */
  contingent_beneficiaries: Maybe<Array<Maybe<Beneficiary>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt instead */
  created_at: Maybe<Scalars['DateTime']['output']>;
  customerId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use customerId instead */
  customer_id: Maybe<Scalars['ID']['output']>;
  dssReengaged: Scalars['Boolean']['output'];
  eligibleForCarrierQuotes: Scalars['Boolean']['output'];
  estimatedRevenue: Scalars['Int']['output'];
  /** @deprecated Use estimatedRevenue instead */
  estimated_revenue: Scalars['Int']['output'];
  everlyInterview: EverlyInterview;
  hipaaVoiceAuthorized: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hipaaVoiceAuthorized instead */
  hipaa_voice_authorized: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  idNumber: Maybe<Scalars['String']['output']>;
  idType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use idNumber instead */
  id_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use idType instead */
  id_type: Maybe<Scalars['String']['output']>;
  internalCase: Maybe<InternalCase>;
  /** @deprecated Use internalCase instead */
  internal_case: Maybe<InternalCase>;
  lifeAppliedForCoverage: Maybe<AppliedForCoverage>;
  lifecyclePhase: Maybe<Scalars['String']['output']>;
  lifecycleStage: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lifecyclePhase instead */
  lifecycle_phase: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lifecycleStage instead */
  lifecycle_stage: Maybe<Scalars['String']['output']>;
  newPartnerReferral: Scalars['Boolean']['output'];
  policies: LifeApplicationPolicies;
  policyDecisionReason: Maybe<Scalars['String']['output']>;
  policyDecisionRecommendation: Maybe<Scalars['String']['output']>;
  policyPremiumEstimates: Maybe<LifePolicyPremiumEstimates>;
  /** @deprecated Use policyDecisionReason instead */
  policy_decision_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyDecisionRecommendation instead */
  policy_decision_recommendation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lifeApplication.policies.policyQuestions */
  policy_questions: Maybe<PolicyQuestions>;
  primaryBeneficiaries: Maybe<Array<Maybe<Beneficiary>>>;
  /** @deprecated Use primaryBeneficiaries instead */
  primary_beneficiaries: Maybe<Array<Maybe<Beneficiary>>>;
  referenceId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use referenceId instead */
  reference_id: Maybe<Scalars['ID']['output']>;
  riderDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use riderDetails instead */
  rider_details: Maybe<Scalars['String']['output']>;
  riders: Maybe<Scalars['Boolean']['output']>;
  source: Source;
  spousalConsent: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use spousalConsent instead */
  spousal_consent: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  successfullySubmitted103: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use successfullySubmitted103 instead */
  successfully_submitted_103: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use umbrella.life_application_metadata.zendesk_ticket_id */
  zendesk_ticket_id: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of LifeApplicationAddInternalCaseTagsMutation */
export type LifeApplicationAddInternalCaseTagsMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_tags: Array<Scalars['String']['input']>;
};

/** Autogenerated input type of LifeApplicationAddToDialerMutation */
export type LifeApplicationAddToDialerMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  delay_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type LifeApplicationPolicies = {
  __typename?: 'LifeApplicationPolicies';
  appliedPolicy: Maybe<LifeApplicationPolicy>;
  /** @deprecated Use appliedPolicy instead */
  applied_policy: Maybe<LifeApplicationPolicy>;
  linkedPolicies: Maybe<Array<Maybe<LifeApplicationPolicy>>>;
  /** @deprecated Use linkedPolicies instead */
  linked_policies: Maybe<Array<Maybe<LifeApplicationPolicy>>>;
  policyPreferences: LifePolicyPreferences;
  policyQuestions: PolicyQuestions;
  /** @deprecated Use policyPreferences instead */
  policy_preferences: LifePolicyPreferences;
  /** @deprecated Use policyQuestions instead */
  policy_questions: PolicyQuestions;
  quotedPolicies: Array<LifeApplicationQuotedPolicy>;
  quotedPoliciesForRange: LifeApplicationQuoteRange;
  selectedPolicy: Maybe<LifeApplicationPolicy>;
  /** @deprecated Use selectedPolicy instead */
  selected_policy: Maybe<LifeApplicationPolicy>;
};


export type LifeApplicationPoliciesQuotedPoliciesArgs = {
  coverageAmount?: InputMaybe<Scalars['Int']['input']>;
  productUrns?: InputMaybe<Array<Scalars['String']['input']>>;
  sortByRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  termLength?: InputMaybe<Scalars['Int']['input']>;
  underwritingClass?: InputMaybe<Scalars['String']['input']>;
  usesTobacco?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LifeApplicationPoliciesQuotedPoliciesForRangeArgs = {
  coverageAmount: Scalars['Int']['input'];
  isPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  usesTobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LifeApplicationPolicy = {
  __typename?: 'LifeApplicationPolicy';
  annualPremium: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use annualPremium instead */
  annual_premium: Maybe<Scalars['Float']['output']>;
  auInterviewRequired: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use auInterviewRequired instead */
  au_interview_required: Maybe<Scalars['Boolean']['output']>;
  calculatedInsuranceAge: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use calculatedInsuranceAge instead */
  calculated_insurance_age: Maybe<Scalars['Int']['output']>;
  carrier: Maybe<LifeInsuranceCarrierType>;
  carrierHealthAndTableRatingValues: Maybe<Scalars['String']['output']>;
  carrierLogoUrl: Maybe<Scalars['String']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  carrierShortName: Maybe<Scalars['String']['output']>;
  carrierSlug: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierHealthAndTableRatingValues instead */
  carrier_health_and_table_rating_values: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierLogoUrl instead */
  carrier_logo_url: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierName instead */
  carrier_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierShortName instead */
  carrier_short_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierSlug instead */
  carrier_slug: Maybe<Scalars['String']['output']>;
  coverageAmount: Maybe<Scalars['Int']['output']>;
  coverageReason: Maybe<Scalars['String']['output']>;
  coverageReasonCategory: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageAmount instead */
  coverage_amount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use coverageReason instead */
  coverage_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageReasonCategory instead */
  coverage_reason_category: Maybe<Scalars['String']['output']>;
  customerLifeSegment: Maybe<Scalars['Int']['output']>;
  customerLifeSegmentName: Maybe<Scalars['String']['output']>;
  deliveryDueDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use deliveryDueDate instead */
  delivery_due_date: Maybe<Scalars['DateTime']['output']>;
  guaranteedAge: Maybe<Scalars['Int']['output']>;
  healthCategory: Maybe<Scalars['String']['output']>;
  /** @deprecated Use healthCategory instead */
  health_category: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inForceDate: Maybe<Scalars['DateTime']['output']>;
  inForceYear: Maybe<Scalars['String']['output']>;
  /** @deprecated Use inForceDate instead */
  in_force_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use inForceYear instead */
  in_force_year: Maybe<Scalars['String']['output']>;
  isAgeChange: Maybe<Scalars['Boolean']['output']>;
  isFinancialMod: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isAgeChange instead */
  is_age_change: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isFinancialMod instead */
  is_financial_mod: Maybe<Scalars['Boolean']['output']>;
  issueAge: Maybe<Scalars['Int']['output']>;
  issueType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use issueAge instead */
  issue_age: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use issueType instead */
  issue_type: Maybe<Scalars['String']['output']>;
  lifeApplicationId: Scalars['ID']['output'];
  /** @deprecated Use lifeApplicationId instead */
  life_application_id: Scalars['ID']['output'];
  monthlyPremium: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use monthlyPremium instead */
  monthly_premium: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nextRateChange: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use nextRateChange instead */
  next_rate_change: Maybe<Scalars['DateTime']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  overfundedAmount: Maybe<Scalars['Float']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  payAge: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentMode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentMethod instead */
  payment_method: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentMode instead */
  payment_mode: Maybe<Scalars['String']['output']>;
  persisted: Maybe<Scalars['Boolean']['output']>;
  planIdentifierName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use planIdentifierName instead */
  plan_identifier_name: Maybe<Scalars['String']['output']>;
  policyDecisionType: Maybe<Scalars['String']['output']>;
  policyHistory: Maybe<Array<Maybe<PolicyHistory>>>;
  policyNumber: Maybe<Scalars['String']['output']>;
  policyType: Maybe<Scalars['String']['output']>;
  policyUpdateSource: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyDecisionType instead */
  policy_decision_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyHistory instead */
  policy_history: Maybe<Array<Maybe<PolicyHistory>>>;
  /** @deprecated Use policyNumber instead */
  policy_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyType instead */
  policy_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyUpdateSource instead */
  policy_update_source: Maybe<Scalars['String']['output']>;
  productType: Maybe<Scalars['String']['output']>;
  productUrn: Maybe<Scalars['String']['output']>;
  /** @deprecated Use productType instead */
  product_type: Maybe<Scalars['String']['output']>;
  quarterlyPremium: Maybe<Scalars['Float']['output']>;
  recommendedPolicy: Maybe<Scalars['Boolean']['output']>;
  recommendedProducts: Array<Scalars['String']['output']>;
  relationshipType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use relationshipType instead */
  relationship_type: Maybe<Scalars['String']['output']>;
  replacing: Maybe<Scalars['Boolean']['output']>;
  selectedReasons: Maybe<Array<Scalars['String']['output']>>;
  selectedRiders: Maybe<Array<Maybe<LifePolicyRider>>>;
  semiAnnualPremium: Maybe<Scalars['Float']['output']>;
  singlePaymentPremium: Maybe<Scalars['Float']['output']>;
  stage: Scalars['String']['output'];
  stateSpecificCarrierSlug: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stateSpecificCarrierSlug instead */
  state_specific_carrier_slug: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  tableRating: Maybe<Scalars['String']['output']>;
  /** @deprecated Use tableRating instead */
  table_rating: Maybe<Scalars['String']['output']>;
  targetPremium: Maybe<Scalars['Float']['output']>;
  termInYears: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use termInYears instead */
  term_in_years: Maybe<Scalars['Int']['output']>;
  underwritingClass: Maybe<Scalars['String']['output']>;
  underwritingClassDecision: Maybe<Scalars['String']['output']>;
  /** @deprecated Use underwritingClass instead */
  underwriting_class: Maybe<Scalars['String']['output']>;
  /** @deprecated Use underwritingClassDecision instead */
  underwriting_class_decision: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of LifeApplicationProceedAsAutogenMutation */
export type LifeApplicationProceedAsAutogenMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proceed_as_autogen: Scalars['Boolean']['input'];
};

export type LifeApplicationQuoteRange = {
  __typename?: 'LifeApplicationQuoteRange';
  maximumAnnualPolicy: Maybe<LifeApplicationQuotedPolicy>;
  maximumMonthlyPolicy: Maybe<LifeApplicationQuotedPolicy>;
  minimumAnnualPolicy: Maybe<LifeApplicationQuotedPolicy>;
  minimumMonthlyPolicy: Maybe<LifeApplicationQuotedPolicy>;
  quotedPolicies: Array<LifeApplicationQuotedPolicy>;
};

export type LifeApplicationQuotedPolicy = {
  __typename?: 'LifeApplicationQuotedPolicy';
  acceleratedUnderwriting: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use acceleratedUnderwriting instead */
  accelerated_underwriting: Maybe<Scalars['Boolean']['output']>;
  annualPremium: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use annualPremium instead */
  annual_premium: Maybe<Scalars['Float']['output']>;
  carrier: Maybe<LifeInsuranceCarrierType>;
  carrierLogoUrl: Maybe<Scalars['String']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierLogoUrl instead */
  carrier_logo_url: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierName instead */
  carrier_name: Maybe<Scalars['String']['output']>;
  coverageAmount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use coverageAmount instead */
  coverage_amount: Maybe<Scalars['Int']['output']>;
  estimated: Scalars['Boolean']['output'];
  healthCategory: Maybe<Scalars['String']['output']>;
  /** @deprecated Use healthCategory instead */
  health_category: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueAge: Maybe<Scalars['Int']['output']>;
  issueType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use issueAge instead */
  issue_age: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use issueType instead */
  issue_type: Maybe<Scalars['String']['output']>;
  monthlyPremium: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use monthlyPremium instead */
  monthly_premium: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  paymentMode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentMode instead */
  payment_mode: Maybe<Scalars['String']['output']>;
  persisted: Scalars['Boolean']['output'];
  planIdentifierName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use planIdentifierName instead */
  plan_identifier_name: Maybe<Scalars['String']['output']>;
  policyType: Scalars['String']['output'];
  /** @deprecated Use policyType instead */
  policy_type: Scalars['String']['output'];
  productType: Maybe<Scalars['String']['output']>;
  productUrn: Scalars['String']['output'];
  /** @deprecated Use productType instead */
  product_type: Maybe<Scalars['String']['output']>;
  recommended: Maybe<Scalars['Boolean']['output']>;
  returnOfPremium: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use returnOfPremium instead */
  return_of_premium: Maybe<Scalars['Boolean']['output']>;
  tableRating: Maybe<Scalars['String']['output']>;
  /** @deprecated Use tableRating instead */
  table_rating: Maybe<Scalars['String']['output']>;
  termInYears: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use termInYears instead */
  term_in_years: Maybe<Scalars['Int']['output']>;
  tobacco: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use underwritingClassGroup instead */
  underwritingClass: Maybe<Scalars['String']['output']>;
  underwritingClassGroup: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of LifeApplicationSubmitCommonAppMutation */
export type LifeApplicationSubmitCommonAppMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of LifeApplicationSubmitMutation */
export type LifeApplicationSubmitMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of LifeApplicationUpdateMutation */
export type LifeApplicationUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  policy_decision_reason?: InputMaybe<Scalars['String']['input']>;
  policy_decision_recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type LifeApplications = {
  __typename?: 'LifeApplications';
  add_internal_case_tags: Maybe<LifeApplication>;
  add_to_dialer: Maybe<LifeApplication>;
  agent_state_license_update: Maybe<LifeApplication>;
  beneficiaries_update: Maybe<LifeApplication>;
  compliance_profile_update: Maybe<ComplianceProfile>;
  identification_update: Maybe<LifeApplication>;
  policy: PolicyMutation;
  proceed_as_autogen: Maybe<AutogenDetails>;
  riders_update: Maybe<LifeApplication>;
  submitExternalApplication: Maybe<SubmitExternalApplicationPayload>;
  submitProgressiveLead: Maybe<SubmitProgressiveLeadPayload>;
  submit_common_app: Maybe<LifeApplication>;
  submit_life_application: Maybe<SubmitLifeApplicationMutationPayload>;
  update_policy_premium_estimates: Maybe<LifePolicyPremiumEstimates>;
};


export type LifeApplicationsAdd_Internal_Case_TagsArgs = {
  input: LifeApplicationAddInternalCaseTagsMutationInput;
};


export type LifeApplicationsAdd_To_DialerArgs = {
  input: LifeApplicationAddToDialerMutationInput;
};


export type LifeApplicationsAgent_State_License_UpdateArgs = {
  input: AgentStateLicenseUpdateMutationInput;
};


export type LifeApplicationsBeneficiaries_UpdateArgs = {
  input: BeneficiariesUpdateMutationInput;
};


export type LifeApplicationsCompliance_Profile_UpdateArgs = {
  input: ComplianceProfileUpdateMutationInput;
};


export type LifeApplicationsIdentification_UpdateArgs = {
  input: IdentificationUpdateMutationInput;
};


export type LifeApplicationsProceed_As_AutogenArgs = {
  input: LifeApplicationProceedAsAutogenMutationInput;
};


export type LifeApplicationsRiders_UpdateArgs = {
  input: RidersUpdateMutationInput;
};


export type LifeApplicationsSubmitExternalApplicationArgs = {
  input: SubmitExternalApplicationInput;
};


export type LifeApplicationsSubmitProgressiveLeadArgs = {
  input: SubmitProgressiveLeadInput;
};


export type LifeApplicationsSubmit_Common_AppArgs = {
  input: LifeApplicationSubmitCommonAppMutationInput;
};


export type LifeApplicationsSubmit_Life_ApplicationArgs = {
  input: SubmitLifeApplicationMutationInput;
};


export type LifeApplicationsUpdate_Policy_Premium_EstimatesArgs = {
  input: LifePolicyPremiumEstimatesMutationInput;
};

export type LifeFulfillmentApplication = {
  __typename?: 'LifeFulfillmentApplication';
  address_update: Maybe<Address>;
  existing_policies_update: Maybe<LifeFulfillmentApplicationLifeFulfillmentApplicationType>;
  hipaa_create: Maybe<LifeFulfillmentApplicationHipaaType>;
  personal_details_update: Maybe<PersonalDetails>;
  policy_update: Maybe<LifeFulfillmentApplicationPolicyType>;
  underwriting_details_update: Maybe<LifeFulfillmentApplicationUnderwritingDetailsType>;
};


export type LifeFulfillmentApplicationAddress_UpdateArgs = {
  input: AddressUpdateMutationInput;
};


export type LifeFulfillmentApplicationExisting_Policies_UpdateArgs = {
  input: ExistingPoliciesUpdateMutationInput;
};


export type LifeFulfillmentApplicationHipaa_CreateArgs = {
  input: HipaaCreateMutationInput;
};


export type LifeFulfillmentApplicationPersonal_Details_UpdateArgs = {
  input: PersonalDetailsUpdateMutationInput;
};


export type LifeFulfillmentApplicationPolicy_UpdateArgs = {
  input: LifeFulfillmentPolicyUpdateMutationInput;
};


export type LifeFulfillmentApplicationUnderwriting_Details_UpdateArgs = {
  input: UnderwritingDetailsUpdateMutationInput;
};

export type LifeFulfillmentApplicationExistingPolicyType = {
  __typename?: 'LifeFulfillmentApplicationExistingPolicyType';
  carrierName: Scalars['String']['output'];
  coverageAmount: Scalars['Int']['output'];
  coverageReason: Scalars['String']['output'];
  inForceYear: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  policyNumber: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  replacing: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type LifeFulfillmentApplicationHipaaType = {
  __typename?: 'LifeFulfillmentApplicationHipaaType';
  hipaaAuthConfirmedAt: Scalars['DateTime']['output'];
};

export type LifeFulfillmentApplicationLifeFulfillmentApplicationType = {
  __typename?: 'LifeFulfillmentApplicationLifeFulfillmentApplicationType';
  existingPolicies: Maybe<Array<Maybe<LifeFulfillmentApplicationExistingPolicyType>>>;
  hipaa: Maybe<LifeFulfillmentApplicationHipaaType>;
  policy: LifeFulfillmentApplicationPolicyType;
  primaryInsured: LifeFulfillmentApplicationPrimaryInsuredType;
  /** Reference id of the life application */
  referenceId: Scalars['ID']['output'];
  underwritingDetails: Maybe<LifeFulfillmentApplicationUnderwritingDetailsType>;
};

export type LifeFulfillmentApplicationPolicyType = {
  __typename?: 'LifeFulfillmentApplicationPolicyType';
  owner: Maybe<Scalars['String']['output']>;
  pendingAmountToBePlaced: Maybe<Scalars['Int']['output']>;
  policyOwnerAddressEmail: Maybe<Scalars['String']['output']>;
  policyOwnerFirstName: Maybe<Scalars['String']['output']>;
  policyOwnerLastName: Maybe<Scalars['String']['output']>;
  trusteeEmailAddress: Maybe<Scalars['String']['output']>;
};

export type LifeFulfillmentApplicationPrimaryInsuredType = {
  __typename?: 'LifeFulfillmentApplicationPrimaryInsuredType';
  address: Address;
  dateOfBirth: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  heightInInches: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone: Phone;
  weight: Scalars['Int']['output'];
};

export type LifeFulfillmentApplicationUnderwritingDetailsType = {
  __typename?: 'LifeFulfillmentApplicationUnderwritingDetailsType';
  coverageDuringUnderwriting: Scalars['Boolean']['output'];
  coverageReason: Scalars['String']['output'];
  otherInsurance: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LifeFulfillmentPolicyUpdateMutation */
export type LifeFulfillmentPolicyUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pending_amount_to_be_placed?: InputMaybe<Scalars['Int']['input']>;
  policy_owner_address_email?: InputMaybe<Scalars['String']['input']>;
  policy_owner_first_name?: InputMaybe<Scalars['String']['input']>;
  policy_owner_last_name?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  trustee_email_address?: InputMaybe<Scalars['String']['input']>;
};

export type LifeInsurance = {
  __typename?: 'LifeInsurance';
  /**
   * @deprecated
   *       LifeInsuranceType is deprecated on 8/15/17. Use LifeInsuranceQueryType instead.
   *       To be removed after life-web and/or umbrella no longer use it
   *
   */
  application: Maybe<Array<Maybe<LifeApplication>>>;
};

export type LifeInsuranceCarrierType = {
  __typename?: 'LifeInsuranceCarrierType';
  amBestRating: Scalars['String']['output'];
  /** @deprecated Use amBestRating instead */
  am_best_rating: Scalars['String']['output'];
  bbbRating: Scalars['String']['output'];
  /** @deprecated Use bbbRating instead */
  bbb_rating: Scalars['String']['output'];
  carrierReview: Maybe<CarrierReview>;
  caseStatusUrl: Scalars['String']['output'];
  /** @deprecated Use caseStatusUrl instead */
  case_status_url: Scalars['String']['output'];
  equalLogoUrl: Scalars['String']['output'];
  /** @deprecated Use equalLogoUrl instead */
  equal_logo_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jdPowerRating: Scalars['Int']['output'];
  /** @deprecated Use jdPowerRating instead */
  jd_power_rating: Scalars['Int']['output'];
  logoLargeUrl: Scalars['String']['output'];
  logoLightUrl: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  /** @deprecated Use logoLargeUrl instead */
  logo_large_url: Scalars['String']['output'];
  /** @deprecated Use logoLightUrl instead */
  logo_light_url: Scalars['String']['output'];
  /** @deprecated Use logoUrl instead */
  logo_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newApplicationSubmitUrl: Scalars['String']['output'];
  /** @deprecated Use newApplicationSubmitUrl instead */
  new_application_submit_url: Scalars['String']['output'];
  reviewUrl: Scalars['String']['output'];
  /** @deprecated Use reviewUrl instead */
  review_url: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  /** @deprecated Use shortName instead */
  short_name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  yearEstablished: Scalars['Int']['output'];
  /** @deprecated Use yearEstablished instead */
  year_established: Scalars['Int']['output'];
};

/** Calculation of assets in the context of life insurance coverage needs */
export type LifeInsuranceCoverageNeedsAssetsCalculation = {
  __typename?: 'LifeInsuranceCoverageNeedsAssetsCalculation';
  existingLifeInsurance: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use existingLifeInsurance instead */
  existing_life_insurance: Maybe<Scalars['Int']['output']>;
  longTermSavings: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use longTermSavings instead */
  long_term_savings: Maybe<Scalars['Int']['output']>;
  shortTermSavings: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use shortTermSavings instead */
  short_term_savings: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** Calculation of life insurance coverage needs for a specific customer */
export type LifeInsuranceCoverageNeedsCalculation = {
  __typename?: 'LifeInsuranceCoverageNeedsCalculation';
  assets: LifeInsuranceCoverageNeedsAssetsCalculation;
  liabilities: LifeInsuranceCoverageNeedsLiabilitiesCalculation;
  recommendedCoverageAmount: Maybe<Scalars['Int']['output']>;
  recommendedTerm: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use recommendedCoverageAmount instead */
  recommended_coverage_amount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use recommendedTerm instead */
  recommended_term: Maybe<Scalars['Int']['output']>;
  totalCoverageNeeded: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use totalCoverageNeeded instead */
  total_coverage_needed: Maybe<Scalars['Int']['output']>;
  yearsOfFinancialObligation: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use yearsOfFinancialObligation instead */
  years_of_financial_obligation: Maybe<Scalars['Int']['output']>;
};

/** Calculation of liabilities in the context of life insurance coverage needs */
export type LifeInsuranceCoverageNeedsLiabilitiesCalculation = {
  __typename?: 'LifeInsuranceCoverageNeedsLiabilitiesCalculation';
  debts: Maybe<Scalars['Int']['output']>;
  dependentLivingExpenses: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use dependentLivingExpenses instead */
  dependent_living_expenses: Maybe<Scalars['Int']['output']>;
  educationAndChildcareCosts: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use educationAndChildcareCosts instead */
  education_and_childcare_costs: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum LifePolicy {
  FinalExpense = 'FINAL_EXPENSE',
  Term = 'TERM',
  WholeLife = 'WHOLE_LIFE'
}

export type LifePolicyPreferences = {
  __typename?: 'LifePolicyPreferences';
  ageOfYoungestChild: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use ageOfYoungestChild instead */
  age_of_youngest_child: Maybe<Scalars['Int']['output']>;
  calculated: Maybe<Scalars['Boolean']['output']>;
  coverageAmount: Scalars['Int']['output'];
  /** @deprecated Use coverageAmount instead */
  coverage_amount: Scalars['Int']['output'];
  fastAppMotivated: Maybe<Scalars['Boolean']['output']>;
  guaranteedAge: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use guaranteedAge instead */
  guaranteed_age: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  issueAge: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use issueAge instead */
  issue_age: Maybe<Scalars['Int']['output']>;
  lowPriceMotivated: Maybe<Scalars['Boolean']['output']>;
  motivationDetails: Maybe<Scalars['String']['output']>;
  noMedExamMotivated: Maybe<Scalars['Boolean']['output']>;
  numberOfChildren: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use numberOfChildren instead */
  number_of_children: Maybe<Scalars['Int']['output']>;
  paymentMode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentMode instead */
  payment_mode: Maybe<Scalars['String']['output']>;
  showRopPlans: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use showRopPlans instead */
  show_rop_plans: Maybe<Scalars['Boolean']['output']>;
  smartCoverageAmount: Scalars['Int']['output'];
  smartTerm: Scalars['String']['output'];
  /** @deprecated Use smartCoverageAmount instead */
  smart_coverage_amount: Scalars['Int']['output'];
  /** @deprecated Use smartTerm instead */
  smart_term: Scalars['String']['output'];
  spousalIntent: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use spousalIntent instead */
  spousal_intent: Maybe<Scalars['Boolean']['output']>;
  term: Scalars['String']['output'];
  underwritingClass: Maybe<Scalars['String']['output']>;
  /** @deprecated Use underwritingClass instead */
  underwriting_class: Maybe<Scalars['String']['output']>;
  usesTobacco: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use usesTobacco instead */
  uses_tobacco: Maybe<Scalars['Boolean']['output']>;
};

export type LifePolicyPremiumEstimates = {
  __typename?: 'LifePolicyPremiumEstimates';
  bannerMaxMonthly: Maybe<Scalars['Float']['output']>;
  bannerMinMonthly: Maybe<Scalars['Float']['output']>;
  coverageAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lifeApplication: LifeApplication;
  maxAnnual: Maybe<Scalars['Float']['output']>;
  maxMonthly: Maybe<Scalars['Float']['output']>;
  minAnnual: Scalars['Float']['output'];
  minMonthly: Scalars['Float']['output'];
  paymentMode: PaymentMode;
  policyType: LifePolicy;
  term: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of LifePolicyPremiumEstimatesMutation */
export type LifePolicyPremiumEstimatesMutationInput = {
  application_id: Scalars['ID']['input'];
  banner_max_monthly?: InputMaybe<Scalars['Float']['input']>;
  banner_min_monthly?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount: Scalars['Int']['input'];
  max_annual?: InputMaybe<Scalars['Float']['input']>;
  max_monthly?: InputMaybe<Scalars['Float']['input']>;
  min_annual: Scalars['Float']['input'];
  min_monthly: Scalars['Float']['input'];
  payment_mode?: InputMaybe<PaymentMode>;
  policy_type?: InputMaybe<LifePolicy>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

export type LifePolicyRider = {
  __typename?: 'LifePolicyRider';
  annualPremium: Maybe<Scalars['Float']['output']>;
  benefitName: Scalars['String']['output'];
  coverageAmount: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  selected: Maybe<Scalars['Boolean']['output']>;
};

export enum LifeProduct {
  Permanent = 'PERMANENT',
  Term = 'TERM'
}

/** Autogenerated input type of LifeSegmentUpdate */
export type LifeSegmentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['String']['input'];
};

/** Autogenerated return type of LifeSegmentUpdate */
export type LifeSegmentUpdatePayload = {
  __typename?: 'LifeSegmentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  customerLifeSegment: Maybe<Scalars['Int']['output']>;
  customerLifeSegmentName: Maybe<Scalars['String']['output']>;
};

/** Canned updates for fields in Umbrella */
export type Macro = {
  __typename?: 'Macro';
  actions: Maybe<Array<Maybe<FormAction>>>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  queuedMacro: Maybe<Macro>;
  queuedMacroId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use queuedMacro instead */
  queued_macro: Maybe<Macro>;
  /** @deprecated Use queuedMacroId instead */
  queued_macro_id: Maybe<Scalars['String']['output']>;
  shortcode: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

/** Macro invocation result */
export type MacroInvokeResult = {
  __typename?: 'MacroInvokeResult';
  comms_actions_ok: Maybe<Scalars['Boolean']['output']>;
  internal_case_updates_ok: Maybe<Scalars['Boolean']['output']>;
  macro_id: Maybe<Scalars['String']['output']>;
  reference_id: Maybe<Scalars['ID']['output']>;
};

/** A single select option for a macro form action */
export type MacroOption = {
  __typename?: 'MacroOption';
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MacrosApplyMutation */
export type MacrosApplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id?: InputMaybe<Scalars['ID']['input']>;
  macro_id?: InputMaybe<Scalars['ID']['input']>;
  shortcode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MacrosInvokeMutation */
export type MacrosInvokeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id?: InputMaybe<Scalars['ID']['input']>;
  macro_id: Scalars['ID']['input'];
  reference_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MacrosMutation = {
  __typename?: 'MacrosMutation';
  macros_apply: Maybe<Macro>;
  macros_invoke: Maybe<MacroInvokeResult>;
};


export type MacrosMutationMacros_ApplyArgs = {
  input: MacrosApplyMutationInput;
};


export type MacrosMutationMacros_InvokeArgs = {
  input: MacrosInvokeMutationInput;
};

/** Autogenerated input type of MedExamAvailabilityMutation */
export type MedExamAvailabilityMutationInput = {
  address_type?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  end_date_of_interest?: InputMaybe<Scalars['DateTime']['input']>;
  reference_id?: InputMaybe<Scalars['ID']['input']>;
  spousal?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_coverage?: InputMaybe<Scalars['Int']['input']>;
  start_date_of_interest?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MedExamAvailabilityType = {
  __typename?: 'MedExamAvailabilityType';
  availability: Maybe<Array<Maybe<AvailabilityType>>>;
  error: Maybe<Scalars['Boolean']['output']>;
  error_message: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MedExamOrderMutation */
export type MedExamOrderMutationInput = {
  address_line_one?: InputMaybe<Scalars['String']['input']>;
  address_line_two?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmation_number?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  preferred_exam_date?: InputMaybe<Scalars['DateTime']['input']>;
  preferred_exam_time?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
  special_instructions?: InputMaybe<Scalars['String']['input']>;
  spousal?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_coverage?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MedExamOrderType = {
  __typename?: 'MedExamOrderType';
  error: Maybe<Scalars['Boolean']['output']>;
  error_message: Maybe<Scalars['String']['output']>;
  response_code: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MedExamReservationCancelationMutation */
export type MedExamReservationCancelationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
};

export type MedExamReservationCancelationType = {
  __typename?: 'MedExamReservationCancelationType';
  error: Maybe<Scalars['Boolean']['output']>;
  error_message: Maybe<Scalars['String']['output']>;
  reference_id: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MedExamReservationDetailsMutation */
export type MedExamReservationDetailsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
};

export type MedExamReservationDetailsType = {
  __typename?: 'MedExamReservationDetailsType';
  error: Maybe<Scalars['Boolean']['output']>;
  error_message: Maybe<Scalars['String']['output']>;
  reservation_details: Maybe<ReservationDetailsType>;
};

/** Autogenerated input type of MedExamReservationMutation */
export type MedExamReservationMutationInput = {
  address_type?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  examiner_id: Scalars['String']['input'];
  reference_id: Scalars['ID']['input'];
  reservation_date: Scalars['DateTime']['input'];
  reservation_time: Scalars['String']['input'];
  spousal?: InputMaybe<Scalars['Boolean']['input']>;
  spouse_coverage?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MedExamReservationType = {
  __typename?: 'MedExamReservationType';
  confirmation_number: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['Boolean']['output']>;
  error_message: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MedExamUpdateMutation */
export type MedExamUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  med_exam_details?: InputMaybe<Scalars['String']['input']>;
};

/** Doctor information for ordering APS reports */
export type MedicalProvider = {
  __typename?: 'MedicalProvider';
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use firstName instead */
  first_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastName instead */
  last_name: Maybe<Scalars['String']['output']>;
  medicalFacilityAddress1: Maybe<Scalars['String']['output']>;
  medicalFacilityAddress2: Maybe<Scalars['String']['output']>;
  medicalFacilityCity: Maybe<Scalars['String']['output']>;
  medicalFacilityFax: Maybe<Scalars['String']['output']>;
  medicalFacilityName: Maybe<Scalars['String']['output']>;
  medicalFacilityPhone: Maybe<Scalars['String']['output']>;
  medicalFacilityStateCode: Maybe<Scalars['String']['output']>;
  medicalFacilityStateName: Maybe<Scalars['String']['output']>;
  medicalFacilityZipCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityAddress1 instead */
  medical_facility_address_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityAddress2 instead */
  medical_facility_address_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityCity instead */
  medical_facility_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityFax instead */
  medical_facility_fax: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityName instead */
  medical_facility_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityPhone instead */
  medical_facility_phone: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityStateCode instead */
  medical_facility_state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityStateName instead */
  medical_facility_state_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalFacilityZipCode instead */
  medical_facility_zip_code: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MedicalProviderCreateMutation */
export type MedicalProviderCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  medical_facility_address_1?: InputMaybe<Scalars['String']['input']>;
  medical_facility_address_2?: InputMaybe<Scalars['String']['input']>;
  medical_facility_city?: InputMaybe<Scalars['String']['input']>;
  medical_facility_fax?: InputMaybe<Scalars['PhoneNumber']['input']>;
  medical_facility_name?: InputMaybe<Scalars['String']['input']>;
  medical_facility_phone: Scalars['PhoneNumber']['input'];
  medical_facility_state_code: Scalars['String']['input'];
  medical_facility_zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** Doctor information for ordering APS reports */
export type MedicalProviderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type Message = {
  __typename?: 'Message';
  attachment_ids: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  commenter: Maybe<ElevatedUser>;
  id: Maybe<Scalars['ID']['output']>;
};

export type MessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MessageSendMutation */
export type MessageSendMutationInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversation_id: Scalars['ID']['input'];
  file_attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  message?: InputMaybe<MessageInput>;
};

/** General purpose data */
export type Metadata = {
  __typename?: 'Metadata';
  countries: Array<Country>;
  exitSurveyOptions: Array<ExitSurveySource>;
  /** @deprecated Use exitSurveyOptions instead */
  exit_survey_options: Array<ExitSurveySource>;
  /** @deprecated Use exitSurveyOptions instead */
  exit_survey_sources: ExitSurveySourcesQuery;
  states: Array<State>;
  trustPilotMetadata: TrustPilotMetadata;
  /** @deprecated Use trustPilotMetadata instead */
  trust_pilot_metadata: TrustPilotMetadata;
};

export type MilestoneChange = {
  __typename?: 'MilestoneChange';
  action: Maybe<Scalars['String']['output']>;
  attribute_changes: Maybe<Array<Maybe<CaseAttributeChange>>>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

/** The name and associated statuses of a milestone */
export type MilestoneOptions = {
  __typename?: 'MilestoneOptions';
  label: Maybe<Scalars['String']['output']>;
  statuses: Maybe<Array<MacroOption>>;
};

export type MilestoneUpdateFeedItem = {
  __typename?: 'MilestoneUpdateFeedItem';
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  milestone_changes: Maybe<Array<Maybe<MilestoneChange>>>;
  updated_by_urn: Maybe<Scalars['String']['output']>;
};

export type MilitaryProfile = {
  __typename?: 'MilitaryProfile';
  branch: Maybe<Scalars['String']['output']>;
  currentStationOfDuty: Maybe<Scalars['String']['output']>;
  /** @deprecated Use currentStationOfDuty instead */
  current_station_of_duty: Maybe<Scalars['String']['output']>;
  datesOfService: Maybe<Scalars['String']['output']>;
  /** @deprecated Use datesOfService instead */
  dates_of_service: Maybe<Scalars['String']['output']>;
  duties: Maybe<Scalars['String']['output']>;
  enlistmentStatus: Maybe<Scalars['String']['output']>;
  /** @deprecated Use enlistmentStatus instead */
  enlistment_status: Maybe<Scalars['String']['output']>;
  everServed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everServed instead */
  ever_served: Maybe<Scalars['Boolean']['output']>;
  foreignAssignments: Maybe<Scalars['String']['output']>;
  /** @deprecated Use foreignAssignments instead */
  foreign_assignments: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  mobilizationCategory: Maybe<Scalars['String']['output']>;
  /** @deprecated Use mobilizationCategory instead */
  mobilization_category: Maybe<Scalars['String']['output']>;
  payGrade: Maybe<Scalars['String']['output']>;
  /** @deprecated Use payGrade instead */
  pay_grade: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MilitaryProfileUpdateMutation */
export type MilitaryProfileUpdateMutationInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  current_station_of_duty?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  dates_of_service?: InputMaybe<Scalars['String']['input']>;
  duties?: InputMaybe<Scalars['String']['input']>;
  enlistment_status?: InputMaybe<Scalars['String']['input']>;
  foreign_assignments?: InputMaybe<Scalars['String']['input']>;
  mobilization_category?: InputMaybe<Scalars['String']['input']>;
  pay_grade?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the motivation behind a life insurance purchase */
export type MotivationType = {
  __typename?: 'MotivationType';
  details: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  motivation: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MotivationUpdateMutation */
export type MotivationUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['ID']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
};

/** The root mutation for this schema */
export type Mutation = {
  __typename?: 'Mutation';
  addTag: Maybe<AddTagPayload>;
  analytics: Maybe<Client>;
  analytics_track: Maybe<Customer>;
  /** @deprecated Use umbrella.aps.aps_excess_fee_approve */
  approveApsExcessFee: Maybe<ApsStateType>;
  /** @deprecated Use umbrella.customer_from_general_case_create */
  createCustomerFromGeneralCase: Maybe<Client>;
  /** @deprecated Use umbrella.elevated_user_create */
  createElevatedUser: Maybe<ElevatedUser>;
  createMacro: Maybe<CreateMacroPayload>;
  createTag: Maybe<CreateTagPayload>;
  customers: CustomersMutation;
  deleteMacro: Maybe<DeleteMacroPayload>;
  deleteUserData: Maybe<DeleteUserDataPayload>;
  disability_applications: DisabilityApplications;
  /** @deprecated Use umbrella.quotes_email */
  emailQuotes: Maybe<Client>;
  formConfirmationsUpdateByCustomer: Maybe<FormConfirmations>;
  internalCaseBulkAssign: Maybe<InternalCaseBulkAssignPayload>;
  lifeSegmentUpdate: Maybe<LifeSegmentUpdatePayload>;
  life_applications: LifeApplications;
  life_fulfillment_application: LifeFulfillmentApplication;
  parseDocument: Maybe<ParseDocumentPayload>;
  /** @deprecated Use customers.quotes_save */
  saveQuotes: Maybe<SaveQuotes>;
  submitLifeApplicationsToWFA: Maybe<SubmitLifeApplicationsToWfaPayload>;
  umbrella: UmbrellaMutation;
  /** @deprecated Use umbrella.internal_case_update */
  updateInternalCase: Maybe<InternalCase>;
  updateMacro: Maybe<UpdateMacroPayload>;
  /** @deprecated Use customers.health_profile_update */
  updateMedicalProfile: Maybe<Client>;
  /** @deprecated Use life_applications.policy.policy_preferences_update */
  updatePolicyPreferences: Maybe<Client>;
};


/** The root mutation for this schema */
export type MutationAddTagArgs = {
  input: AddTagInput;
};


/** The root mutation for this schema */
export type MutationAnalyticsArgs = {
  input: AnalyticsInput;
};


/** The root mutation for this schema */
export type MutationAnalytics_TrackArgs = {
  input: AnalyticsTrackInput;
};


/** The root mutation for this schema */
export type MutationApproveApsExcessFeeArgs = {
  input: ApproveApsExcessFeeInput;
};


/** The root mutation for this schema */
export type MutationCreateCustomerFromGeneralCaseArgs = {
  input: CreateCustomerFromGeneralCaseInput;
};


/** The root mutation for this schema */
export type MutationCreateElevatedUserArgs = {
  input: CreateElevatedUserInput;
};


/** The root mutation for this schema */
export type MutationCreateMacroArgs = {
  input: CreateMacroInput;
};


/** The root mutation for this schema */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** The root mutation for this schema */
export type MutationDeleteMacroArgs = {
  input: DeleteMacroInput;
};


/** The root mutation for this schema */
export type MutationDeleteUserDataArgs = {
  input: DeleteUserDataInput;
};


/** The root mutation for this schema */
export type MutationEmailQuotesArgs = {
  input: EmailQuotesInput;
};


/** The root mutation for this schema */
export type MutationFormConfirmationsUpdateByCustomerArgs = {
  input: FormConfirmationsUpdateByCustomerMutationInput;
};


/** The root mutation for this schema */
export type MutationInternalCaseBulkAssignArgs = {
  input: InternalCaseBulkAssignInput;
};


/** The root mutation for this schema */
export type MutationLifeSegmentUpdateArgs = {
  input: LifeSegmentUpdateInput;
};


/** The root mutation for this schema */
export type MutationParseDocumentArgs = {
  input: ParseDocumentInput;
};


/** The root mutation for this schema */
export type MutationSaveQuotesArgs = {
  input: SaveQuotesInput;
};


/** The root mutation for this schema */
export type MutationSubmitLifeApplicationsToWfaArgs = {
  input: SubmitLifeApplicationsToWfaInput;
};


/** The root mutation for this schema */
export type MutationUpdateInternalCaseArgs = {
  input: UpdateInternalCaseInput;
};


/** The root mutation for this schema */
export type MutationUpdateMacroArgs = {
  input: UpdateMacroInput;
};


/** The root mutation for this schema */
export type MutationUpdateMedicalProfileArgs = {
  input: UpdateMedicalProfileInput;
};


/** The root mutation for this schema */
export type MutationUpdatePolicyPreferencesArgs = {
  input: UpdatePolicyPreferencesInput;
};

export type Note = {
  __typename?: 'Note';
  details: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  product_type: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of NotesUpdateMutation */
export type NotesUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  product_type: Scalars['String']['input'];
};

/** Autogenerated input type of OfferRejection */
export type OfferRejectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
  rejectionStatus: Scalars['String']['input'];
};

/** Autogenerated return type of OfferRejection */
export type OfferRejectionPayload = {
  __typename?: 'OfferRejectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Option = {
  __typename?: 'Option';
  disabled: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Answer']['output']>;
};

export type OtherConditionProfile = {
  dateOfLastEpisode: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfLastEpisode instead */
  date_of_last_episode: Maybe<Scalars['DateTime']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  historyOfCondition: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfCondition instead */
  history_of_condition: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use internalDetails instead */
  internal_details: Maybe<Scalars['String']['output']>;
  otherDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherDetails instead */
  other_details: Maybe<Scalars['String']['output']>;
};

export type PacketFeedItem = {
  __typename?: 'PacketFeedItem';
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  star: Maybe<Star>;
};

export type PacketStateType = {
  __typename?: 'PacketStateType';
  agent_signed_at: Maybe<Scalars['DateTime']['output']>;
  current_state: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  proposed_insured_opened_packet_at: Maybe<Scalars['DateTime']['output']>;
  proposed_insured_signed_at: Maybe<Scalars['DateTime']['output']>;
  sent_to_carrier_at: Maybe<Scalars['DateTime']['output']>;
  signature_requested_at: Maybe<Scalars['DateTime']['output']>;
};

export type PaginationMacrosCustomCollection = {
  __typename?: 'PaginationMacrosCustomCollection';
  collection: Array<Macro>;
  metadata: PaginationMetadataType;
};

export type PaginationMetadataType = {
  __typename?: 'PaginationMetadataType';
  currentPage: Scalars['Int']['output'];
  limitValue: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationSafeguardUsersCustomCollection = {
  __typename?: 'PaginationSafeguardUsersCustomCollection';
  collection: Array<SafeguardUser>;
  metadata: PaginationMetadataType;
};

export type PaginationTagsCustomCollection = {
  __typename?: 'PaginationTagsCustomCollection';
  collection: Array<UmbrellaMetadataTagType>;
  metadata: PaginationMetadataType;
};

export type ParamedicalExamInfoType = {
  __typename?: 'ParamedicalExamInfoType';
  active: Maybe<Scalars['Boolean']['output']>;
  examiner_name: Maybe<Scalars['String']['output']>;
  examiner_phone_number: Maybe<Scalars['String']['output']>;
  external_provider_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  last_status_change_date: Maybe<Scalars['String']['output']>;
  order_number: Maybe<Scalars['String']['output']>;
  paramedical_result_files: Maybe<Array<Maybe<FileType>>>;
  scheduled_date: Maybe<Scalars['String']['output']>;
  scheduling_url: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  status_updates: Maybe<Array<Maybe<StatusUpdateType>>>;
  vendor_name: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ParamedicalExamInfoUpdate */
export type ParamedicalExamInfoUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paramed_requirement_id: Scalars['ID']['input'];
  reference_id: Scalars['ID']['input'];
};

/** Autogenerated input type of ParseDocument */
export type ParseDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The PDF document to send to sensible to parse. */
  document: Scalars['Upload']['input'];
  /**
   * The sensible document type that
   *                    should be used to parse the document.
   */
  documentType: DocumentTypeEnum;
};

/** Autogenerated return type of ParseDocument */
export type ParseDocumentPayload = {
  __typename?: 'ParseDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** A JSON representation of the parsed document. */
  parsedDocument: Scalars['JSON']['output'];
};

export enum PaymentMode {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

/** The payment profile of the proposed insured */
export type PaymentProfile = {
  __typename?: 'PaymentProfile';
  accountType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use accountType instead */
  account_type: Maybe<Scalars['String']['output']>;
  bankInformation: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use bankInformation instead */
  bank_information: Maybe<Scalars['Boolean']['output']>;
  carrierRequiresBankInformation: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use carrierRequiresBankInformation instead */
  carrier_requires_bank_information: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentMethod instead */
  payment_method: Maybe<Scalars['String']['output']>;
  saveBankAccountUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PaymentProfileUpdateMutation */
export type PaymentProfileUpdateMutationInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  bank_information?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  payment_method?: InputMaybe<Scalars['String']['input']>;
};

export type PcpProfile = {
  __typename?: 'PcpProfile';
  additionalNotes: Maybe<Scalars['String']['output']>;
  /** @deprecated Use additionalNotes instead */
  additional_notes: Maybe<Scalars['String']['output']>;
  hasPcp: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasPcp instead */
  has_pcp: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  labsCompleted: Maybe<Scalars['Boolean']['output']>;
  labsLastCompletedAt: Maybe<Scalars['String']['output']>;
  /** @deprecated Use labsCompleted instead */
  labs_completed: Maybe<Scalars['Boolean']['output']>;
  lastVisitedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lastVisitedAt instead */
  last_visited_at: Maybe<Scalars['DateTime']['output']>;
  reasonForLastVisit: Maybe<Scalars['String']['output']>;
  /** @deprecated Use reasonForLastVisit instead */
  reason_for_last_visit: Maybe<Scalars['String']['output']>;
  referralOrTestCompletionDetails: Maybe<Scalars['String']['output']>;
  referralOrTestRecommended: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use referralOrTestCompletionDetails instead */
  referral_or_test_completion_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use referralOrTestRecommended instead */
  referral_or_test_recommended: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of PcpProfileUpdateMutation */
export type PcpProfileUpdateMutationInput = {
  additional_notes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  has_pcp?: InputMaybe<Scalars['Boolean']['input']>;
  labs_completed?: InputMaybe<Scalars['Boolean']['input']>;
  labs_last_completed_at?: InputMaybe<Scalars['String']['input']>;
  last_visited_at?: InputMaybe<Scalars['DateTime']['input']>;
  reason_for_last_visit?: InputMaybe<Scalars['String']['input']>;
  referral_or_test_completion_details?: InputMaybe<Scalars['String']['input']>;
  referral_or_test_recommended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonalDetails = {
  __typename?: 'PersonalDetails';
  dateOfBirth: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  heightInInches: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone: Phone;
  weight: Scalars['Int']['output'];
};

/** Autogenerated input type of PersonalDetailsUpdateMutation */
export type PersonalDetailsUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  height_in_inches?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInputType>;
  reference_id: Scalars['ID']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonalInfoConfirmation = {
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Confirmation is now defined as a field on the profile */
  personal_info_confirmed_by: Maybe<Scalars['String']['output']>;
};

export type Phone = {
  __typename?: 'Phone';
  number: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type PhoneCallFeedItem = {
  __typename?: 'PhoneCallFeedItem';
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  star: Maybe<Star>;
};

export type PhoneInputType = {
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PolicyDeleteMutation */
export type PolicyDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  policy_id: Scalars['ID']['input'];
};

/** Autogenerated input type of PolicyDeselectMutation */
export type PolicyDeselectMutationInput = {
  application_id: Scalars['ID']['input'];
  clear_applied_policy?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  triggered_from: Scalars['String']['input'];
};

export type PolicyHistory = {
  __typename?: 'PolicyHistory';
  changeset: Maybe<Array<Maybe<Changeset>>>;
  type: Maybe<Scalars['String']['output']>;
  user: Maybe<Scalars['String']['output']>;
};

export type PolicyMutation = {
  __typename?: 'PolicyMutation';
  policy_deselect: Maybe<LifeApplication>;
  policy_preferences_update: Maybe<LifePolicyPreferences>;
  policy_questions_update: Maybe<LifeApplication>;
  policy_select: Maybe<LifeApplication>;
};


export type PolicyMutationPolicy_DeselectArgs = {
  input: PolicyDeselectMutationInput;
};


export type PolicyMutationPolicy_Preferences_UpdateArgs = {
  input: PolicyPreferencesUpdateMutationInput;
};


export type PolicyMutationPolicy_Questions_UpdateArgs = {
  input: PolicyQuestionsUpdateMutationInput;
};


export type PolicyMutationPolicy_SelectArgs = {
  input: PolicySelectMutationInput;
};

export type PolicyNamesInput = {
  issue_type?: InputMaybe<Scalars['String']['input']>;
  plan_identifier_name?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyPreferencesInputType = {
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of PolicyPreferencesUpdateMutation */
export type PolicyPreferencesUpdateMutationInput = {
  age_of_youngest_child?: InputMaybe<Scalars['Int']['input']>;
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  customer_id: Scalars['ID']['input'];
  employment_type?: InputMaybe<Scalars['String']['input']>;
  fast_app_motivated?: InputMaybe<Scalars['Boolean']['input']>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  individual_income?: InputMaybe<Scalars['Int']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  low_price_motivated?: InputMaybe<Scalars['Boolean']['input']>;
  motivation_details?: InputMaybe<Scalars['String']['input']>;
  no_med_exam_motivated?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_children?: InputMaybe<Scalars['Int']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  spousal_intent?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  triggered_from?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PolicyQuestions = {
  __typename?: 'PolicyQuestions';
  assets: Maybe<Scalars['Int']['output']>;
  benefitAmount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use benefitAmount instead */
  benefit_amount: Maybe<Scalars['Int']['output']>;
  businessApproximateMarketValue: Maybe<Scalars['Int']['output']>;
  businessAssets: Maybe<Scalars['Int']['output']>;
  businessBankruptcyOrLienInLast5Years: Maybe<Scalars['Boolean']['output']>;
  businessCity: Maybe<Scalars['String']['output']>;
  businessEntityType: Maybe<Scalars['String']['output']>;
  businessFoundedAt: Maybe<Scalars['Int']['output']>;
  businessKeyPersonCoverage: Maybe<Scalars['Boolean']['output']>;
  businessLiabilities: Maybe<Scalars['Int']['output']>;
  businessName: Maybe<Scalars['String']['output']>;
  businessNature: Maybe<Scalars['String']['output']>;
  businessNetAnnualIncome: Maybe<Scalars['Int']['output']>;
  businessPercentageOwned: Maybe<Scalars['Int']['output']>;
  businessStateId: Maybe<Scalars['Int']['output']>;
  businessStreet1: Maybe<Scalars['String']['output']>;
  businessStreet2: Maybe<Scalars['String']['output']>;
  businessTaxpayerId: Maybe<Scalars['String']['output']>;
  businessZip: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessApproximateMarketValue instead */
  business_approximate_market_value: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessAssets instead */
  business_assets: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessBankruptcyOrLienInLast5Years instead */
  business_bankruptcy_or_lien_in_last_5_years: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use businessCity instead */
  business_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessEntityType instead */
  business_entity_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessFoundedAt instead */
  business_founded_at: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessKeyPersonCoverage instead */
  business_key_person_coverage: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use businessLiabilities instead */
  business_liabilities: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessName instead */
  business_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessNature instead */
  business_nature: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessNetAnnualIncome instead */
  business_net_annual_income: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessPercentageOwned instead */
  business_percentage_owned: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessStateId instead */
  business_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use businessStreet1 instead */
  business_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessStreet2 instead */
  business_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessTaxpayerId instead */
  business_taxpayer_id: Maybe<Scalars['String']['output']>;
  /** @deprecated Use businessZip instead */
  business_zip: Maybe<Scalars['String']['output']>;
  coverageDuringUnderwriting: Maybe<Scalars['Boolean']['output']>;
  coverageReason: Maybe<Scalars['String']['output']>;
  coverageReasonCategory: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageDuringUnderwriting instead */
  coverage_during_underwriting: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use coverageReason instead */
  coverage_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use coverageReasonCategory instead */
  coverage_reason_category: Maybe<Scalars['String']['output']>;
  currentPolicies: Maybe<Array<Maybe<LifeApplicationPolicy>>>;
  /** @deprecated Use currentPolicies instead */
  current_policies: Maybe<Array<Maybe<LifeApplicationPolicy>>>;
  existingPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use existingPolicy instead */
  existing_policy: Maybe<Scalars['Boolean']['output']>;
  fundingWithExistingPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use fundingWithExistingPolicy instead */
  funding_with_existing_policy: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  insuredIsPremiumPayer: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use insuredIsPremiumPayer instead */
  insured_is_premium_payer: Maybe<Scalars['Boolean']['output']>;
  labsCompletedLast6Months: Maybe<Scalars['Boolean']['output']>;
  labsCompletedLast12Months: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use labsCompletedLast6Months instead */
  labs_completed_last_6_months: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use labsCompletedLast12Months instead */
  labs_completed_last_12_months: Maybe<Scalars['Boolean']['output']>;
  liabilities: Maybe<Scalars['Int']['output']>;
  medicalAttentionLastNinetyDays: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use medicalAttentionLastNinetyDays instead */
  medical_attention_last_ninety_days: Maybe<Scalars['Boolean']['output']>;
  modifyingExistingPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use modifyingExistingPolicy instead */
  modifying_existing_policy: Maybe<Scalars['Boolean']['output']>;
  netWorth: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use netWorth instead */
  net_worth: Maybe<Scalars['Int']['output']>;
  otherInsurance: Maybe<Scalars['Boolean']['output']>;
  otherInsuranceCarrierName: Maybe<Scalars['String']['output']>;
  otherInsuranceDetails: Maybe<Scalars['String']['output']>;
  otherInsuranceIssueDate: Maybe<Scalars['DateTime']['output']>;
  otherInsurancePolicyNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherInsurance instead */
  other_insurance: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherInsuranceCarrierName instead */
  other_insurance_carrier_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherInsuranceDetails instead */
  other_insurance_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherInsuranceIssueDate instead */
  other_insurance_issue_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use otherInsurancePolicyNumber instead */
  other_insurance_policy_number: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['Boolean']['output']>;
  ownerTrust: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use ownerTrust instead */
  owner_trust: Maybe<Scalars['Boolean']['output']>;
  pendingAmountToBePlaced: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use pendingAmountToBePlaced instead */
  pending_amount_to_be_placed: Maybe<Scalars['Int']['output']>;
  policyOwnerAddressCitizenshipStatus: Maybe<Scalars['String']['output']>;
  policyOwnerAddressCity: Maybe<Scalars['String']['output']>;
  policyOwnerAddressEmail: Maybe<Scalars['String']['output']>;
  policyOwnerAddressStateCode: Maybe<Scalars['String']['output']>;
  policyOwnerAddressStateId: Maybe<Scalars['Int']['output']>;
  policyOwnerAddressStateName: Maybe<Scalars['String']['output']>;
  policyOwnerAddressStreet1: Maybe<Scalars['String']['output']>;
  policyOwnerAddressStreet2: Maybe<Scalars['String']['output']>;
  policyOwnerAddressZipCode: Maybe<Scalars['String']['output']>;
  policyOwnerDob: Maybe<Scalars['String']['output']>;
  policyOwnerExistingCoverage: Maybe<Scalars['Boolean']['output']>;
  policyOwnerFirstName: Maybe<Scalars['String']['output']>;
  policyOwnerFullName: Maybe<Scalars['String']['output']>;
  policyOwnerGender: Maybe<Scalars['String']['output']>;
  policyOwnerLastName: Maybe<Scalars['String']['output']>;
  policyOwnerPhoneNumber: Maybe<Scalars['String']['output']>;
  policyOwnerRelationship: Maybe<Scalars['String']['output']>;
  policyOwnerSocialSecurityNumber: Maybe<Scalars['String']['output']>;
  policyType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressCitizenshipStatus instead */
  policy_owner_address_citizenship_status: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressCity instead */
  policy_owner_address_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressEmail instead */
  policy_owner_address_email: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressStateCode instead */
  policy_owner_address_state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressStateId instead */
  policy_owner_address_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use policyOwnerAddressStateName instead */
  policy_owner_address_state_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressStreet1 instead */
  policy_owner_address_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressStreet2 instead */
  policy_owner_address_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerAddressZipCode instead */
  policy_owner_address_zip_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerDob instead */
  policy_owner_dob: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerExistingCoverage instead */
  policy_owner_existing_coverage: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use policyOwnerFirstName instead */
  policy_owner_first_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerFullName instead */
  policy_owner_full_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerGender instead */
  policy_owner_gender: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerLastName instead */
  policy_owner_last_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerPhoneNumber instead */
  policy_owner_phone_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerRelationship instead */
  policy_owner_relationship: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyOwnerSocialSecurityNumber instead */
  policy_owner_social_security_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyType instead */
  policy_type: Maybe<Scalars['String']['output']>;
  premiumFinancing: Maybe<Scalars['Boolean']['output']>;
  premiumFinancingDetails: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressCity: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressStateCode: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressStateId: Maybe<Scalars['Int']['output']>;
  premiumNoticeAddressStateName: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressStreet1: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressStreet2: Maybe<Scalars['String']['output']>;
  premiumNoticeAddressZipCode: Maybe<Scalars['String']['output']>;
  premiumNoticeAlternateAddress: Maybe<Scalars['Boolean']['output']>;
  premiumNoticeName: Maybe<Scalars['String']['output']>;
  premiumPayerAddressCity: Maybe<Scalars['String']['output']>;
  premiumPayerAddressStateId: Maybe<Scalars['Int']['output']>;
  premiumPayerAddressStreet1: Maybe<Scalars['String']['output']>;
  premiumPayerAddressStreet2: Maybe<Scalars['String']['output']>;
  premiumPayerAddressZipCode: Maybe<Scalars['String']['output']>;
  premiumPayerCitizenshipStatus: Maybe<Scalars['String']['output']>;
  premiumPayerDateOfBirth: Maybe<Scalars['DateTime']['output']>;
  premiumPayerDriversLicenseNumber: Maybe<Scalars['String']['output']>;
  premiumPayerDriversLicenseStateOfIssueId: Maybe<Scalars['Int']['output']>;
  premiumPayerEmail: Maybe<Scalars['String']['output']>;
  premiumPayerGender: Maybe<Scalars['String']['output']>;
  premiumPayerName: Maybe<Scalars['String']['output']>;
  premiumPayerPhoneNumber: Maybe<Scalars['String']['output']>;
  premiumPayerRelationshipToApplicant: Maybe<Scalars['String']['output']>;
  premiumPayerSsn: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumFinancing instead */
  premium_financing: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use premiumFinancingDetails instead */
  premium_financing_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressCity instead */
  premium_notice_address_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressStateCode instead */
  premium_notice_address_state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressStateId instead */
  premium_notice_address_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use premiumNoticeAddressStateName instead */
  premium_notice_address_state_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressStreet1 instead */
  premium_notice_address_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressStreet2 instead */
  premium_notice_address_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAddressZipCode instead */
  premium_notice_address_zip_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumNoticeAlternateAddress instead */
  premium_notice_alternate_address: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use premiumNoticeName instead */
  premium_notice_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerAddressCity instead */
  premium_payer_address_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerAddressStateId instead */
  premium_payer_address_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use premiumPayerAddressStreet1 instead */
  premium_payer_address_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerAddressStreet2 instead */
  premium_payer_address_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerAddressZipCode instead */
  premium_payer_address_zip_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerCitizenshipStatus instead */
  premium_payer_citizenship_status: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerDateOfBirth instead */
  premium_payer_date_of_birth: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use premiumPayerDriversLicenseNumber instead */
  premium_payer_drivers_license_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerDriversLicenseStateOfIssueId instead */
  premium_payer_drivers_license_state_of_issue_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use premiumPayerEmail instead */
  premium_payer_email: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerGender instead */
  premium_payer_gender: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerName instead */
  premium_payer_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerPhoneNumber instead */
  premium_payer_phone_number: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerRelationshipToApplicant instead */
  premium_payer_relationship_to_applicant: Maybe<Scalars['String']['output']>;
  /** @deprecated Use premiumPayerSsn instead */
  premium_payer_ssn: Maybe<Scalars['String']['output']>;
  previousRestricted: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use previousRestricted instead */
  previous_restricted: Maybe<Scalars['Boolean']['output']>;
  recentlyModifiedPolicy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use recentlyModifiedPolicy instead */
  recently_modified_policy: Maybe<Scalars['Boolean']['output']>;
  replacingCoverage: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use replacingCoverage instead */
  replacing_coverage: Maybe<Scalars['Boolean']['output']>;
  restrictionCoverageType: Maybe<Scalars['String']['output']>;
  restrictionDate: Maybe<Scalars['DateTime']['output']>;
  restrictionReason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use restrictionCoverageType instead */
  restriction_coverage_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use restrictionDate instead */
  restriction_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use restrictionReason instead */
  restriction_reason: Maybe<Scalars['String']['output']>;
  severeConditionLastTwoYears: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use severeConditionLastTwoYears instead */
  severe_condition_last_two_years: Maybe<Scalars['Boolean']['output']>;
  sourceOfPayment: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sourceOfPayment instead */
  source_of_payment: Maybe<Scalars['String']['output']>;
  trustAddressCity: Maybe<Scalars['String']['output']>;
  trustAddressStateCode: Maybe<Scalars['String']['output']>;
  trustAddressStateId: Maybe<Scalars['Int']['output']>;
  trustAddressStateName: Maybe<Scalars['String']['output']>;
  trustAddressStreet1: Maybe<Scalars['String']['output']>;
  trustAddressStreet2: Maybe<Scalars['String']['output']>;
  trustAddressZipCode: Maybe<Scalars['String']['output']>;
  trustCorporateOfficeTitle: Maybe<Scalars['String']['output']>;
  trustCorporateOfficerName: Maybe<Scalars['String']['output']>;
  trustDate: Maybe<Scalars['DateTime']['output']>;
  trustName: Maybe<Scalars['String']['output']>;
  trustPurpose: Maybe<Scalars['String']['output']>;
  trustSignerRelationship: Maybe<Scalars['String']['output']>;
  trustStateId: Maybe<Scalars['Int']['output']>;
  trustTaxId: Maybe<Scalars['String']['output']>;
  trustType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressCity instead */
  trust_address_city: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressStateCode instead */
  trust_address_state_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressStateId instead */
  trust_address_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use trustAddressStateName instead */
  trust_address_state_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressStreet1 instead */
  trust_address_street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressStreet2 instead */
  trust_address_street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustAddressZipCode instead */
  trust_address_zip_code: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustCorporateOfficeTitle instead */
  trust_corporate_office_title: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustCorporateOfficerName instead */
  trust_corporate_officer_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustDate instead */
  trust_date: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use trustName instead */
  trust_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustPurpose instead */
  trust_purpose: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustSignerRelationship instead */
  trust_signer_relationship: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustStateId instead */
  trust_state_id: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use trustTaxId instead */
  trust_tax_id: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trustType instead */
  trust_type: Maybe<Scalars['String']['output']>;
  trustee: Maybe<Scalars['String']['output']>;
  trusteeEmailAddress: Maybe<Scalars['String']['output']>;
  trusteeHasSoleAuthority: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use trusteeEmailAddress instead */
  trustee_email_address: Maybe<Scalars['String']['output']>;
  /** @deprecated Use trusteeHasSoleAuthority instead */
  trustee_has_sole_authority: Maybe<Scalars['Boolean']['output']>;
};

export type PolicyQuestionsPolicyInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  carrier_name?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  coverage_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  in_force_year?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  persisted?: InputMaybe<Scalars['Boolean']['input']>;
  policy_number?: InputMaybe<Scalars['String']['input']>;
  policy_type?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  replacing?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PolicyQuestionsUpdateMutation */
export type PolicyQuestionsUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  assets?: InputMaybe<Scalars['Int']['input']>;
  business_approximate_market_value?: InputMaybe<Scalars['Int']['input']>;
  business_assets?: InputMaybe<Scalars['Int']['input']>;
  business_bankruptcy_or_lien_in_last_5_years?: InputMaybe<Scalars['Boolean']['input']>;
  business_city?: InputMaybe<Scalars['String']['input']>;
  business_entity_type?: InputMaybe<Scalars['String']['input']>;
  business_founded_at?: InputMaybe<Scalars['Int']['input']>;
  business_key_person_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  business_liabilities?: InputMaybe<Scalars['Int']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  business_nature?: InputMaybe<Scalars['String']['input']>;
  business_net_annual_income?: InputMaybe<Scalars['Int']['input']>;
  business_percentage_owned?: InputMaybe<Scalars['Int']['input']>;
  business_state_id?: InputMaybe<Scalars['Int']['input']>;
  business_street_1?: InputMaybe<Scalars['String']['input']>;
  business_street_2?: InputMaybe<Scalars['String']['input']>;
  business_taxpayer_id?: InputMaybe<Scalars['String']['input']>;
  business_zip?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_during_underwriting?: InputMaybe<Scalars['Boolean']['input']>;
  coverage_reason?: InputMaybe<Scalars['String']['input']>;
  coverage_reason_category?: InputMaybe<Scalars['String']['input']>;
  existing_policies?: InputMaybe<Array<InputMaybe<PolicyQuestionsPolicyInput>>>;
  existing_policy?: InputMaybe<Scalars['Boolean']['input']>;
  funding_with_existing_policy?: InputMaybe<Scalars['Boolean']['input']>;
  insured_is_premium_payer?: InputMaybe<Scalars['Boolean']['input']>;
  labs_completed_last_6_months?: InputMaybe<Scalars['Boolean']['input']>;
  labs_completed_last_12_months?: InputMaybe<Scalars['Boolean']['input']>;
  liabilities?: InputMaybe<Scalars['Int']['input']>;
  medical_attention_last_ninety_days?: InputMaybe<Scalars['Boolean']['input']>;
  modifying_existing_policy?: InputMaybe<Scalars['Boolean']['input']>;
  other_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  other_insurance_carrier_name?: InputMaybe<Scalars['String']['input']>;
  other_insurance_details?: InputMaybe<Scalars['String']['input']>;
  other_insurance_issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  other_insurance_policy_number?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  owner_trust?: InputMaybe<Scalars['Boolean']['input']>;
  pending_amount_to_be_placed?: InputMaybe<Scalars['Int']['input']>;
  policy_owner_address_citizenship_status?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_city?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_email?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_state_code?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_state_id?: InputMaybe<Scalars['Int']['input']>;
  policy_owner_address_state_name?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_street_1?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_street_2?: InputMaybe<Scalars['String']['input']>;
  policy_owner_address_zip_code?: InputMaybe<Scalars['String']['input']>;
  policy_owner_dob?: InputMaybe<Scalars['String']['input']>;
  policy_owner_existing_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  policy_owner_first_name?: InputMaybe<Scalars['String']['input']>;
  policy_owner_full_name?: InputMaybe<Scalars['String']['input']>;
  policy_owner_gender?: InputMaybe<Scalars['String']['input']>;
  policy_owner_last_name?: InputMaybe<Scalars['String']['input']>;
  policy_owner_phone_number?: InputMaybe<Scalars['String']['input']>;
  policy_owner_relationship?: InputMaybe<Scalars['String']['input']>;
  policy_owner_social_security_number?: InputMaybe<Scalars['String']['input']>;
  premium_financing?: InputMaybe<Scalars['Boolean']['input']>;
  premium_financing_details?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_city?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_state_code?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_state_id?: InputMaybe<Scalars['Int']['input']>;
  premium_notice_address_state_name?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_street_1?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_street_2?: InputMaybe<Scalars['String']['input']>;
  premium_notice_address_zip_code?: InputMaybe<Scalars['String']['input']>;
  premium_notice_alternate_address?: InputMaybe<Scalars['Boolean']['input']>;
  premium_notice_name?: InputMaybe<Scalars['String']['input']>;
  premium_payer_address_city?: InputMaybe<Scalars['String']['input']>;
  premium_payer_address_state_id?: InputMaybe<Scalars['Int']['input']>;
  premium_payer_address_street_1?: InputMaybe<Scalars['String']['input']>;
  premium_payer_address_street_2?: InputMaybe<Scalars['String']['input']>;
  premium_payer_address_zip_code?: InputMaybe<Scalars['String']['input']>;
  premium_payer_citizenship_status?: InputMaybe<Scalars['String']['input']>;
  premium_payer_date_of_birth?: InputMaybe<Scalars['DateTime']['input']>;
  premium_payer_drivers_license_number?: InputMaybe<Scalars['String']['input']>;
  premium_payer_drivers_license_state_of_issue?: InputMaybe<Scalars['String']['input']>;
  premium_payer_drivers_license_state_of_issue_id?: InputMaybe<Scalars['Int']['input']>;
  premium_payer_email?: InputMaybe<Scalars['String']['input']>;
  premium_payer_gender?: InputMaybe<Scalars['String']['input']>;
  premium_payer_name?: InputMaybe<Scalars['String']['input']>;
  premium_payer_phone_number?: InputMaybe<Scalars['String']['input']>;
  premium_payer_relationship_to_applicant?: InputMaybe<Scalars['String']['input']>;
  premium_payer_ssn?: InputMaybe<Scalars['String']['input']>;
  previous_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  recently_modified_policy?: InputMaybe<Scalars['Boolean']['input']>;
  replacing_coverage?: InputMaybe<Scalars['Boolean']['input']>;
  restriction_coverage_type?: InputMaybe<Scalars['String']['input']>;
  restriction_date?: InputMaybe<Scalars['DateTime']['input']>;
  restriction_reason?: InputMaybe<Scalars['String']['input']>;
  severe_condition_last_two_years?: InputMaybe<Scalars['Boolean']['input']>;
  source_of_payment?: InputMaybe<Scalars['String']['input']>;
  trust_address_city?: InputMaybe<Scalars['String']['input']>;
  trust_address_state_code?: InputMaybe<Scalars['String']['input']>;
  trust_address_state_id?: InputMaybe<Scalars['Int']['input']>;
  trust_address_state_name?: InputMaybe<Scalars['String']['input']>;
  trust_address_street_1?: InputMaybe<Scalars['String']['input']>;
  trust_address_street_2?: InputMaybe<Scalars['String']['input']>;
  trust_address_zip_code?: InputMaybe<Scalars['String']['input']>;
  trust_corporate_office_title?: InputMaybe<Scalars['String']['input']>;
  trust_corporate_officer_name?: InputMaybe<Scalars['String']['input']>;
  trust_date?: InputMaybe<Scalars['DateTime']['input']>;
  trust_name?: InputMaybe<Scalars['String']['input']>;
  trust_purpose?: InputMaybe<Scalars['String']['input']>;
  trust_signer_relationship?: InputMaybe<Scalars['String']['input']>;
  trust_state_id?: InputMaybe<Scalars['Int']['input']>;
  trust_tax_id?: InputMaybe<Scalars['String']['input']>;
  trust_type?: InputMaybe<Scalars['String']['input']>;
  trustee?: InputMaybe<Scalars['String']['input']>;
  trustee_email_address?: InputMaybe<Scalars['String']['input']>;
  trustee_has_sole_authority?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PolicySearchResult = {
  __typename?: 'PolicySearchResult';
  accelerated_underwriting: Maybe<Scalars['Boolean']['output']>;
  am_best_rating: Maybe<Scalars['String']['output']>;
  annual_premium: Maybe<Scalars['Float']['output']>;
  bbb_rating: Maybe<Scalars['String']['output']>;
  carrier_logo_url: Maybe<Scalars['String']['output']>;
  carrier_name: Maybe<Scalars['String']['output']>;
  carrier_review_url: Maybe<Scalars['String']['output']>;
  carrier_slug: Maybe<Scalars['String']['output']>;
  coverage_amount: Maybe<Scalars['Int']['output']>;
  errors: Maybe<Scalars['String']['output']>;
  guaranteed_age: Maybe<Scalars['Int']['output']>;
  issue_age: Maybe<Scalars['Int']['output']>;
  issue_type: Maybe<Scalars['String']['output']>;
  monthly_premium: Maybe<Scalars['Float']['output']>;
  plan_identifier_name: Maybe<Scalars['String']['output']>;
  policy_name: Maybe<Scalars['String']['output']>;
  product_type: Maybe<Scalars['String']['output']>;
  product_urn: Maybe<Scalars['String']['output']>;
  recommended_policy: Maybe<Scalars['Boolean']['output']>;
  recommended_reason_1: Maybe<Scalars['String']['output']>;
  recommended_reason_2: Maybe<Scalars['String']['output']>;
  return_of_premium: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<Scalars['String']['output']>;
  table_rating: Maybe<Scalars['String']['output']>;
  term_in_years: Maybe<Scalars['Int']['output']>;
  tobacco: Maybe<Scalars['String']['output']>;
  underwriting_class: Maybe<Scalars['String']['output']>;
  underwriting_class_group: Maybe<Scalars['String']['output']>;
  use_nearest_age: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of PolicySelectMutation */
export type PolicySelectMutationInput = {
  add_to_dialer?: InputMaybe<Scalars['Boolean']['input']>;
  annual_premium?: InputMaybe<Scalars['Float']['input']>;
  application_id: Scalars['ID']['input'];
  carrier_name: Scalars['String']['input'];
  carrier_slug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount: Scalars['Int']['input'];
  dialer_delay_type?: InputMaybe<DialerDelayTypeEnum>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  issue_type?: InputMaybe<Scalars['String']['input']>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  payment_mode: Scalars['String']['input'];
  plan_identifier_name?: InputMaybe<Scalars['String']['input']>;
  policy_name?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  product_urn?: InputMaybe<Scalars['String']['input']>;
  select_and_apply?: InputMaybe<Scalars['Boolean']['input']>;
  table_rating?: InputMaybe<Scalars['String']['input']>;
  term_in_years?: InputMaybe<Scalars['Int']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  triggered_from: Scalars['String']['input'];
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  underwriting_class_group?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PolicyUpdateMutation */
export type PolicyUpdateMutationInput = {
  add_note?: InputMaybe<Scalars['Boolean']['input']>;
  annual_premium?: InputMaybe<Scalars['Float']['input']>;
  application_id: Scalars['ID']['input'];
  calculate_modifications?: InputMaybe<Scalars['Boolean']['input']>;
  carrier_name?: InputMaybe<Scalars['String']['input']>;
  carrier_slug?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_due_date?: InputMaybe<Scalars['DateTime']['input']>;
  displayed_policy_results?: InputMaybe<Array<InputMaybe<DisplayedPolicyResultsInputType>>>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  is_age_change?: InputMaybe<Scalars['Boolean']['input']>;
  is_financial_mod?: InputMaybe<Scalars['Boolean']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  issue_type?: InputMaybe<Scalars['String']['input']>;
  monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  overfunded_amount?: InputMaybe<Scalars['Float']['input']>;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  pay_age?: InputMaybe<Scalars['String']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  plan_identifier_name?: InputMaybe<Scalars['String']['input']>;
  policy_decision_type?: InputMaybe<Scalars['String']['input']>;
  policy_name?: InputMaybe<Scalars['String']['input']>;
  policy_number?: InputMaybe<Scalars['String']['input']>;
  policy_preferences?: InputMaybe<PolicyPreferencesInputType>;
  policy_update_source?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<Scalars['String']['input']>;
  product_urn?: InputMaybe<Scalars['String']['input']>;
  quarterly_premium?: InputMaybe<Scalars['Float']['input']>;
  recommended_policy?: InputMaybe<Scalars['Boolean']['input']>;
  recommended_products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selected_reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  semi_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  single_payment_premium?: InputMaybe<Scalars['Float']['input']>;
  table_rating?: InputMaybe<Scalars['Int']['input']>;
  target_premium?: InputMaybe<Scalars['Float']['input']>;
  term_in_years?: InputMaybe<Scalars['Int']['input']>;
  tobacco?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  underwriting_class_decision?: InputMaybe<Scalars['String']['input']>;
  underwriting_class_group?: InputMaybe<Scalars['String']['input']>;
  use_nearest_age?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Profile of past pregnancies for the insured */
export type PregnancyHistory = {
  __typename?: 'PregnancyHistory';
  a1cReading: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use a1cReading instead */
  a1c_reading: Maybe<Scalars['Float']['output']>;
  anemia: Maybe<Scalars['Boolean']['output']>;
  birthInLast10Years: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use birthInLast10Years instead */
  birth_in_last_10_years: Maybe<Scalars['Boolean']['output']>;
  complicationDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use complicationDetails instead */
  complication_details: Maybe<Scalars['String']['output']>;
  complications: Maybe<Scalars['Boolean']['output']>;
  gestationalDiabetes: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use gestationalDiabetes instead */
  gestational_diabetes: Maybe<Scalars['Boolean']['output']>;
  highBloodPressure: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use highBloodPressure instead */
  high_blood_pressure: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  infections: Maybe<Scalars['Boolean']['output']>;
  miscarriage: Maybe<Scalars['Boolean']['output']>;
  mostRecentDeliveryDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use mostRecentDeliveryDate instead */
  most_recent_delivery_date: Maybe<Scalars['DateTime']['output']>;
  multiplePregnancy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use multiplePregnancy instead */
  multiple_pregnancy: Maybe<Scalars['Boolean']['output']>;
  otherComplication: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherComplication instead */
  other_complication: Maybe<Scalars['Boolean']['output']>;
  preclampsia: Maybe<Scalars['Boolean']['output']>;
  prescriptionDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use prescriptionDetails instead */
  prescription_details: Maybe<Scalars['String']['output']>;
  prescriptions: Maybe<Scalars['Boolean']['output']>;
  pretermLabor: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use pretermLabor instead */
  preterm_labor: Maybe<Scalars['Boolean']['output']>;
  severeVomiting: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use severeVomiting instead */
  severe_vomiting: Maybe<Scalars['Boolean']['output']>;
  stillbirth: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of PregnancyHistoryUpdateMutation */
export type PregnancyHistoryUpdateMutationInput = {
  a1c_reading?: InputMaybe<Scalars['Float']['input']>;
  anemia?: InputMaybe<Scalars['Boolean']['input']>;
  birth_in_last_10_years?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  complication_details?: InputMaybe<Scalars['String']['input']>;
  complications?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  gestational_diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  high_blood_pressure?: InputMaybe<Scalars['Boolean']['input']>;
  infections?: InputMaybe<Scalars['Boolean']['input']>;
  miscarriage?: InputMaybe<Scalars['Boolean']['input']>;
  most_recent_delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  multiple_pregnancy?: InputMaybe<Scalars['Boolean']['input']>;
  other_complication?: InputMaybe<Scalars['Boolean']['input']>;
  preclampsia?: InputMaybe<Scalars['Boolean']['input']>;
  prescription_details?: InputMaybe<Scalars['String']['input']>;
  prescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  preterm_labor?: InputMaybe<Scalars['Boolean']['input']>;
  severe_vomiting?: InputMaybe<Scalars['Boolean']['input']>;
  stillbirth?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Profile of current pregnancy for the insured */
export type PregnancyProfile = {
  __typename?: 'PregnancyProfile';
  a1cReading: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use a1cReading instead */
  a1c_reading: Maybe<Scalars['Float']['output']>;
  anemia: Maybe<Scalars['Boolean']['output']>;
  complicationDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use complicationDetails instead */
  complication_details: Maybe<Scalars['String']['output']>;
  complications: Maybe<Scalars['Boolean']['output']>;
  currentlyPregnant: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use currentlyPregnant instead */
  currently_pregnant: Maybe<Scalars['Boolean']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dueDate instead */
  due_date: Maybe<Scalars['DateTime']['output']>;
  gestationalDiabetes: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use gestationalDiabetes instead */
  gestational_diabetes: Maybe<Scalars['Boolean']['output']>;
  highBloodPressure: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use highBloodPressure instead */
  high_blood_pressure: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  infections: Maybe<Scalars['Boolean']['output']>;
  miscarriage: Maybe<Scalars['Boolean']['output']>;
  multiplePregnancy: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use multiplePregnancy instead */
  multiple_pregnancy: Maybe<Scalars['Boolean']['output']>;
  otherComplication: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherComplication instead */
  other_complication: Maybe<Scalars['Boolean']['output']>;
  preclampsia: Maybe<Scalars['Boolean']['output']>;
  prescriptionDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use prescriptionDetails instead */
  prescription_details: Maybe<Scalars['String']['output']>;
  prescriptions: Maybe<Scalars['Boolean']['output']>;
  pretermLabor: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use pretermLabor instead */
  preterm_labor: Maybe<Scalars['Boolean']['output']>;
  severeVomiting: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use severeVomiting instead */
  severe_vomiting: Maybe<Scalars['Boolean']['output']>;
  stillbirth: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of PregnancyProfileUpdateMutation */
export type PregnancyProfileUpdateMutationInput = {
  a1c_reading?: InputMaybe<Scalars['Float']['input']>;
  anemia?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  complication_details?: InputMaybe<Scalars['String']['input']>;
  complications?: InputMaybe<Scalars['Boolean']['input']>;
  currently_pregnant?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id: Scalars['ID']['input'];
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  gestational_diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  high_blood_pressure?: InputMaybe<Scalars['Boolean']['input']>;
  infections?: InputMaybe<Scalars['Boolean']['input']>;
  miscarriage?: InputMaybe<Scalars['Boolean']['input']>;
  multiple_pregnancy?: InputMaybe<Scalars['Boolean']['input']>;
  other_complication?: InputMaybe<Scalars['Boolean']['input']>;
  preclampsia?: InputMaybe<Scalars['Boolean']['input']>;
  prescription_details?: InputMaybe<Scalars['String']['input']>;
  prescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  preterm_labor?: InputMaybe<Scalars['Boolean']['input']>;
  severe_vomiting?: InputMaybe<Scalars['Boolean']['input']>;
  stillbirth?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Product ids for a Policygenius customer */
export type ProductProfile = {
  __typename?: 'ProductProfile';
  id: Scalars['ID']['output'];
  lifeApplicationId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use lifeApplicationId instead */
  life_application_id: Maybe<Scalars['ID']['output']>;
};

export type Products = {
  __typename?: 'Products';
  life: Maybe<Array<Maybe<LifeApplication>>>;
};

export type ProgressiveLead = {
  __typename?: 'ProgressiveLead';
  continueButtonClickedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  trackingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAnalyticsId: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** The root query for this schema */
export type Query = {
  __typename?: 'Query';
  /** Query for an agent by their ID */
  agent: AgentType;
  /** Query for all agents */
  agents: Array<AgentType>;
  /** @deprecated Use umbrella.aps_info */
  aps_info: Maybe<ApsInfoResponseType>;
  /** Query for all bulk assign groups */
  bulkAssignGroups: Array<UmbrellaBulkAssignGroupType>;
  /** Find CarrierLicense by ID */
  carrierLicense: CarrierLicenseType;
  /** Query for all licenses */
  carrierLicenses: Array<CarrierLicenseType>;
  /** Query to retrieve smaller subset of case info */
  caseInfo: InternalCase;
  /** @deprecated Use the customers node */
  client: Maybe<Client>;
  customer: Maybe<Customer>;
  disabilityApplication: Maybe<DisabilityApplication>;
  /** @deprecated Use disabilityApplication instead */
  disability_application: Maybe<DisabilityApplication>;
  evidences: Maybe<Array<CarrierIntegrationEvidencesEvidenceType>>;
  lifeApplication: LifeApplication;
  /** Life Fulfillment Application Resource */
  lifeFulfillmentApplication: Maybe<LifeFulfillmentApplicationLifeFulfillmentApplicationType>;
  /** @deprecated Use lifeApplication instead */
  life_application: LifeApplication;
  /** Query to retrieve paginated macros, optionally filtered by a keyword */
  macrosCollection: PaginationMacrosCustomCollection;
  /** Query for base milestones based on line of business */
  manualBaseMilestones: Array<TasksBaseMilestoneType>;
  metadata: Metadata;
  policies: Maybe<Array<Maybe<PolicySearchResult>>>;
  quoted_policy: Maybe<PolicySearchResult>;
  /** Query to retrieve paginated safeguard users */
  safeguardUsersCollection: PaginationSafeguardUsersCustomCollection;
  /** Query to retrieve paginated tags, optionally filtered by a keyword */
  tagsCollection: PaginationTagsCustomCollection;
  umbrella: Maybe<Umbrella>;
  userPermitted: Maybe<Scalars['Boolean']['output']>;
};


/** The root query for this schema */
export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryAgentsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** The root query for this schema */
export type QueryAps_InfoArgs = {
  life_application_id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryCarrierLicenseArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryCaseInfoArgs = {
  internalCaseId: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryClientArgs = {
  uuid: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryDisabilityApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryDisability_ApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryEvidencesArgs = {
  referenceId: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryLifeApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryLifeFulfillmentApplicationArgs = {
  referenceId: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryLife_ApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryMacrosCollectionArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query for this schema */
export type QueryManualBaseMilestonesArgs = {
  lineOfBusiness: Scalars['String']['input'];
};


/** The root query for this schema */
export type QueryPoliciesArgs = {
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  plan_identifier_name?: InputMaybe<Scalars['String']['input']>;
  reference_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QueryQuoted_PolicyArgs = {
  application_id: Scalars['ID']['input'];
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  table_rating?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};


/** The root query for this schema */
export type QuerySafeguardUsersCollectionArgs = {
  filter?: InputMaybe<ElevatedUserSearchInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


/** The root query for this schema */
export type QueryTagsCollectionArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query for this schema */
export type QueryUserPermittedArgs = {
  action: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

/** Dynamic Questions from YML file. Have jjkkj */
export type Question = {
  __typename?: 'Question';
  conditional_on: Maybe<Scalars['String']['output']>;
  conditional_value: Maybe<Scalars['Answer']['output']>;
  field_name: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<Maybe<Option>>>;
  required: Maybe<Scalars['String']['output']>;
  tooltip: Maybe<Scalars['String']['output']>;
  tooltip_header: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Answer']['output']>;
};

/** Autogenerated input type of QuoteEstimateCreate */
export type QuoteEstimateCreateInput = {
  all_perils_deductible?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dwelling_coverage?: InputMaybe<Scalars['Int']['input']>;
  internal_case_id: Scalars['ID']['input'];
  medical_payments_coverage?: InputMaybe<Scalars['Int']['input']>;
  personal_liability_coverage?: InputMaybe<Scalars['Int']['input']>;
  personal_property_coverage?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of QuoteFinalCreateMutation */
export type QuoteFinalCreateMutationInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  existing_business_policies?: InputMaybe<Array<InputMaybe<HomeAndAutoExistingBusinessPolicyInput>>>;
  internal_case_id: Scalars['ID']['input'];
  internal_case_task_id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  policies: Array<InputMaybe<HomeAndAutoPolicyInput>>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of QuoteFinalSectionAddMutation */
export type QuoteFinalSectionAddMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id: Scalars['ID']['input'];
  selected_sections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuoteParamsInput = {
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of QuoteSectionAddMutation */
export type QuoteSectionAddMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id: Scalars['ID']['input'];
  selected_sections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Autogenerated input type of QuotesEmailMutation */
export type QuotesEmailMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  intro_text: Scalars['String']['input'];
  quote_params: Array<InputMaybe<QuoteParamsInput>>;
};

/** Autogenerated input type of RecordCustomerAccess */
export type RecordCustomerAccessInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ReferralProfile = {
  __typename?: 'ReferralProfile';
  campaignHash: Maybe<Scalars['String']['output']>;
  channelHash: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type RenovationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ReservationDetailsType = {
  __typename?: 'ReservationDetailsType';
  coverage_amount: Maybe<Scalars['Int']['output']>;
  order_submitted_at: Maybe<Scalars['String']['output']>;
  reservation_confirmation_id: Maybe<Scalars['String']['output']>;
  reservation_date: Maybe<Scalars['String']['output']>;
  reservation_time: Maybe<Scalars['String']['output']>;
  special_instructions: Maybe<Scalars['Boolean']['output']>;
  spousal: Maybe<Scalars['Boolean']['output']>;
  spouse_coverage: Maybe<Scalars['Int']['output']>;
};

/** The residence of the proposed insured */
export type Residence = {
  __typename?: 'Residence';
  birth_country: Maybe<Scalars['String']['output']>;
  birth_state_code: Maybe<Scalars['String']['output']>;
  birth_state_id: Maybe<Scalars['Int']['output']>;
  birth_state_name: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country_of_origin: Maybe<Scalars['String']['output']>;
  date_of_entry_to_us: Maybe<Scalars['DateTime']['output']>;
  do_not_call: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  length_of_us_stay: Maybe<Scalars['String']['output']>;
  opt_in_notification: Maybe<Scalars['Boolean']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  phone_type: Maybe<Scalars['String']['output']>;
  raw_phone: Maybe<Scalars['String']['output']>;
  residency_expiration_date: Maybe<Scalars['DateTime']['output']>;
  residency_status: Maybe<Scalars['String']['output']>;
  state_code: Maybe<Scalars['String']['output']>;
  state_id: Maybe<Scalars['Int']['output']>;
  state_name: Maybe<Scalars['String']['output']>;
  street_1: Maybe<Scalars['String']['output']>;
  street_2: Maybe<Scalars['String']['output']>;
  street_3: Maybe<Scalars['String']['output']>;
  visa_details: Maybe<Scalars['String']['output']>;
  visa_green_card_number: Maybe<Scalars['String']['output']>;
  visa_type: Maybe<Scalars['String']['output']>;
  years_at_current_address: Maybe<Scalars['Int']['output']>;
  years_in_united_states: Maybe<Scalars['Int']['output']>;
  zip_code: Maybe<Scalars['String']['output']>;
};

export type ResidenceProfile = {
  __typename?: 'ResidenceProfile';
  city: Maybe<Scalars['String']['output']>;
  hasHydratedHomeData: Scalars['Boolean']['output'];
  hydratedHomeData: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Use isValid instead */
  is_valid: Scalars['Boolean']['output'];
  potentialCrossSellState: Maybe<Scalars['Boolean']['output']>;
  state: Maybe<State>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  street3: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street1 instead */
  street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street2 instead */
  street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street3 instead */
  street_3: Maybe<Scalars['String']['output']>;
  yearsAtCurrentAddress: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use yearsAtCurrentAddress instead */
  years_at_current_address: Maybe<Scalars['Int']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use zipCode instead */
  zip_code: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResidenceProfileUpdateMutation */
export type ResidenceProfileUpdateMutationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  state_id?: InputMaybe<Scalars['Int']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  street_2?: InputMaybe<Scalars['String']['input']>;
  street_3?: InputMaybe<Scalars['String']['input']>;
  years_at_current_address?: InputMaybe<Scalars['Int']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type RiderInputType = {
  annual_premium?: InputMaybe<Scalars['Float']['input']>;
  benefit_name: Scalars['String']['input'];
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  is_free?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of RidersUpdateMutation */
export type RidersUpdateMutationInput = {
  application_id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rider_details?: InputMaybe<Scalars['String']['input']>;
  riders?: InputMaybe<Scalars['Boolean']['input']>;
  selected_riders?: InputMaybe<Array<InputMaybe<RiderInputType>>>;
};

/** A PG user with roles and permissions defined in safeguard */
export type SafeguardUser = {
  __typename?: 'SafeguardUser';
  /** Whether or not the user is active in the system. */
  active: Scalars['Boolean']['output'];
  /** Whether or not the user is an administrator. */
  admin: Scalars['Boolean']['output'];
  /** The email of the user. */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use firstName instead */
  first_name: Maybe<Scalars['String']['output']>;
  /** The full name of the user. */
  fullName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use fullName instead */
  full_name: Maybe<Scalars['String']['output']>;
  /** Id of the user */
  id: Scalars['ID']['output'];
  /** The last name of the user. */
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastName instead */
  last_name: Maybe<Scalars['String']['output']>;
  /** Whether or not the user has the ability to modify permissions. */
  permissionAdmin: Scalars['Boolean']['output'];
  /** @deprecated Use permissionAdmin instead */
  permission_admin: Scalars['Boolean']['output'];
  /** The list of permissions the user has. */
  productAccessPermissions: Array<Scalars['String']['output']>;
  /** @deprecated Use productAccessPermissions instead */
  product_access_permissions: Array<Scalars['String']['output']>;
  /** The team the user is on. */
  team: Maybe<Scalars['String']['output']>;
};

export type SafeguardUserRoleMappingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SafeguardUserRolesAddMutation */
export type SafeguardUserRolesAddMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  safeguard_user_role_mappings?: InputMaybe<Array<InputMaybe<SafeguardUserRoleMappingsInput>>>;
};

export type SaveQuotes = {
  __typename?: 'SaveQuotes';
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  subscribed_to_newsletter: Maybe<Scalars['Boolean']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SaveQuotes */
export type SaveQuotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eligible_types?: InputMaybe<SavedQuotesAnalyticsInput>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  insurance_type: Scalars['String']['input'];
  submitted_from: Scalars['String']['input'];
  subscribed_to_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  validate_email?: InputMaybe<Scalars['Boolean']['input']>;
  validate_first_name: Scalars['Boolean']['input'];
};

export type SavedQuotesAnalyticsInput = {
  life_product_type?: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryResidenceProfile = {
  __typename?: 'SecondaryResidenceProfile';
  city: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state: Maybe<State>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  street3: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street1 instead */
  street_1: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street2 instead */
  street_2: Maybe<Scalars['String']['output']>;
  /** @deprecated Use street3 instead */
  street_3: Maybe<Scalars['String']['output']>;
  yearsAtCurrentAddress: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use yearsAtCurrentAddress instead */
  years_at_current_address: Maybe<Scalars['Int']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use zipCode instead */
  zip_code: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SecondaryResidenceProfileUpdateMutation */
export type SecondaryResidenceProfileUpdateMutationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  state_id?: InputMaybe<Scalars['Int']['input']>;
  street_1?: InputMaybe<Scalars['String']['input']>;
  street_2?: InputMaybe<Scalars['String']['input']>;
  street_3?: InputMaybe<Scalars['String']['input']>;
  years_at_current_address?: InputMaybe<Scalars['Int']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type SecureMessageAttachment = {
  __typename?: 'SecureMessageAttachment';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type SecureMessageFeedItem = {
  __typename?: 'SecureMessageFeedItem';
  attachments: Maybe<Array<Maybe<SecureMessageAttachment>>>;
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  commenter: Maybe<ElevatedUser>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  direction: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  star: Maybe<Star>;
};

/** Options for select macro form actions */
export type SelectOptions = {
  __typename?: 'SelectOptions';
  assigneeOptions: Maybe<Array<MacroOption>>;
  caseStatusOptions: Maybe<Array<MacroOption>>;
  lifecycleStageOptions: Maybe<Array<MacroOption>>;
  milestoneOptions: Maybe<Array<MilestoneOptions>>;
  queuedMacroOptions: Maybe<Array<Macro>>;
  tagOptions: Maybe<Array<MacroOption>>;
};

/** Autogenerated input type of SendAmendmentMessage */
export type SendAmendmentMessageInput = {
  amendmentMessage?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  goodHealthStatement?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendAmendmentMessage */
export type SendAmendmentMessagePayload = {
  __typename?: 'SendAmendmentMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShareableAttachment = {
  __typename?: 'ShareableAttachment';
  attachment_name: Maybe<Scalars['String']['output']>;
  shareable: Maybe<Scalars['Boolean']['output']>;
};

export type SleepApneaProfile = {
  __typename?: 'SleepApneaProfile';
  apneaHypopneaIndex: Maybe<Scalars['Int']['output']>;
  apneaIndex: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use apneaHypopneaIndex instead */
  apnea_hypopnea_index: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use apneaIndex instead */
  apnea_index: Maybe<Scalars['Int']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  everTreated: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use everTreated instead */
  ever_treated: Maybe<Scalars['Boolean']['output']>;
  historyOfSleepApnea: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfSleepApnea instead */
  history_of_sleep_apnea: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  oxygenSaturation: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use oxygenSaturation instead */
  oxygen_saturation: Maybe<Scalars['Int']['output']>;
  respiratoryDisturbanceIndex: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use respiratoryDisturbanceIndex instead */
  respiratory_disturbance_index: Maybe<Scalars['Int']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  sleepStudyConducted: Maybe<Scalars['Boolean']['output']>;
  sleepStudyConductedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use sleepStudyConducted instead */
  sleep_study_conducted: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use sleepStudyConductedAt instead */
  sleep_study_conducted_at: Maybe<Scalars['DateTime']['output']>;
  treatedAt: Maybe<Scalars['DateTime']['output']>;
  treatedWith: Maybe<Scalars['String']['output']>;
  /** @deprecated Use treatedAt instead */
  treated_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use treatedWith instead */
  treated_with: Maybe<Scalars['String']['output']>;
  usesCpapMachine: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use usesCpapMachine instead */
  uses_cpap_machine: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of SleepApneaProfileUpdateMutation */
export type SleepApneaProfileUpdateMutationInput = {
  apnea_hypopnea_index?: InputMaybe<Scalars['Int']['input']>;
  apnea_index?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  ever_treated?: InputMaybe<Scalars['Boolean']['input']>;
  history_of_sleep_apnea?: InputMaybe<Scalars['Boolean']['input']>;
  oxygen_saturation?: InputMaybe<Scalars['Int']['input']>;
  respiratory_disturbance_index?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  sleep_study_conducted?: InputMaybe<Scalars['Boolean']['input']>;
  sleep_study_conducted_at?: InputMaybe<Scalars['DateTime']['input']>;
  treated_at?: InputMaybe<Scalars['DateTime']['input']>;
  uses_cpap_machine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmsFeedItem = {
  __typename?: 'SmsFeedItem';
  body: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  commenter: Maybe<ElevatedUser>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  direction: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  sent_at: Maybe<Scalars['DateTime']['output']>;
  source: Maybe<Scalars['String']['output']>;
  star: Maybe<Star>;
};

export enum Source {
  Pgpro = 'PGPRO',
  Policygenius = 'POLICYGENIUS'
}

/** Spousal linked internal cases */
export type SpousalLink = {
  __typename?: 'SpousalLink';
  clientCaseId: Maybe<Scalars['ID']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use clientCaseId instead */
  client_case_id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use clientName instead */
  client_name: Maybe<Scalars['String']['output']>;
  customerId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use customerId instead */
  customer_id: Maybe<Scalars['ID']['output']>;
  relationshipId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use relationshipId instead */
  relationship_id: Maybe<Scalars['ID']['output']>;
  spouseCaseId: Maybe<Scalars['ID']['output']>;
  spouseCoverage: Maybe<Scalars['Int']['output']>;
  spouseDateOfBirth: Maybe<Scalars['DateTime']['output']>;
  spouseGender: Maybe<Scalars['String']['output']>;
  spouseName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use spouseCaseId instead */
  spouse_case_id: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use spouseCoverage instead */
  spouse_coverage: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use spouseDateOfBirth instead */
  spouse_date_of_birth: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use spouseGender instead */
  spouse_gender: Maybe<Scalars['String']['output']>;
  /** @deprecated Use spouseName instead */
  spouse_name: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SpousalLinkMutation */
export type SpousalLinkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  client_case_id: Scalars['ID']['input'];
  customer_id: Scalars['ID']['input'];
  spouse_case_id: Scalars['ID']['input'];
};

/** Autogenerated input type of SpousalUnlinkMutation */
export type SpousalUnlinkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  client_case_id: Scalars['ID']['input'];
  customer_id: Scalars['ID']['input'];
  spouse_case_id: Scalars['ID']['input'];
};

export type Star = {
  __typename?: 'Star';
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['String']['output']>;
  /** @deprecated Use star id */
  reference_uuid: Maybe<Scalars['String']['output']>;
  star_id: Maybe<Scalars['String']['output']>;
  starred: Maybe<Scalars['Boolean']['output']>;
  starred_by: Maybe<ElevatedUser>;
};

export type State = {
  __typename?: 'State';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StatusUpdateType = {
  __typename?: 'StatusUpdateType';
  date: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  vendor_status_event_code: Maybe<Scalars['String']['output']>;
};

export type StrokeProfile = OtherConditionProfile & {
  __typename?: 'StrokeProfile';
  dateOfLastEpisode: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use dateOfLastEpisode instead */
  date_of_last_episode: Maybe<Scalars['DateTime']['output']>;
  diagnosedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use diagnosedAt instead */
  diagnosed_at: Maybe<Scalars['DateTime']['output']>;
  historyOfCondition: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfCondition instead */
  history_of_condition: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use internalDetails instead */
  internal_details: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  /** @deprecated Use isValid instead */
  is_valid: Scalars['Boolean']['output'];
  otherDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherDetails instead */
  other_details: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of StrokeProfileUpdateMutation */
export type StrokeProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  date_of_last_episode?: InputMaybe<Scalars['DateTime']['input']>;
  diagnosed_at?: InputMaybe<Scalars['DateTime']['input']>;
  history_of_condition?: InputMaybe<Scalars['Boolean']['input']>;
  internal_details?: InputMaybe<Scalars['String']['input']>;
  other_details?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SubmitEverlyPartTwo */
export type SubmitEverlyPartTwoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitEverlyPartTwo */
export type SubmitEverlyPartTwoPayload = {
  __typename?: 'SubmitEverlyPartTwoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitEvidenceResponse */
export type SubmitEvidenceResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalEvidenceId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitEvidenceResponse */
export type SubmitEvidenceResponsePayload = {
  __typename?: 'SubmitEvidenceResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitExternalApplication */
export type SubmitExternalApplicationInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitExternalApplication */
export type SubmitExternalApplicationPayload = {
  __typename?: 'SubmitExternalApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  directTransferLink: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SubmitLifeApplicationMutation */
export type SubmitLifeApplicationMutationInput = {
  autoconfirm_and_tag?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  dialer_delay_type?: InputMaybe<DialerDelayTypeEnum>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  internal_case_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name: Scalars['String']['input'];
  max_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  max_monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  min_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  min_monthly_premium?: InputMaybe<Scalars['Float']['input']>;
  phone: Scalars['PhoneNumber']['input'];
  previous_first_name?: InputMaybe<Scalars['String']['input']>;
  previous_last_name?: InputMaybe<Scalars['String']['input']>;
  previous_middle_name?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitLifeApplicationMutationPayload = {
  __typename?: 'SubmitLifeApplicationMutationPayload';
  customer: Maybe<Customer>;
  life_application: Maybe<LifeApplication>;
};

/** Autogenerated input type of SubmitLifeApplicationsToWFA */
export type SubmitLifeApplicationsToWfaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reference ids for all cases to be submitted to WFA */
  referenceIds: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitLifeApplicationsToWFA */
export type SubmitLifeApplicationsToWfaPayload = {
  __typename?: 'SubmitLifeApplicationsToWFAPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Reference ids for all cases that failed to be sent to WFA */
  failedToSend: Maybe<Array<Scalars['String']['output']>>;
  /** Reference ids for all internal cases successfully sent to WFA */
  successfullySent: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of SubmitPartOne */
export type SubmitPartOneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitPartOne */
export type SubmitPartOnePayload = {
  __typename?: 'SubmitPartOnePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitProgressiveLead */
export type SubmitProgressiveLeadInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitProgressiveLead */
export type SubmitProgressiveLeadPayload = {
  __typename?: 'SubmitProgressiveLeadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  progressiveLead: ProgressiveLead;
};

export type SubstanceAbuseProfile = {
  __typename?: 'SubstanceAbuseProfile';
  alcoholQuantity: Maybe<Scalars['Int']['output']>;
  alcoholUsage: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use alcoholQuantity instead */
  alcohol_quantity: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use alcoholUsage instead */
  alcohol_usage: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  referredToAlcoholSupportGroup: Maybe<Scalars['Boolean']['output']>;
  treatedForAlcoholAbuse: Maybe<Scalars['Boolean']['output']>;
  treatedForAlcoholAbuseAt: Maybe<Scalars['DateTime']['output']>;
  treatedForDrugAbuse: Maybe<Scalars['Boolean']['output']>;
  treatedForDrugAbuseAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use treatedForAlcoholAbuse instead */
  treated_for_alcohol_abuse: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use treatedForAlcoholAbuseAt instead */
  treated_for_alcohol_abuse_at: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use treatedForDrugAbuse instead */
  treated_for_drug_abuse: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use treatedForDrugAbuseAt instead */
  treated_for_drug_abuse_at: Maybe<Scalars['DateTime']['output']>;
};

/** Autogenerated input type of SubstanceAbuseProfileUpdateMutation */
export type SubstanceAbuseProfileUpdateMutationInput = {
  alcohol_quantity?: InputMaybe<Scalars['Int']['input']>;
  alcohol_usage?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  referred_to_alcohol_support_group?: InputMaybe<Scalars['Boolean']['input']>;
  treated_for_alcohol_abuse?: InputMaybe<Scalars['Boolean']['input']>;
  treated_for_alcohol_abuse_at?: InputMaybe<Scalars['DateTime']['input']>;
  treated_for_drug_abuse?: InputMaybe<Scalars['Boolean']['input']>;
  treated_for_drug_abuse_at?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated input type of TagsDeleteMutation */
export type TagsDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tag_id: Scalars['ID']['input'];
};

export type TaskChange = {
  __typename?: 'TaskChange';
  action: Maybe<Scalars['String']['output']>;
  attribute_changes: Maybe<Array<Maybe<CaseAttributeChange>>>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

export type TaskUpdateFeedItem = {
  __typename?: 'TaskUpdateFeedItem';
  category: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  role: Maybe<Scalars['String']['output']>;
  task_changes: Maybe<Array<Maybe<TaskChange>>>;
  updated_by_urn: Maybe<Scalars['String']['output']>;
};

export type TasksBaseMilestoneType = {
  __typename?: 'TasksBaseMilestoneType';
  /** The list of base tasks associated with the base milestone */
  baseTasks: Array<TasksBaseTaskType>;
  /** Id of the base milestone */
  id: Scalars['ID']['output'];
  /** The line of business associated with base milestone */
  lineOfBusiness: Scalars['String']['output'];
  /** The name of the base milestone */
  name: Scalars['String']['output'];
  /** The unique slug representing the milestone. */
  slug: Scalars['String']['output'];
};

export type TasksBaseTaskType = {
  __typename?: 'TasksBaseTaskType';
  /** The description of the base task */
  description: Scalars['String']['output'];
  /** Id of the base task */
  id: Scalars['ID']['output'];
  /** The name of the base task */
  name: Scalars['String']['output'];
  /** The base task slug */
  slug: Scalars['String']['output'];
};

/** Autogenerated input type of TeamsCreateMutation */
export type TeamsCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  team_name: Scalars['String']['input'];
};

export type TobaccoProfile = {
  __typename?: 'TobaccoProfile';
  chewingTobacco: Maybe<Scalars['Boolean']['output']>;
  chewingTobaccoUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use chewingTobacco instead */
  chewing_tobacco: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use chewingTobaccoUsedAt instead */
  chewing_tobacco_used_at: Maybe<Scalars['DateTime']['output']>;
  cigarettes: Maybe<Scalars['Boolean']['output']>;
  cigarettesPerDay: Maybe<Scalars['Int']['output']>;
  cigarettesUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use cigarettesPerDay instead */
  cigarettes_per_day: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cigarettesUsedAt instead */
  cigarettes_used_at: Maybe<Scalars['DateTime']['output']>;
  cigars: Maybe<Scalars['Boolean']['output']>;
  cigarsPerDay: Maybe<Scalars['Int']['output']>;
  cigarsPerMonth: Maybe<Scalars['Int']['output']>;
  cigarsPerYear: Maybe<Scalars['Int']['output']>;
  cigarsUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use cigarsPerDay instead */
  cigars_per_day: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cigarsPerMonth instead */
  cigars_per_month: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cigarsPerYear instead */
  cigars_per_year: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cigarsUsedAt instead */
  cigars_used_at: Maybe<Scalars['DateTime']['output']>;
  historyOfTobaccoUse: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use historyOfTobaccoUse instead */
  history_of_tobacco_use: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  marijuana: Maybe<Scalars['Boolean']['output']>;
  marijuanaDetails: Maybe<Scalars['String']['output']>;
  marijuanaInhales: Maybe<Scalars['Boolean']['output']>;
  marijuanaMedicinal: Maybe<Scalars['Boolean']['output']>;
  marijuanaOral: Maybe<Scalars['Boolean']['output']>;
  marijuanaOther: Maybe<Scalars['Boolean']['output']>;
  marijuanaPerMonth: Maybe<Scalars['Int']['output']>;
  marijuanaPrescriptionReason: Maybe<Scalars['String']['output']>;
  marijuanaSmoke: Maybe<Scalars['Boolean']['output']>;
  marijuanaTinctures: Maybe<Scalars['Boolean']['output']>;
  marijuanaUsageType: Maybe<Scalars['String']['output']>;
  marijuanaUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use marijuanaDetails instead */
  marijuana_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use marijuanaInhales instead */
  marijuana_inhales: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaMedicinal instead */
  marijuana_medicinal: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaOral instead */
  marijuana_oral: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaOther instead */
  marijuana_other: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaPerMonth instead */
  marijuana_per_month: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use marijuanaPrescriptionReason instead */
  marijuana_prescription_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use marijuanaSmoke instead */
  marijuana_smoke: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaTinctures instead */
  marijuana_tinctures: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use marijuanaUsageType instead */
  marijuana_usage_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use marijuanaUsedAt instead */
  marijuana_used_at: Maybe<Scalars['DateTime']['output']>;
  nicotineReplacement: Maybe<Scalars['Boolean']['output']>;
  nicotineReplacementUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use nicotineReplacement instead */
  nicotine_replacement: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use nicotineReplacementUsedAt instead */
  nicotine_replacement_used_at: Maybe<Scalars['DateTime']['output']>;
  otherTobacco: Maybe<Scalars['Boolean']['output']>;
  otherTobaccoDetails: Maybe<Scalars['String']['output']>;
  otherTobaccoUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use otherTobacco instead */
  other_tobacco: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use otherTobaccoDetails instead */
  other_tobacco_details: Maybe<Scalars['String']['output']>;
  /** @deprecated Use otherTobaccoUsedAt instead */
  other_tobacco_used_at: Maybe<Scalars['DateTime']['output']>;
  pipe: Maybe<Scalars['Boolean']['output']>;
  pipeUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use pipeUsedAt instead */
  pipe_used_at: Maybe<Scalars['DateTime']['output']>;
  smoker: Maybe<Scalars['Boolean']['output']>;
  summary: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TobaccoProfileUpdateMutation */
export type TobaccoProfileUpdateMutationInput = {
  chewing_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  chewing_tobacco_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  cigarettes?: InputMaybe<Scalars['Boolean']['input']>;
  cigarettes_per_day?: InputMaybe<Scalars['Int']['input']>;
  cigarettes_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  cigars?: InputMaybe<Scalars['Boolean']['input']>;
  cigars_per_day?: InputMaybe<Scalars['Int']['input']>;
  cigars_per_month?: InputMaybe<Scalars['Int']['input']>;
  cigars_per_year?: InputMaybe<Scalars['Int']['input']>;
  cigars_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  history_of_tobacco_use?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_details?: InputMaybe<Scalars['String']['input']>;
  marijuana_inhales?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_medicinal?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_oral?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_other?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_per_month?: InputMaybe<Scalars['Int']['input']>;
  marijuana_prescription_reason?: InputMaybe<Scalars['String']['input']>;
  marijuana_smoke?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_tinctures?: InputMaybe<Scalars['Boolean']['input']>;
  marijuana_usage_type?: InputMaybe<Scalars['String']['input']>;
  marijuana_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  nicotine_replacement?: InputMaybe<Scalars['Boolean']['input']>;
  nicotine_replacement_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  other_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  other_tobacco_details?: InputMaybe<Scalars['String']['input']>;
  other_tobacco_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  pipe?: InputMaybe<Scalars['Boolean']['input']>;
  pipe_used_at?: InputMaybe<Scalars['DateTime']['input']>;
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransamericaInterview = {
  __typename?: 'TransamericaInterview';
  apiErrors: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** The travel profile of the proposed insured */
export type TravelProfile = {
  __typename?: 'TravelProfile';
  futureOverseasTravel: Maybe<Scalars['Boolean']['output']>;
  futureOverseasTravelDates: Maybe<Scalars['String']['output']>;
  futureOverseasTravelDestination: Maybe<Scalars['String']['output']>;
  futureOverseasTravelDuration: Maybe<Scalars['String']['output']>;
  futureOverseasTravelReason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use futureOverseasTravel instead */
  future_overseas_travel: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use futureOverseasTravelDates instead */
  future_overseas_travel_dates: Maybe<Scalars['String']['output']>;
  /** @deprecated Use futureOverseasTravelDestination instead */
  future_overseas_travel_destination: Maybe<Scalars['String']['output']>;
  /** @deprecated Use futureOverseasTravelDuration instead */
  future_overseas_travel_duration: Maybe<Scalars['String']['output']>;
  /** @deprecated Use futureOverseasTravelReason instead */
  future_overseas_travel_reason: Maybe<Scalars['String']['output']>;
  generalOverseasTravel: Maybe<Scalars['Boolean']['output']>;
  generalOverseasTravelDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use generalOverseasTravel instead */
  general_overseas_travel: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use generalOverseasTravelDetails instead */
  general_overseas_travel_details: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isValid instead */
  is_valid: Maybe<Scalars['Boolean']['output']>;
  recentGeneralOverseasTravel: Maybe<Scalars['Boolean']['output']>;
  recentGeneralOverseasTravelDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use recentGeneralOverseasTravel instead */
  recent_general_overseas_travel: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use recentGeneralOverseasTravelDetails instead */
  recent_general_overseas_travel_details: Maybe<Scalars['String']['output']>;
  travelToWarCountry: Maybe<Scalars['Boolean']['output']>;
  travelToWarCountryDetails: Maybe<Scalars['String']['output']>;
  /** @deprecated Use travelToWarCountry instead */
  travel_to_war_country: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use travelToWarCountryDetails instead */
  travel_to_war_country_details: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TravelProfileUpdateMutation */
export type TravelProfileUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
  future_overseas_travel?: InputMaybe<Scalars['Boolean']['input']>;
  future_overseas_travel_dates?: InputMaybe<Scalars['String']['input']>;
  future_overseas_travel_destination?: InputMaybe<Scalars['String']['input']>;
  future_overseas_travel_duration?: InputMaybe<Scalars['String']['input']>;
  future_overseas_travel_reason?: InputMaybe<Scalars['String']['input']>;
  general_overseas_travel?: InputMaybe<Scalars['Boolean']['input']>;
  general_overseas_travel_details?: InputMaybe<Scalars['String']['input']>;
  recent_general_overseas_travel?: InputMaybe<Scalars['Boolean']['input']>;
  recent_general_overseas_travel_details?: InputMaybe<Scalars['String']['input']>;
  travel_to_war_country?: InputMaybe<Scalars['Boolean']['input']>;
  travel_to_war_country_details?: InputMaybe<Scalars['String']['input']>;
};

export type TrustPilotMetadata = {
  __typename?: 'TrustPilotMetadata';
  numberOfReviews: Scalars['Int']['output'];
  /** @deprecated Use numberOfReviews instead */
  number_of_reviews: Scalars['Int']['output'];
  reviews: Array<TrustPilotReview>;
  stars: Maybe<Scalars['Float']['output']>;
  trustScore: Scalars['Float']['output'];
  /** @deprecated Use trustScore instead */
  trust_score: Scalars['Float']['output'];
};

export type TrustPilotReview = {
  __typename?: 'TrustPilotReview';
  createdAt: Scalars['String']['output'];
  /** @deprecated Use createdAt instead */
  created_at: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** @deprecated Use displayName instead */
  display_name: Scalars['String']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isVerified instead */
  is_verified: Maybe<Scalars['Boolean']['output']>;
  stars: Maybe<Scalars['Int']['output']>;
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Umbrella = {
  __typename?: 'Umbrella';
  accelerated_underwriting_case: Maybe<AcceleratedUnderwritingCase>;
  accelerated_underwriting_form: Maybe<AcceleratedUnderwritingForm>;
  agent_uuid: Maybe<Scalars['ID']['output']>;
  aps_info: Maybe<ApsInfoResponseType>;
  available_views: Maybe<Array<Maybe<Views>>>;
  carrier_policy_report: Maybe<CarrierPolicyReport>;
  carrier_requirements: Maybe<Array<Maybe<CarrierRequirementsType>>>;
  cases_filter: Maybe<CasesFilter>;
  cases_search: Maybe<UmbrellaCasesSearch>;
  communications: Maybe<UmbrellaCommunications>;
  communications_feed: Maybe<Array<Maybe<CommunicationsFeedItem>>>;
  communications_feed_item: Maybe<CommunicationsFeedItem>;
  favorited_views: Maybe<Array<Maybe<Views>>>;
  form_templates: Maybe<Array<Maybe<FormTemplateSearchResult>>>;
  /** @deprecated use internal case */
  general_internal_case: Maybe<InternalCase>;
  home_prefill: Maybe<UmbrellaHomeAndAutoHomePrefillType>;
  id: Maybe<Scalars['ID']['output']>;
  insured_child_additional_questions: Maybe<InsuredChildAdditionalQuestions>;
  internal_case: Maybe<InternalCase>;
  life_application_metadata: Maybe<UmbrellaLifeApplicationMetadata>;
  macro_select_options: Maybe<SelectOptions>;
  macros: Maybe<Array<Maybe<Macro>>>;
  /** @deprecated bc y tho */
  macros_template_variables: Maybe<Scalars['String']['output']>;
  metadata: Maybe<UmbrellaMetadata>;
  notes: Maybe<Array<Maybe<Note>>>;
  paramedical_exam_info: Maybe<Array<Maybe<ParamedicalExamInfoType>>>;
  redirect_url: Maybe<AcceleratedUnderwritingCase>;
  underwriting_profile_summary: Maybe<Scalars['String']['output']>;
  views: Maybe<Array<Maybe<Views>>>;
  views_case_counts: Maybe<Array<Maybe<ViewCasesCount>>>;
  withdrawal_reasons: Maybe<Array<Maybe<WithdrawalReasonType>>>;
  withdrawal_request: Maybe<WithdrawalDetailsType>;
};


export type UmbrellaAccelerated_Underwriting_CaseArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaAccelerated_Underwriting_FormArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaAps_InfoArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaCarrier_Policy_ReportArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaCarrier_RequirementsArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaCases_FilterArgs = {
  filters?: InputMaybe<FiltersInputType>;
};


export type UmbrellaCommunications_FeedArgs = {
  conversation_id: Scalars['ID']['input'];
  starred_items_only?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UmbrellaCommunications_Feed_ItemArgs = {
  conversation_id: Scalars['String']['input'];
  item_id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type UmbrellaForm_TemplatesArgs = {
  carrier: Scalars['String']['input'];
  product_name?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type UmbrellaGeneral_Internal_CaseArgs = {
  id: Scalars['ID']['input'];
};


export type UmbrellaHome_PrefillArgs = {
  address?: InputMaybe<HomePrefillAddressInputType>;
  generated_by: Scalars['String']['input'];
  reference_id: Scalars['String']['input'];
};


export type UmbrellaInsured_Child_Additional_QuestionsArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaInternal_CaseArgs = {
  id: Scalars['ID']['input'];
};


export type UmbrellaLife_Application_MetadataArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaNotesArgs = {
  id: Scalars['ID']['input'];
};


export type UmbrellaParamedical_Exam_InfoArgs = {
  reference_id: Scalars['String']['input'];
};


export type UmbrellaRedirect_UrlArgs = {
  life_application_id: Scalars['ID']['input'];
};


export type UmbrellaUnderwriting_Profile_SummaryArgs = {
  customer_id: Scalars['ID']['input'];
};


export type UmbrellaViews_Case_CountsArgs = {
  views?: InputMaybe<Array<InputMaybe<FiltersInputType>>>;
};


export type UmbrellaWithdrawal_RequestArgs = {
  internal_case_id: Scalars['ID']['input'];
};

export type UmbrellaAmendmentMessageType = {
  __typename?: 'UmbrellaAmendmentMessageType';
  amendmentText: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  goodHealthStatement: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type UmbrellaBulkAssignGroupMemberType = {
  __typename?: 'UmbrellaBulkAssignGroupMemberType';
  /** Name of group member */
  name: Maybe<Scalars['String']['output']>;
  /** Team of the group member */
  team: Maybe<Scalars['String']['output']>;
  /** Uuid of group member */
  uuid: Maybe<Scalars['String']['output']>;
};

export type UmbrellaBulkAssignGroupType = {
  __typename?: 'UmbrellaBulkAssignGroupType';
  /** Id of the group creator */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Id of the group */
  id: Maybe<Scalars['ID']['output']>;
  /** Array of group members */
  members: Maybe<Array<UmbrellaBulkAssignGroupMemberType>>;
  /** Name of the bulk assign group */
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaCasesInternalCaseMilestoneType = {
  __typename?: 'UmbrellaCasesInternalCaseMilestoneType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type UmbrellaCasesSearch = {
  __typename?: 'UmbrellaCasesSearch';
  customersSearchResults: Maybe<Array<Maybe<CustomerSummaryType>>>;
  /** @deprecated Use customersSearchResults instead */
  customers_search_results: Maybe<Array<Maybe<CustomerSummaryType>>>;
  disabilityInternalCasesSearchResults: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  /** @deprecated Use disabilityInternalCasesSearchResults instead */
  disability_internal_cases_search_results: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  generalInternalCasesSearchResults: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  /** @deprecated Use generalInternalCasesSearchResults instead */
  general_internal_cases_search_results: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  internalCasesSearchResults: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  /** @deprecated Use internalCasesSearchResults instead */
  internal_cases_search_results: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  lifeInternalCasesSearchResults: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
  /** @deprecated Use lifeInternalCasesSearchResults instead */
  life_internal_cases_search_results: Maybe<Array<Maybe<UmbrellaInternalCaseSummaryType>>>;
};


export type UmbrellaCasesSearchCustomersSearchResultsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type UmbrellaCasesSearchCustomers_Search_ResultsArgs = {
  search_term: Scalars['String']['input'];
};


export type UmbrellaCasesSearchDisabilityInternalCasesSearchResultsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type UmbrellaCasesSearchDisability_Internal_Cases_Search_ResultsArgs = {
  search_term: Scalars['String']['input'];
};


export type UmbrellaCasesSearchGeneralInternalCasesSearchResultsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type UmbrellaCasesSearchGeneral_Internal_Cases_Search_ResultsArgs = {
  search_term: Scalars['String']['input'];
};


export type UmbrellaCasesSearchInternalCasesSearchResultsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type UmbrellaCasesSearchInternal_Cases_Search_ResultsArgs = {
  search_term: Scalars['String']['input'];
};


export type UmbrellaCasesSearchLifeInternalCasesSearchResultsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type UmbrellaCasesSearchLife_Internal_Cases_Search_ResultsArgs = {
  search_term: Scalars['String']['input'];
};

export type UmbrellaCommunications = {
  __typename?: 'UmbrellaCommunications';
  conversation_metadata: Maybe<ConversationMetadata>;
};


export type UmbrellaCommunicationsConversation_MetadataArgs = {
  conversation_id: Scalars['ID']['input'];
};

export type UmbrellaCommunicationsMutation = {
  __typename?: 'UmbrellaCommunicationsMutation';
  attachment_update: Maybe<AttachmentUpdate>;
  conversations_merge: Maybe<InternalCase>;
  feed_items_star: Maybe<Star>;
  message_send: Maybe<Message>;
};


export type UmbrellaCommunicationsMutationAttachment_UpdateArgs = {
  input: AttachmentUpdateMutationInput;
};


export type UmbrellaCommunicationsMutationConversations_MergeArgs = {
  input: ConversationsMergeMutationInput;
};


export type UmbrellaCommunicationsMutationFeed_Items_StarArgs = {
  input: FeedItemsStarMutationInput;
};


export type UmbrellaCommunicationsMutationMessage_SendArgs = {
  input: MessageSendMutationInput;
};

/** A user-readable error */
export type UmbrellaErrorType = {
  __typename?: 'UmbrellaErrorType';
  /** The full_message of the error return */
  message: Scalars['String']['output'];
};

export type UmbrellaEverlyApprovedChildRiderType = {
  __typename?: 'UmbrellaEverlyApprovedChildRiderType';
  age: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
};

export type UmbrellaEverlyDocumentType = {
  __typename?: 'UmbrellaEverlyDocumentType';
  attachmentType: Maybe<Scalars['String']['output']>;
  docPopUrl: Maybe<Scalars['String']['output']>;
  documentId: Maybe<Scalars['Int']['output']>;
};

export type UmbrellaEverlyPolicyValidationExceptionType = {
  __typename?: 'UmbrellaEverlyPolicyValidationExceptionType';
  executionDetails: Array<UmbrellaEverlyPolicyValidationExecutionDetailType>;
  ruleName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UmbrellaEverlyPolicyValidationExecutionDetailType = {
  __typename?: 'UmbrellaEverlyPolicyValidationExecutionDetailType';
  detailReason: Scalars['String']['output'];
  exceptionId: Scalars['String']['output'];
  nmId: Scalars['String']['output'];
};

export type UmbrellaHomeAndAutoAdditionalCoveragePreferenceType = {
  __typename?: 'UmbrellaHomeAndAutoAdditionalCoveragePreferenceType';
  display_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoArchitectureStyleType = {
  __typename?: 'UmbrellaHomeAndAutoArchitectureStyleType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoBundleType = {
  __typename?: 'UmbrellaHomeAndAutoBundleType';
  annual_premium: Maybe<Scalars['Float']['output']>;
  customer_selected: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  is_hybrid: Maybe<Scalars['Boolean']['output']>;
  policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoPolicyType>>>;
};

export type UmbrellaHomeAndAutoCarrierType = {
  __typename?: 'UmbrellaHomeAndAutoCarrierType';
  carrier_slug: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoCollectPolicyInfoType = {
  __typename?: 'UmbrellaHomeAndAutoCollectPolicyInfoType';
  internal_note: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoConstructionTypeType = {
  __typename?: 'UmbrellaHomeAndAutoConstructionTypeType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoCoverageDeductibleType = {
  __typename?: 'UmbrellaHomeAndAutoCoverageDeductibleType';
  amount: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoDriverLicenseStatusType = {
  __typename?: 'UmbrellaHomeAndAutoDriverLicenseStatusType';
  display_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoDwellingEndorsementType = {
  __typename?: 'UmbrellaHomeAndAutoDwellingEndorsementType';
  building_additions_alterations_amount: Maybe<Scalars['Int']['output']>;
  existing_foundation_damage: Maybe<Scalars['Boolean']['output']>;
  foundation_coverage: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  identity_theft: Maybe<Scalars['Boolean']['output']>;
  increased_coverage_on_credit_card_amount: Maybe<Scalars['Int']['output']>;
  increased_limit_jewelry_watches_fur_amount: Maybe<Scalars['Int']['output']>;
  increased_mold_increase_liability: Maybe<Scalars['Boolean']['output']>;
  increased_mold_property_damage_amount: Maybe<Scalars['Int']['output']>;
  increased_replacement_cost_dwelling_percentage: Maybe<Scalars['Float']['output']>;
  loss_assessment_amount: Maybe<Scalars['Int']['output']>;
  mine_subsidence: Maybe<Scalars['Boolean']['output']>;
  off_premises_theft_exclusion: Maybe<Scalars['Boolean']['output']>;
  ordinance_law_percentage: Maybe<Scalars['Float']['output']>;
  permitted_incidental_business_occupancy: Maybe<Scalars['Boolean']['output']>;
  personal_injury: Maybe<Scalars['Boolean']['output']>;
  replacement_cost_content: Maybe<Scalars['Boolean']['output']>;
  residence_glass: Maybe<Scalars['Boolean']['output']>;
  scheduled_personal_properties: Maybe<Array<Maybe<UmbrellaHomeAndAutoScheduledPersonalPropertyType>>>;
  sinkhole_collapse: Maybe<Scalars['Boolean']['output']>;
  sinkhole_collapse_amount: Maybe<Scalars['Int']['output']>;
  water_backup_amount: Maybe<Scalars['Int']['output']>;
  water_damage: Maybe<Scalars['Boolean']['output']>;
  windstorm_hurricane_hail_exclusion: Maybe<Scalars['Boolean']['output']>;
};

export type UmbrellaHomeAndAutoExistingBusinessPolicyType = {
  __typename?: 'UmbrellaHomeAndAutoExistingBusinessPolicyType';
  annual_premium: Maybe<Scalars['Float']['output']>;
  carrier_name: Maybe<Scalars['String']['output']>;
  carrier_policy_number: Maybe<Scalars['String']['output']>;
  carrier_slug: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['DateTime']['output']>;
  effective_date: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  term_in_months: Maybe<Scalars['Int']['output']>;
  vertical_name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoFormValueType = {
  __typename?: 'UmbrellaHomeAndAutoFormValueType';
  additional_coverage_preferences: Maybe<Array<Maybe<UmbrellaHomeAndAutoAdditionalCoveragePreferenceType>>>;
  architectural_styles: Maybe<Array<Maybe<UmbrellaHomeAndAutoArchitectureStyleType>>>;
  carriers: Maybe<Array<Maybe<UmbrellaHomeAndAutoCarrierType>>>;
  construction_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoConstructionTypeType>>>;
  driver_license_statuses: Maybe<Array<Maybe<UmbrellaHomeAndAutoDriverLicenseStatusType>>>;
  foundation_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoFoundationType>>>;
  occupancy_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoOccupancyType>>>;
  occupations: Maybe<Array<Maybe<UmbrellaHomeAndAutoOccupationType>>>;
  payment_method_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoPaymentMethodType>>>;
  payment_mode_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoPaymentModeType>>>;
  renovation_years: Maybe<Array<Maybe<UmbrellaHomeAndAutoRenovationYearType>>>;
  roof_designs: Maybe<Array<Maybe<UmbrellaHomeAndAutoRoofDesignType>>>;
  roof_types: Maybe<Array<Maybe<UmbrellaHomeAndAutoRoofTypeType>>>;
  verticals: Maybe<Array<Maybe<UmbrellaHomeAndAutoVerticalType>>>;
};

export type UmbrellaHomeAndAutoFoundationType = {
  __typename?: 'UmbrellaHomeAndAutoFoundationType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoHomePrefillType = {
  __typename?: 'UmbrellaHomeAndAutoHomePrefillType';
  architectural_style: Maybe<Scalars['String']['output']>;
  basement_status: Maybe<Scalars['String']['output']>;
  construction_type: Maybe<Scalars['String']['output']>;
  dwelling: Maybe<Scalars['String']['output']>;
  foundation_type: Maybe<Scalars['String']['output']>;
  heating_system: Maybe<Scalars['String']['output']>;
  number_of_bathrooms: Maybe<Scalars['Float']['output']>;
  number_of_stories: Maybe<Scalars['Int']['output']>;
  replacement_cost_estimate: Maybe<Scalars['Int']['output']>;
  roof_design: Maybe<Scalars['String']['output']>;
  roof_type: Maybe<Scalars['String']['output']>;
  square_footage: Maybe<Scalars['Int']['output']>;
  year_built: Maybe<Scalars['Int']['output']>;
};

export type UmbrellaHomeAndAutoOccupancyType = {
  __typename?: 'UmbrellaHomeAndAutoOccupancyType';
  display_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoOccupationType = {
  __typename?: 'UmbrellaHomeAndAutoOccupationType';
  id: Maybe<Scalars['ID']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  occupation: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoPaymentMethodType = {
  __typename?: 'UmbrellaHomeAndAutoPaymentMethodType';
  display_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoPaymentModeType = {
  __typename?: 'UmbrellaHomeAndAutoPaymentModeType';
  display_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoPolicyType = {
  __typename?: 'UmbrellaHomeAndAutoPolicyType';
  annual_premium: Maybe<Scalars['Float']['output']>;
  bundle_id: Maybe<Scalars['String']['output']>;
  carrier_logo: Maybe<Scalars['String']['output']>;
  carrier_name: Maybe<Scalars['String']['output']>;
  carrier_slug: Maybe<Scalars['String']['output']>;
  coverages: Maybe<Array<Maybe<UmbrellaHomeAndAutoCoverageDeductibleType>>>;
  customer_selected: Maybe<Scalars['Boolean']['output']>;
  deductibles: Maybe<Array<Maybe<UmbrellaHomeAndAutoCoverageDeductibleType>>>;
  dwelling_endorsements: Maybe<UmbrellaHomeAndAutoDwellingEndorsementType>;
  error: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  latest_updated_at: Maybe<Scalars['DateTime']['output']>;
  monthly_premium: Maybe<Scalars['Float']['output']>;
  not_insured_reason: Maybe<Scalars['String']['output']>;
  occupancy_type: Maybe<UmbrellaHomeAndAutoOccupancyType>;
  occupancy_type_id: Maybe<Scalars['ID']['output']>;
  payment_mode: Maybe<Scalars['String']['output']>;
  policy_type: Maybe<Scalars['String']['output']>;
  premium_range: Maybe<Scalars['String']['output']>;
  quote_links: Maybe<UmbrellaHomeAndAutoQuoteLinkType>;
  reference_id: Maybe<Scalars['String']['output']>;
  savings: Maybe<Scalars['Float']['output']>;
  term_in_months: Maybe<Scalars['Int']['output']>;
  unavailable_rate: Maybe<Scalars['Boolean']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
  upsell: Maybe<Scalars['Boolean']['output']>;
  vertical: Maybe<UmbrellaHomeAndAutoVerticalType>;
  vertical_id: Maybe<Scalars['ID']['output']>;
  vertical_name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoQuoteEstimatesSendEstimatesEmailType = {
  __typename?: 'UmbrellaHomeAndAutoQuoteEstimatesSendEstimatesEmailType';
  estimates_email: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoQuoteEstimatesType = {
  __typename?: 'UmbrellaHomeAndAutoQuoteEstimatesType';
  bundles: Maybe<Array<Maybe<UmbrellaHomeAndAutoBundleType>>>;
  id: Maybe<Scalars['ID']['output']>;
  policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoPolicyType>>>;
  request_state: Maybe<UmbrellaHomeAndAutoRequestStateType>;
  sections: Maybe<Array<Maybe<UmbrellaHomeAndAutoSectionType>>>;
  slide_id: Maybe<Scalars['String']['output']>;
  slide_url: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type UmbrellaHomeAndAutoQuoteFinalType = {
  __typename?: 'UmbrellaHomeAndAutoQuoteFinalType';
  created_at: Maybe<Scalars['DateTime']['output']>;
  existing_business_policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoExistingBusinessPolicyType>>>;
  id: Maybe<Scalars['ID']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoPolicyType>>>;
  recommended: Maybe<Scalars['Boolean']['output']>;
  slide_id: Maybe<Scalars['String']['output']>;
  slide_url: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoQuoteLinkType = {
  __typename?: 'UmbrellaHomeAndAutoQuoteLinkType';
  carrier_link: Maybe<Scalars['String']['output']>;
  ezlynx_link: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoRenewalOfferType = {
  __typename?: 'UmbrellaHomeAndAutoRenewalOfferType';
  carrier_name: Maybe<Scalars['String']['output']>;
  current_term_premium: Maybe<Scalars['Float']['output']>;
  effective_date: Maybe<Scalars['String']['output']>;
  expiration_date: Maybe<Scalars['String']['output']>;
  policy_number: Maybe<Scalars['String']['output']>;
  premium_percent_change: Maybe<Scalars['Float']['output']>;
  product_type: Maybe<Scalars['String']['output']>;
  received_at: Maybe<Scalars['String']['output']>;
  term: Maybe<Scalars['Int']['output']>;
  written_premium: Maybe<Scalars['Float']['output']>;
};

export type UmbrellaHomeAndAutoRenovationYearType = {
  __typename?: 'UmbrellaHomeAndAutoRenovationYearType';
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

export type UmbrellaHomeAndAutoRequestStateType = {
  __typename?: 'UmbrellaHomeAndAutoRequestStateType';
  actual_response_count: Maybe<Scalars['Int']['output']>;
  expected_response_count: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['DateTime']['output']>;
};

export type UmbrellaHomeAndAutoRoofDesignType = {
  __typename?: 'UmbrellaHomeAndAutoRoofDesignType';
  ezlynx_name: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoRoofTypeType = {
  __typename?: 'UmbrellaHomeAndAutoRoofTypeType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoScheduledPersonalPropertyType = {
  __typename?: 'UmbrellaHomeAndAutoScheduledPersonalPropertyType';
  amount: Maybe<Scalars['Int']['output']>;
  breakage: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaHomeAndAutoSectionType = {
  __typename?: 'UmbrellaHomeAndAutoSectionType';
  combo: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  policies: Maybe<Array<Maybe<UmbrellaHomeAndAutoPolicyType>>>;
};

export type UmbrellaHomeAndAutoVerticalType = {
  __typename?: 'UmbrellaHomeAndAutoVerticalType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/**
 * Translation of an elasticsearch \
 *                      record into a useful summary of our internal case
 */
export type UmbrellaInternalCaseSummaryType = {
  __typename?: 'UmbrellaInternalCaseSummaryType';
  annualPremium: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use annualPremium instead */
  annual_premium: Maybe<Scalars['Int']['output']>;
  /**
   * The transaction type of a Home and Auto application, \
   *                             e.g. Reshop, New Business
   */
  applicationType: Maybe<Scalars['String']['output']>;
  /**
   * The transaction type of a Home and Auto application, \
   *                                              e.g. Reshop, New Business
   * @deprecated Use applicationType instead
   */
  application_type: Maybe<Scalars['String']['output']>;
  approvalFlags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use approvalFlags instead */
  approval_flags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  apsAttributes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use apsAttributes instead */
  aps_attributes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Just the first name */
  assigneeFirstName: Maybe<Scalars['String']['output']>;
  assigneeFullName: Maybe<Scalars['String']['output']>;
  assigneeId: Maybe<Scalars['ID']['output']>;
  /** Just the last name of the assignee */
  assigneeLastName: Maybe<Scalars['String']['output']>;
  assigneeTeam: Maybe<Scalars['String']['output']>;
  /**
   * Just the first name
   * @deprecated Use assigneeFirstName instead
   */
  assignee_first_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use assigneeFullName instead */
  assignee_full_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use assigneeId instead */
  assignee_id: Maybe<Scalars['ID']['output']>;
  /**
   * Just the last name of the assignee
   * @deprecated Use assigneeLastName instead
   */
  assignee_last_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use assigneeTeam instead */
  assignee_team: Maybe<Scalars['String']['output']>;
  carrierName: Maybe<Scalars['String']['output']>;
  carrierSlug: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierName instead */
  carrier_name: Maybe<Scalars['String']['output']>;
  /** @deprecated Use carrierSlug instead */
  carrier_slug: Maybe<Scalars['String']['output']>;
  caseAgeInDays: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use caseAgeInDays instead */
  case_age_in_days: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt instead */
  created_at: Maybe<Scalars['DateTime']['output']>;
  /** Customer email */
  customerEmail: Maybe<Scalars['String']['output']>;
  customerFirstName: Maybe<Scalars['String']['output']>;
  /** Name of the customer */
  customerFullName: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the customer */
  customerId: Maybe<Scalars['String']['output']>;
  customerLastName: Maybe<Scalars['String']['output']>;
  /** Customer phone number */
  customerPhone: Maybe<Scalars['String']['output']>;
  /** Customer timezone */
  customerTimezone: Maybe<Scalars['String']['output']>;
  /**
   * Customer email
   * @deprecated Use customerEmail instead
   */
  customer_email: Maybe<Scalars['String']['output']>;
  /** @deprecated Use customerFirstName instead */
  customer_first_name: Maybe<Scalars['String']['output']>;
  /**
   * Name of the customer
   * @deprecated Use customerFullName instead
   */
  customer_full_name: Maybe<Scalars['String']['output']>;
  /**
   * Unique identifier of the customer
   * @deprecated Use customerId instead
   */
  customer_id: Maybe<Scalars['String']['output']>;
  /** @deprecated Use customerLastName instead */
  customer_last_name: Maybe<Scalars['String']['output']>;
  /**
   * Customer phone number
   * @deprecated Use customerPhone instead
   */
  customer_phone: Maybe<Scalars['String']['output']>;
  deliveryDueDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Use deliveryDueDate instead */
  delivery_due_date: Maybe<Scalars['String']['output']>;
  /** Everly case ID from the everly_interview */
  everlyCaseId: Maybe<Scalars['String']['output']>;
  /**
   * Everly case ID from the everly_interview
   * @deprecated Use everlyCaseId instead
   */
  everly_case_id: Maybe<Scalars['String']['output']>;
  excludeTags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use excludeTags instead */
  exclude_tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  followUpDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Use followUpDate instead */
  follow_up_date: Maybe<Scalars['String']['output']>;
  /** Another alias for the globally unique reference id */
  id: Maybe<Scalars['ID']['output']>;
  lastUpdatedAt: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastUpdatedAt instead */
  last_updated_at: Maybe<Scalars['String']['output']>;
  lifecycleStage: Maybe<Scalars['String']['output']>;
  lifecycleStageAgeInDays: Maybe<Scalars['Int']['output']>;
  lifecycleStageStartedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lifecycleStage instead */
  lifecycle_stage: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lifecycleStageAgeInDays instead */
  lifecycle_stage_age_in_days: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use lifecycleStageStartedAt instead */
  lifecycle_stage_started_at: Maybe<Scalars['DateTime']['output']>;
  /** Time passed since case opened; used for new general cases */
  messageAge: Maybe<Scalars['String']['output']>;
  /**
   * Time passed since case /
   *                                              opened; used for new general cases
   * @deprecated Use messageAge instead
   */
  message_age: Maybe<Scalars['String']['output']>;
  milestones: Maybe<Array<Maybe<InternalCaseMilestoneSummary>>>;
  numberOfCalls: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use numberOfCalls instead */
  number_of_calls: Maybe<Scalars['Int']['output']>;
  openForInHours: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use openForInHours instead */
  open_for_in_hours: Maybe<Scalars['Int']['output']>;
  /** The IDs of all owners of the case */
  owners: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** P&C application is for a new purchase home or reshop */
  pncIsNewPurchase: Maybe<Scalars['Boolean']['output']>;
  /** The product type of a home and auto application. */
  pncProductTypes: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  pncShoppingReason: Maybe<Scalars['String']['output']>;
  /**
   * P&C application is for a new purchase home or reshop
   * @deprecated Use pncIsNewPurchase instead
   */
  pnc_is_new_purchase: Maybe<Scalars['Boolean']['output']>;
  /**
   * The product type of a home and auto application.
   * @deprecated Use pncProductTypes instead
   */
  pnc_product_types: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  policyDecisionType: Maybe<Scalars['String']['output']>;
  policyNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyDecisionType instead */
  policy_decision_type: Maybe<Scalars['String']['output']>;
  /** @deprecated Use policyNumber instead */
  policy_number: Maybe<Scalars['String']['output']>;
  productType: Maybe<Scalars['String']['output']>;
  /** @deprecated Use productType instead */
  product_type: Maybe<Scalars['String']['output']>;
  /** The globally-unique reference id of the internal case */
  referenceId: Maybe<Scalars['String']['output']>;
  /**
   * The globally-unique reference id of the internal case
   * @deprecated Use referenceId instead
   */
  reference_id: Maybe<Scalars['String']['output']>;
  /** Agency type of the referring agent - BOR, Fee Only or Subproducer */
  referralAgencyType: Maybe<Scalars['String']['output']>;
  /** Referring Agency and Referring Vendor names for PgPro cases */
  referringOrganizationName: Maybe<Scalars['String']['output']>;
  /**
   * The globally sequentially id, \
   *                             historically used for routing life applications
   */
  sequentialId: Maybe<Scalars['Int']['output']>;
  /**
   * The globally sequentially id, historically \
   *                                              used for routing life applications
   * @deprecated Use sequentialId instead
   */
  sequential_id: Maybe<Scalars['Int']['output']>;
  /** Source of the application, either PgPro or other */
  source: Maybe<Scalars['String']['output']>;
  status: Maybe<InternalCaseStatus>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Maybe<Scalars['String']['output']>;
  underwritingClassDecision: Maybe<Scalars['String']['output']>;
  /** @deprecated Use underwritingClassDecision instead */
  underwriting_class_decision: Maybe<Scalars['String']['output']>;
  zendeskTicketId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use zendeskTicketId instead */
  zendesk_ticket_id: Maybe<Scalars['Int']['output']>;
};

/** Tasks on an internal case */
export type UmbrellaInternalCaseTaskType = {
  __typename?: 'UmbrellaInternalCaseTaskType';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt instead */
  created_at: Maybe<Scalars['DateTime']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  internalCaseId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use internalCaseId instead */
  internal_case_id: Maybe<Scalars['Int']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  statusGroup: Maybe<Scalars['String']['output']>;
  statusReason: Maybe<Scalars['String']['output']>;
  statusReasonText: Maybe<Scalars['String']['output']>;
  /** @deprecated Use statusGroup instead */
  status_group: Maybe<Scalars['String']['output']>;
  /** @deprecated Use statusReason instead */
  status_reason: Maybe<Scalars['String']['output']>;
  /** @deprecated Use statusReasonText instead */
  status_reason_text: Maybe<Scalars['String']['output']>;
};

export type UmbrellaLifeApplicationMetadata = {
  __typename?: 'UmbrellaLifeApplicationMetadata';
  apps_med_exam_url: Maybe<Scalars['String']['output']>;
  aps_states: Maybe<Array<Maybe<ApsStateType>>>;
  base_packets: Maybe<Array<Maybe<DocumentPacket>>>;
  carrier_portal_url: Maybe<Scalars['String']['output']>;
  changed_over_from_applications: Maybe<Array<Maybe<LifeApplication>>>;
  changed_over_to_applications: Maybe<Array<Maybe<LifeApplication>>>;
  custom_forms: Maybe<CustomFormsType>;
  default_tma_mailer_body: Maybe<Scalars['String']['output']>;
  everly_interview: EverlyInterview;
  id: Maybe<Scalars['ID']['output']>;
  med_exam_details: Maybe<Scalars['String']['output']>;
  policy_snapshot_differences: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reference_id: Maybe<Scalars['ID']['output']>;
  requires_additional_questions: Maybe<Scalars['Boolean']['output']>;
  requires_aps: Maybe<ApsRequirement>;
  requires_family_history: Maybe<Scalars['Boolean']['output']>;
  smm_med_exam_url: Maybe<Scalars['String']['output']>;
  supplemental_packets: Maybe<Array<Maybe<DocumentPacket>>>;
  supported_by_accordion: Maybe<Scalars['Boolean']['output']>;
  zendesk_ticket_id: Maybe<Scalars['Int']['output']>;
};

/** Metadata for Umbrella */
export type UmbrellaMetadata = {
  __typename?: 'UmbrellaMetadata';
  agents: Maybe<Array<Maybe<ElevatedUser>>>;
  approval_properties: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aps_status_options: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  case_managers: Maybe<Array<Maybe<ElevatedUser>>>;
  case_statuses: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  form_confirmations: Maybe<Array<Maybe<FormConfirmations>>>;
  genericTeamUsers: Maybe<Array<Maybe<ElevatedUser>>>;
  generic_team_users: Maybe<Array<Maybe<ElevatedUser>>>;
  home_and_auto_carriers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  home_and_auto_form_values: Maybe<UmbrellaHomeAndAutoFormValueType>;
  home_and_auto_quote_sections: Maybe<Array<Maybe<UmbrellaHomeAndAutoSectionType>>>;
  id: Maybe<Scalars['ID']['output']>;
  lifecycle_stages: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  milestone_statuses: Maybe<InternalCaseMilestoneStatusesType>;
  mortgage_companies: Maybe<Array<Maybe<HomeAndAutoApplicationThirdPartyCompanyType>>>;
  mortgage_contacts: Maybe<Array<Maybe<HomeAndAutoApplicationThirdPartyContactType>>>;
  policy_statuses: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  producer_license_code_spreadsheet_url: Maybe<Scalars['String']['output']>;
  product_access_roles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  referring_organization_name: Maybe<Array<Maybe<UmbrellaMetadataReferringOrganizationType>>>;
  tags: Maybe<Array<Maybe<UmbrellaMetadataTagType>>>;
  team_members: Maybe<Array<Maybe<ElevatedUser>>>;
  team_members_and_permissions: Maybe<Array<Maybe<ElevatedUser>>>;
  teams: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  types: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  umbrellaSafeguardUsers: Maybe<Array<Maybe<SafeguardUser>>>;
  umbrella_safeguard_users: Maybe<Array<Maybe<SafeguardUser>>>;
};


/** Metadata for Umbrella */
export type UmbrellaMetadataForm_ConfirmationsArgs = {
  customer_id: Scalars['ID']['input'];
  disability_application_id?: InputMaybe<Scalars['ID']['input']>;
  life_application_id?: InputMaybe<Scalars['ID']['input']>;
};


/** Metadata for Umbrella */
export type UmbrellaMetadataLifecycle_StagesArgs = {
  product_type?: InputMaybe<Scalars['String']['input']>;
};


/** Metadata for Umbrella */
export type UmbrellaMetadataMortgage_ContactsArgs = {
  company_id: Scalars['ID']['input'];
};


/** Metadata for Umbrella */
export type UmbrellaMetadataReferring_Organization_NameArgs = {
  order_by?: InputMaybe<Scalars['String']['input']>;
};


/** Metadata for Umbrella */
export type UmbrellaMetadataUmbrellaSafeguardUsersArgs = {
  filter?: InputMaybe<ElevatedUserSearchInput>;
};


/** Metadata for Umbrella */
export type UmbrellaMetadataUmbrella_Safeguard_UsersArgs = {
  filter?: InputMaybe<ElevatedUserSearchInput>;
};

export type UmbrellaMetadataReferringOrganizationType = {
  __typename?: 'UmbrellaMetadataReferringOrganizationType';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type UmbrellaMetadataTagType = {
  __typename?: 'UmbrellaMetadataTagType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UmbrellaMutation = {
  __typename?: 'UmbrellaMutation';
  accelerated_underwriting: Maybe<AcceleratedUnderwritingMutation>;
  accelerated_underwriting_form: Maybe<AcceleratedUnderwritingFormsMutation>;
  access_control: Maybe<AccessControlMutation>;
  additional_questions_update: Maybe<CustomFormsType>;
  application_create: Maybe<Customer>;
  aps: Maybe<ApsMutation>;
  bank_account_url_fetch: Maybe<Scalars['String']['output']>;
  bulk_assign_group_create: Maybe<Query>;
  bulk_assign_group_delete: Maybe<Query>;
  carrier_requirement_update: Maybe<CarrierRequirementsType>;
  client_decision_create: Maybe<AcceleratedUnderwritingCase>;
  communications: Maybe<UmbrellaCommunicationsMutation>;
  conversation_metadata_update: Maybe<ConversationMetadata>;
  copy_selected_quotes: Maybe<CopyQuotesType>;
  custom_form_response_update: Maybe<CustomFormsType>;
  customer_create: Maybe<Customer>;
  customer_from_general_case_create: Maybe<Customer>;
  customer_unsubscribe: Maybe<Customer>;
  document_packets: Maybe<DocumentPacketsMutation>;
  elevated_user_create: Maybe<ElevatedUser>;
  everly: Maybe<Everly>;
  form_confirmations_update: Maybe<UmbrellaMetadata>;
  hipaa_preauth_create: Maybe<HipaaPreAuth>;
  home_and_auto: Maybe<HomeAndAutoMutation>;
  hydrate_residence_profile: Maybe<ResidenceProfile>;
  insured_child_additional_questions_update: Maybe<InsuredChildAdditionalQuestions>;
  internal_case_bulk_update: Maybe<Scalars['String']['output']>;
  internal_case_tasks: Maybe<InternalCaseTasksMutation>;
  internal_case_update: Maybe<InternalCase>;
  life_application_submit: Maybe<LifeApplication>;
  life_application_update: Maybe<LifeApplication>;
  macros: Maybe<MacrosMutation>;
  med_exam_availability: Maybe<MedExamAvailabilityType>;
  med_exam_order: Maybe<MedExamOrderType>;
  med_exam_reservation: Maybe<MedExamReservationType>;
  med_exam_reservation_cancelation: Maybe<MedExamReservationCancelationType>;
  med_exam_reservation_details: Maybe<MedExamReservationDetailsType>;
  med_exam_update: Maybe<UmbrellaLifeApplicationMetadata>;
  motivation_update: Maybe<MotivationType>;
  notes_update: Maybe<Note>;
  paramedical_exam_info_update: Maybe<ParamedicalExamInfoType>;
  policy_delete: Maybe<LifeApplicationPolicy>;
  policy_update: Maybe<LifeApplicationPolicy>;
  quotes_email: Maybe<LifeApplication>;
  safeguard_user_roles_add: Maybe<UmbrellaMetadata>;
  tags_delete: Maybe<UmbrellaMetadata>;
  teams_create: Maybe<UmbrellaMetadata>;
  users_product_access_roles_update: Maybe<UmbrellaMetadata>;
  views: Maybe<UmbrellaViewsMutation>;
  withdrawal_request: Maybe<WithdrawalDetailsType>;
};


export type UmbrellaMutationAdditional_Questions_UpdateArgs = {
  input: AdditionalQuestionsUpdateMutationInput;
};


export type UmbrellaMutationApplication_CreateArgs = {
  input: ApplicationCreateMutationInput;
};


export type UmbrellaMutationBank_Account_Url_FetchArgs = {
  input: BankAccountUrlFetchMutationInput;
};


export type UmbrellaMutationBulk_Assign_Group_CreateArgs = {
  input: BulkAssignGroupCreateMutationInput;
};


export type UmbrellaMutationBulk_Assign_Group_DeleteArgs = {
  input: BulkAssignGroupDeleteMutationInput;
};


export type UmbrellaMutationCarrier_Requirement_UpdateArgs = {
  input: CarrierRequirementUpdateMutationInput;
};


export type UmbrellaMutationClient_Decision_CreateArgs = {
  input: ClientDecisionCreateMutationInput;
};


export type UmbrellaMutationConversation_Metadata_UpdateArgs = {
  input: ConversationMetadataUpdateMutationInput;
};


export type UmbrellaMutationCopy_Selected_QuotesArgs = {
  input: CopySelectedQuotesInput;
};


export type UmbrellaMutationCustom_Form_Response_UpdateArgs = {
  input: CustomFormResponseUpdateMutationInput;
};


export type UmbrellaMutationCustomer_CreateArgs = {
  input: CustomerCreateMutationInput;
};


export type UmbrellaMutationCustomer_From_General_Case_CreateArgs = {
  input: CustomerFromGeneralCaseCreateMutationInput;
};


export type UmbrellaMutationCustomer_UnsubscribeArgs = {
  input: CustomerUnsubscribeMutationInput;
};


export type UmbrellaMutationElevated_User_CreateArgs = {
  input: ElevatedUserCreateMutationInput;
};


export type UmbrellaMutationForm_Confirmations_UpdateArgs = {
  input: FormConfirmationsUpdateMutationInput;
};


export type UmbrellaMutationHipaa_Preauth_CreateArgs = {
  input: HipaaPreAuthCreateMutationInput;
};


export type UmbrellaMutationHydrate_Residence_ProfileArgs = {
  input: HydrateResidenceProfileInput;
};


export type UmbrellaMutationInsured_Child_Additional_Questions_UpdateArgs = {
  input: InsuredChildAdditionalQuestionsUpdateMutationInput;
};


export type UmbrellaMutationInternal_Case_Bulk_UpdateArgs = {
  input: InternalCaseBulkUpdateMutationInput;
};


export type UmbrellaMutationInternal_Case_UpdateArgs = {
  input: InternalCaseUpdateMutationInput;
};


export type UmbrellaMutationLife_Application_SubmitArgs = {
  input: LifeApplicationSubmitMutationInput;
};


export type UmbrellaMutationLife_Application_UpdateArgs = {
  input: LifeApplicationUpdateMutationInput;
};


export type UmbrellaMutationMed_Exam_AvailabilityArgs = {
  input: MedExamAvailabilityMutationInput;
};


export type UmbrellaMutationMed_Exam_OrderArgs = {
  input: MedExamOrderMutationInput;
};


export type UmbrellaMutationMed_Exam_ReservationArgs = {
  input: MedExamReservationMutationInput;
};


export type UmbrellaMutationMed_Exam_Reservation_CancelationArgs = {
  input: MedExamReservationCancelationMutationInput;
};


export type UmbrellaMutationMed_Exam_Reservation_DetailsArgs = {
  input: MedExamReservationDetailsMutationInput;
};


export type UmbrellaMutationMed_Exam_UpdateArgs = {
  input: MedExamUpdateMutationInput;
};


export type UmbrellaMutationMotivation_UpdateArgs = {
  input: MotivationUpdateMutationInput;
};


export type UmbrellaMutationNotes_UpdateArgs = {
  input: NotesUpdateMutationInput;
};


export type UmbrellaMutationParamedical_Exam_Info_UpdateArgs = {
  input: ParamedicalExamInfoUpdateInput;
};


export type UmbrellaMutationPolicy_DeleteArgs = {
  input: PolicyDeleteMutationInput;
};


export type UmbrellaMutationPolicy_UpdateArgs = {
  input: PolicyUpdateMutationInput;
};


export type UmbrellaMutationQuotes_EmailArgs = {
  input: QuotesEmailMutationInput;
};


export type UmbrellaMutationSafeguard_User_Roles_AddArgs = {
  input: SafeguardUserRolesAddMutationInput;
};


export type UmbrellaMutationTags_DeleteArgs = {
  input: TagsDeleteMutationInput;
};


export type UmbrellaMutationTeams_CreateArgs = {
  input: TeamsCreateMutationInput;
};


export type UmbrellaMutationUsers_Product_Access_Roles_UpdateArgs = {
  input: UsersProductAccessRolesUpdateMutationInput;
};


export type UmbrellaMutationWithdrawal_RequestArgs = {
  input: WithdrawalRequestCreateMutationInput;
};

export type UmbrellaViewsMutation = {
  __typename?: 'UmbrellaViewsMutation';
  views_apply: Maybe<Views>;
  views_create: Maybe<Views>;
  views_reorder: Maybe<Array<Maybe<Views>>>;
  views_unfavorite: Maybe<Array<Maybe<Views>>>;
};


export type UmbrellaViewsMutationViews_ApplyArgs = {
  input: ViewsApplyMutationInput;
};


export type UmbrellaViewsMutationViews_CreateArgs = {
  input: ViewsCreateMutationInput;
};


export type UmbrellaViewsMutationViews_ReorderArgs = {
  input: ViewsReorderMutationInput;
};


export type UmbrellaViewsMutationViews_UnfavoriteArgs = {
  input: ViewsUnfavoriteMutationInput;
};

/** Autogenerated input type of UnderwritingDetailsUpdateMutation */
export type UnderwritingDetailsUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_during_underwriting?: InputMaybe<Scalars['Boolean']['input']>;
  coverage_reason?: InputMaybe<Scalars['String']['input']>;
  reference_id: Scalars['ID']['input'];
};

/** Underwriting outcomes for an AU policy's underwriting process */
export type UnderwritingOutcome = {
  __typename?: 'UnderwritingOutcome';
  category: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateHazardousEmploymentProfile */
export type UpdateHazardousEmploymentProfileInput = {
  bartender?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  correctionsOfficer?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  fireFighter?: InputMaybe<Scalars['Boolean']['input']>;
  military?: InputMaybe<Scalars['Boolean']['input']>;
  nightclub?: InputMaybe<Scalars['Boolean']['input']>;
  pilotOrFlightCrew?: InputMaybe<Scalars['Boolean']['input']>;
  professionalSportsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  stuntPerson?: InputMaybe<Scalars['Boolean']['input']>;
  swat?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateHazardousEmploymentProfile */
export type UpdateHazardousEmploymentProfilePayload = {
  __typename?: 'UpdateHazardousEmploymentProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  hazardousEmploymentProfile: HazardousEmploymentProfile;
};

/** Autogenerated input type of UpdateInternalCase */
export type UpdateInternalCaseInput = {
  assignee_id?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  follow_up_date?: InputMaybe<Scalars['DateTime']['input']>;
  internal_case_id: Scalars['Int']['input'];
  lifecycle_stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InternalCaseStatus>;
  team_member_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Autogenerated input type of UpdateMacro */
export type UpdateMacroInput = {
  actions: Array<InputMaybe<FormActionInputType>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  macroId: Scalars['ID']['input'];
  queuedMacroId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateMacro */
export type UpdateMacroPayload = {
  __typename?: 'UpdateMacroPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  macro: Maybe<Macro>;
};

/** Autogenerated input type of UpdateMedicalProfile */
export type UpdateMedicalProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  most_recent_physical_exam_at?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated input type of UpdatePolicyPreferences */
export type UpdatePolicyPreferencesInput = {
  age_of_youngest_child?: InputMaybe<Scalars['Int']['input']>;
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverage_amount?: InputMaybe<Scalars['Int']['input']>;
  employment_type?: InputMaybe<Scalars['String']['input']>;
  guaranteed_age?: InputMaybe<Scalars['Int']['input']>;
  individual_income?: InputMaybe<Scalars['Int']['input']>;
  issue_age?: InputMaybe<Scalars['Int']['input']>;
  number_of_children?: InputMaybe<Scalars['Int']['input']>;
  payment_mode?: InputMaybe<Scalars['String']['input']>;
  spousal_intent?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  triggered_from?: InputMaybe<Scalars['String']['input']>;
  underwriting_class?: InputMaybe<Scalars['String']['input']>;
  uses_tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateUserAttributesMutation */
export type UpdateUserAttributesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
  /** JSON-stringified value that will be parsed before being set */
  value_json: Scalars['String']['input'];
};

/** Autogenerated input type of UserBrokerUpdateMutation */
export type UserBrokerUpdateMutationInput = {
  broker_code?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customer_id: Scalars['ID']['input'];
};

export type UserProductAccessRoleMappingInput = {
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UsersProductAccessRolesUpdateMutation */
export type UsersProductAccessRolesUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  users_product_access_roles?: InputMaybe<Array<InputMaybe<UserProductAccessRoleMappingInput>>>;
};

export type VehicleCoverageInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  coverages?: InputMaybe<Array<InputMaybe<VehicleCoverageInput>>>;
  deductibles?: InputMaybe<Array<InputMaybe<VehicleCoverageInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  miles_driven_per_year?: InputMaybe<Scalars['Int']['input']>;
  new_purchase?: InputMaybe<Scalars['Boolean']['input']>;
  primary_driver_id?: InputMaybe<Scalars['ID']['input']>;
  primary_use?: InputMaybe<Scalars['String']['input']>;
  purchase_type?: InputMaybe<Scalars['String']['input']>;
  telematics?: InputMaybe<Scalars['Boolean']['input']>;
  use_for_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  use_for_rideshare?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_identification_number?: InputMaybe<Scalars['String']['input']>;
};

export type ViewCasesCount = {
  __typename?: 'ViewCasesCount';
  totalCount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use totalCount instead */
  total_count: Maybe<Scalars['Int']['output']>;
  viewId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use viewId instead */
  view_id: Maybe<Scalars['Int']['output']>;
};

/** Represents a view, stored in Marco */
export type Views = {
  __typename?: 'Views';
  favorited: Maybe<Scalars['Boolean']['output']>;
  favorited_at: Maybe<Scalars['DateTime']['output']>;
  favorited_id: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  options: Maybe<Scalars['String']['output']>;
  order_id: Maybe<Scalars['Int']['output']>;
  public: Maybe<Scalars['Boolean']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ViewsApplyMutation */
export type ViewsApplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  view_id: Scalars['ID']['input'];
};

/** Autogenerated input type of ViewsCreateMutation */
export type ViewsCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  options: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type ViewsReorderInputType = {
  favorited_id?: InputMaybe<Scalars['Int']['input']>;
  order_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of ViewsReorderMutation */
export type ViewsReorderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Array<InputMaybe<ViewsReorderInputType>>>;
};

/** Autogenerated input type of ViewsUnfavoriteMutation */
export type ViewsUnfavoriteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  view_id: Scalars['ID']['input'];
};

export type WithdrawalDetailsType = {
  __typename?: 'WithdrawalDetailsType';
  id: Maybe<Scalars['ID']['output']>;
  is_escalated: Maybe<Scalars['Boolean']['output']>;
  other_reason: Maybe<Scalars['String']['output']>;
  withdrawal_reasons: Maybe<Array<Maybe<WithdrawalReasonType>>>;
  withdrawal_type: Maybe<Scalars['String']['output']>;
};

export type WithdrawalReasonType = {
  __typename?: 'WithdrawalReasonType';
  id: Maybe<Scalars['Int']['output']>;
  reason_type: Maybe<Scalars['String']['output']>;
  selection: Maybe<Scalars['String']['output']>;
  selection_key: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of WithdrawalRequestCreateMutation */
export type WithdrawalRequestCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internal_case_id: Scalars['ID']['input'];
  is_escalated?: InputMaybe<Scalars['Boolean']['input']>;
  other_reason?: InputMaybe<Scalars['String']['input']>;
  withdrawal_reason_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  withdrawal_type?: InputMaybe<Scalars['String']['input']>;
};
